import SystemUtil from '../lib/SystemUtil'

module.exports =
  /******/
  (function (modules) { // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/
      if (installedModules[moduleId]) {
        /******/
        return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/
        i: moduleId,
        /******/
        l: false,
        /******/
        exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/
      if (!__webpack_require__.o(exports, name)) {
        /******/
        Object.defineProperty(exports, name, {
          /******/
          configurable: false,
          /******/
          enumerable: true,
          /******/
          get: getter
          /******/
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/
      var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = 495);
    /******/
  })
    /************************************************************************/
    /******/
    ({

      /***/
      1:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          /**
           * 事件网关
           */
          var EventBus = /** @class */ (function () {
            function EventBus() {
              this.eventListeners = {};
            }
            /**
             * 单例
             */
            EventBus.getInstance = function () {
              if (!EventBus.instance) {
                EventBus.instance = new EventBus();
              }
              return EventBus.instance;
            };
            EventBus.prototype.hasListener = function (evtName) {
              return this.eventListeners.hasOwnProperty(evtName) && this.eventListeners[evtName].length > 0;
            };
            /**
             * 事件注册
             */
            EventBus.prototype.addListener = function (evtName, listener) {
              var listeners;
              // 已注册
              if (this.eventListeners.hasOwnProperty(evtName)) {
                listeners = this.eventListeners[evtName];
              } else {
                listeners = [];
                this.eventListeners[evtName] = listeners;
              }
              listeners.push(listener);
            };
            /**
             * 移除监听器
             */
            EventBus.prototype.removeListener = function (evtName, listener) {
              if (!this.eventListeners.hasOwnProperty(evtName)) {
                console.warn("'" + evtName + " can't find'");
              }
              if (!listener) {
                delete this.eventListeners[evtName];
              }
              var listeners = this.eventListeners[evtName];
              if (!listeners) {
                return;
              }
              this.eventListeners[evtName] = listeners.filter(function (lis) {
                return lis !== listener;
              });
            };
            /**
             * 移除im监听器
             */
            EventBus.prototype.clearImListener = function () {
              for (var item in this.eventListeners) {
                if (item !== 'toast') {
                  delete this.eventListeners[item];
                }
              }
            };
            /**
             * 触发事件
             */
            EventBus.prototype.trigger = function (evtName) {
              var params = [];
              for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
              }
              var listeners = this.eventListeners[evtName];
              if (listeners && Object.prototype.toString.call(listeners) === '[object Array]') {
                listeners.forEach(function (listener) {
                  listener.call.apply(listener, [null].concat(params));
                });
              }
            };
            return EventBus;
          }());
          exports.default = EventBus.getInstance();


          /***/
        }),

      /***/
      10:
        /***/
        (function (module, exports, __webpack_require__) {

          var store = __webpack_require__(47)('wks');
          var uid = __webpack_require__(37);
          var Symbol = __webpack_require__(9).Symbol;
          var USE_SYMBOL = typeof Symbol == 'function';

          var $exports = module.exports = function (name) {
            return store[name] || (store[name] =
              USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
          };

          $exports.store = store;


          /***/
        }),

      /***/
      102:
        /***/
        (function (module, exports) {

          module.exports = function (it) {
            if (typeof it != 'function') throw TypeError(it + ' is not a function!');
            return it;
          };


          /***/
        }),

      /***/
      104:
        /***/
        (function (module, exports, __webpack_require__) {

          // false -> Array#indexOf
          // true  -> Array#includes
          var toIObject = __webpack_require__(19);
          var toLength = __webpack_require__(84);
          var toAbsoluteIndex = __webpack_require__(105);
          module.exports = function (IS_INCLUDES) {
            return function ($this, el, fromIndex) {
              var O = toIObject($this);
              var length = toLength(O.length);
              var index = toAbsoluteIndex(fromIndex, length);
              var value;
              // Array#includes uses SameValueZero equality algorithm
              // eslint-disable-next-line no-self-compare
              if (IS_INCLUDES && el != el)
                while (length > index) {
                  value = O[index++];
                  // eslint-disable-next-line no-self-compare
                  if (value != value) return true;
                  // Array#indexOf ignores holes, Array#includes - not
                } else
                for (; length > index; index++)
                  if (IS_INCLUDES || index in O) {
                    if (O[index] === el) return IS_INCLUDES || index || 0;
                  } return !IS_INCLUDES && -1;
            };
          };


          /***/
        }),

      /***/
      105:
        /***/
        (function (module, exports, __webpack_require__) {

          var toInteger = __webpack_require__(45);
          var max = Math.max;
          var min = Math.min;
          module.exports = function (index, length) {
            index = toInteger(index);
            return index < 0 ? max(index + length, 0) : min(index, length);
          };


          /***/
        }),

      /***/
      107:
        /***/
        (function (module, exports, __webpack_require__) {

          var Symbol = __webpack_require__(50);

          /** Used for built-in method references. */
          var objectProto = Object.prototype;

          /** Used to check objects for own properties. */
          var hasOwnProperty = objectProto.hasOwnProperty;

          /**
           * Used to resolve the
           * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
           * of values.
           */
          var nativeObjectToString = objectProto.toString;

          /** Built-in value references. */
          var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

          /**
           * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
           *
           * @private
           * @param {*} value The value to query.
           * @returns {string} Returns the raw `toStringTag`.
           */
          function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag),
              tag = value[symToStringTag];

            try {
              value[symToStringTag] = undefined;
              var unmasked = true;
            } catch (e) { }

            var result = nativeObjectToString.call(value);
            if (unmasked) {
              if (isOwn) {
                value[symToStringTag] = tag;
              } else {
                delete value[symToStringTag];
              }
            }
            return result;
          }

          module.exports = getRawTag;


          /***/
        }),

      /***/
      108:
        /***/
        (function (module, exports) {

          /** Used for built-in method references. */
          var objectProto = Object.prototype;

          /**
           * Used to resolve the
           * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
           * of values.
           */
          var nativeObjectToString = objectProto.toString;

          /**
           * Converts `value` to a string using `Object.prototype.toString`.
           *
           * @private
           * @param {*} value The value to convert.
           * @returns {string} Returns the converted string.
           */
          function objectToString(value) {
            return nativeObjectToString.call(value);
          }

          module.exports = objectToString;


          /***/
        }),

      /***/
      109:
        /***/
        (function (module, exports, __webpack_require__) {

          module.exports = {
            "default": __webpack_require__(110),
            __esModule: true
          };

          /***/
        }),

      /***/
      110:
        /***/
        (function (module, exports, __webpack_require__) {

          __webpack_require__(87);
          __webpack_require__(116);
          module.exports = __webpack_require__(54).f('iterator');


          /***/
        }),

      /***/
      111:
        /***/
        (function (module, exports, __webpack_require__) {

          var toInteger = __webpack_require__(45);
          var defined = __webpack_require__(44);
          // true  -> String#at
          // false -> String#codePointAt
          module.exports = function (TO_STRING) {
            return function (that, pos) {
              var s = String(defined(that));
              var i = toInteger(pos);
              var l = s.length;
              var a, b;
              if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
              a = s.charCodeAt(i);
              return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ?
                TO_STRING ? s.charAt(i) : a :
                TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
            };
          };


          /***/
        }),

      /***/
      112:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          var create = __webpack_require__(63);
          var descriptor = __webpack_require__(30);
          var setToStringTag = __webpack_require__(53);
          var IteratorPrototype = {};

          // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
          __webpack_require__(18)(IteratorPrototype, __webpack_require__(10)('iterator'), function () {
            return this;
          });

          module.exports = function (Constructor, NAME, next) {
            Constructor.prototype = create(IteratorPrototype, {
              next: descriptor(1, next)
            });
            setToStringTag(Constructor, NAME + ' Iterator');
          };


          /***/
        }),

      /***/
      113:
        /***/
        (function (module, exports, __webpack_require__) {

          var dP = __webpack_require__(12);
          var anObject = __webpack_require__(27);
          var getKeys = __webpack_require__(39);

          module.exports = __webpack_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
            anObject(O);
            var keys = getKeys(Properties);
            var length = keys.length;
            var i = 0;
            var P;
            while (length > i) dP.f(O, P = keys[i++], Properties[P]);
            return O;
          };


          /***/
        }),

      /***/
      114:
        /***/
        (function (module, exports, __webpack_require__) {

          var document = __webpack_require__(9).document;
          module.exports = document && document.documentElement;


          /***/
        }),

      /***/
      115:
        /***/
        (function (module, exports, __webpack_require__) {

          // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
          var has = __webpack_require__(13);
          var toObject = __webpack_require__(73);
          var IE_PROTO = __webpack_require__(46)('IE_PROTO');
          var ObjectProto = Object.prototype;

          module.exports = Object.getPrototypeOf || function (O) {
            O = toObject(O);
            if (has(O, IE_PROTO)) return O[IE_PROTO];
            if (typeof O.constructor == 'function' && O instanceof O.constructor) {
              return O.constructor.prototype;
            }
            return O instanceof Object ? ObjectProto : null;
          };


          /***/
        }),

      /***/
      116:
        /***/
        (function (module, exports, __webpack_require__) {

          __webpack_require__(117);
          var global = __webpack_require__(9);
          var hide = __webpack_require__(18);
          var Iterators = __webpack_require__(38);
          var TO_STRING_TAG = __webpack_require__(10)('toStringTag');

          var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
            'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
            'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
            'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
            'TextTrackList,TouchList').split(',');

          for (var i = 0; i < DOMIterables.length; i++) {
            var NAME = DOMIterables[i];
            var Collection = global[NAME];
            var proto = Collection && Collection.prototype;
            if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
            Iterators[NAME] = Iterators.Array;
          }


          /***/
        }),

      /***/
      117:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          var addToUnscopables = __webpack_require__(118);
          var step = __webpack_require__(119);
          var Iterators = __webpack_require__(38);
          var toIObject = __webpack_require__(19);

          // 22.1.3.4 Array.prototype.entries()
          // 22.1.3.13 Array.prototype.keys()
          // 22.1.3.29 Array.prototype.values()
          // 22.1.3.30 Array.prototype[@@iterator]()
          module.exports = __webpack_require__(76)(Array, 'Array', function (iterated, kind) {
            this._t = toIObject(iterated); // target
            this._i = 0; // next index
            this._k = kind; // kind
            // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
          }, function () {
            var O = this._t;
            var kind = this._k;
            var index = this._i++;
            if (!O || index >= O.length) {
              this._t = undefined;
              return step(1);
            }
            if (kind == 'keys') return step(0, index);
            if (kind == 'values') return step(0, O[index]);
            return step(0, [index, O[index]]);
          }, 'values');

          // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
          Iterators.Arguments = Iterators.Array;

          addToUnscopables('keys');
          addToUnscopables('values');
          addToUnscopables('entries');


          /***/
        }),

      /***/
      118:
        /***/
        (function (module, exports) {

          module.exports = function () {
            /* empty */
          };


          /***/
        }),

      /***/
      119:
        /***/
        (function (module, exports) {

          module.exports = function (done, value) {
            return {
              value: value,
              done: !!done
            };
          };


          /***/
        }),

      /***/
      12:
        /***/
        (function (module, exports, __webpack_require__) {

          var anObject = __webpack_require__(27);
          var IE8_DOM_DEFINE = __webpack_require__(70);
          var toPrimitive = __webpack_require__(43);
          var dP = Object.defineProperty;

          exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPrimitive(P, true);
            anObject(Attributes);
            if (IE8_DOM_DEFINE) try {
              return dP(O, P, Attributes);
            } catch (e) {
              /* empty */
            }
            if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
            if ('value' in Attributes) O[P] = Attributes.value;
            return O;
          };


          /***/
        }),

      /***/
      120:
        /***/
        (function (module, exports, __webpack_require__) {

          module.exports = {
            "default": __webpack_require__(121),
            __esModule: true
          };

          /***/
        }),

      /***/
      121:
        /***/
        (function (module, exports, __webpack_require__) {

          __webpack_require__(122);
          __webpack_require__(127);
          __webpack_require__(128);
          __webpack_require__(129);
          module.exports = __webpack_require__(17).Symbol;


          /***/
        }),

      /***/
      122:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          // ECMAScript 6 symbols shim
          var global = __webpack_require__(9);
          var has = __webpack_require__(13);
          var DESCRIPTORS = __webpack_require__(15);
          var $export = __webpack_require__(28);
          var redefine = __webpack_require__(77);
          var META = __webpack_require__(123).KEY;
          var $fails = __webpack_require__(29);
          var shared = __webpack_require__(47);
          var setToStringTag = __webpack_require__(53);
          var uid = __webpack_require__(37);
          var wks = __webpack_require__(10);
          var wksExt = __webpack_require__(54);
          var wksDefine = __webpack_require__(55);
          var enumKeys = __webpack_require__(124);
          var isArray = __webpack_require__(125);
          var anObject = __webpack_require__(27);
          var isObject = __webpack_require__(21);
          var toIObject = __webpack_require__(19);
          var toPrimitive = __webpack_require__(43);
          var createDesc = __webpack_require__(30);
          var _create = __webpack_require__(63);
          var gOPNExt = __webpack_require__(126);
          var $GOPD = __webpack_require__(88);
          var $DP = __webpack_require__(12);
          var $keys = __webpack_require__(39);
          var gOPD = $GOPD.f;
          var dP = $DP.f;
          var gOPN = gOPNExt.f;
          var $Symbol = global.Symbol;
          var $JSON = global.JSON;
          var _stringify = $JSON && $JSON.stringify;
          var PROTOTYPE = 'prototype';
          var HIDDEN = wks('_hidden');
          var TO_PRIMITIVE = wks('toPrimitive');
          var isEnum = {}.propertyIsEnumerable;
          var SymbolRegistry = shared('symbol-registry');
          var AllSymbols = shared('symbols');
          var OPSymbols = shared('op-symbols');
          var ObjectProto = Object[PROTOTYPE];
          var USE_NATIVE = typeof $Symbol == 'function';
          var QObject = global.QObject;
          // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
          var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

          // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
          var setSymbolDesc = DESCRIPTORS && $fails(function () {
            return _create(dP({}, 'a', {
              get: function () {
                return dP(this, 'a', {
                  value: 7
                }).a;
              }
            })).a != 7;
          }) ? function (it, key, D) {
            var protoDesc = gOPD(ObjectProto, key);
            if (protoDesc) delete ObjectProto[key];
            dP(it, key, D);
            if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
          } : dP;

          var wrap = function (tag) {
            var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
            sym._k = tag;
            return sym;
          };

          var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
            return typeof it == 'symbol';
          } : function (it) {
            return it instanceof $Symbol;
          };

          var $defineProperty = function defineProperty(it, key, D) {
            if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
            anObject(it);
            key = toPrimitive(key, true);
            anObject(D);
            if (has(AllSymbols, key)) {
              if (!D.enumerable) {
                if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
                it[HIDDEN][key] = true;
              } else {
                if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
                D = _create(D, {
                  enumerable: createDesc(0, false)
                });
              }
              return setSymbolDesc(it, key, D);
            }
            return dP(it, key, D);
          };
          var $defineProperties = function defineProperties(it, P) {
            anObject(it);
            var keys = enumKeys(P = toIObject(P));
            var i = 0;
            var l = keys.length;
            var key;
            while (l > i) $defineProperty(it, key = keys[i++], P[key]);
            return it;
          };
          var $create = function create(it, P) {
            return P === undefined ? _create(it) : $defineProperties(_create(it), P);
          };
          var $propertyIsEnumerable = function propertyIsEnumerable(key) {
            var E = isEnum.call(this, key = toPrimitive(key, true));
            if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
            return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
          };
          var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
            it = toIObject(it);
            key = toPrimitive(key, true);
            if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
            var D = gOPD(it, key);
            if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
            return D;
          };
          var $getOwnPropertyNames = function getOwnPropertyNames(it) {
            var names = gOPN(toIObject(it));
            var result = [];
            var i = 0;
            var key;
            while (names.length > i) {
              if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
            }
            return result;
          };
          var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
            var IS_OP = it === ObjectProto;
            var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
            var result = [];
            var i = 0;
            var key;
            while (names.length > i) {
              if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
            }
            return result;
          };

          // 19.4.1.1 Symbol([description])
          if (!USE_NATIVE) {
            $Symbol = function Symbol() {
              if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
              var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
              var $set = function (value) {
                if (this === ObjectProto) $set.call(OPSymbols, value);
                if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                setSymbolDesc(this, tag, createDesc(1, value));
              };
              if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
                configurable: true,
                set: $set
              });
              return wrap(tag);
            };
            redefine($Symbol[PROTOTYPE], 'toString', function toString() {
              return this._k;
            });

            $GOPD.f = $getOwnPropertyDescriptor;
            $DP.f = $defineProperty;
            __webpack_require__(78).f = gOPNExt.f = $getOwnPropertyNames;
            __webpack_require__(40).f = $propertyIsEnumerable;
            __webpack_require__(61).f = $getOwnPropertySymbols;

            if (DESCRIPTORS && !__webpack_require__(52)) {
              redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
            }

            wksExt.f = function (name) {
              return wrap(wks(name));
            };
          }

          $export($export.G + $export.W + $export.F * !USE_NATIVE, {
            Symbol: $Symbol
          });

          for (var es6Symbols = (
            // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
            'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
          ).split(','), j = 0; es6Symbols.length > j;) wks(es6Symbols[j++]);

          for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

          $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
            // 19.4.2.1 Symbol.for(key)
            'for': function (key) {
              return has(SymbolRegistry, key += '') ?
                SymbolRegistry[key] :
                SymbolRegistry[key] = $Symbol(key);
            },
            // 19.4.2.5 Symbol.keyFor(sym)
            keyFor: function keyFor(sym) {
              if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
              for (var key in SymbolRegistry)
                if (SymbolRegistry[key] === sym) return key;
            },
            useSetter: function () {
              setter = true;
            },
            useSimple: function () {
              setter = false;
            }
          });

          $export($export.S + $export.F * !USE_NATIVE, 'Object', {
            // 19.1.2.2 Object.create(O [, Properties])
            create: $create,
            // 19.1.2.4 Object.defineProperty(O, P, Attributes)
            defineProperty: $defineProperty,
            // 19.1.2.3 Object.defineProperties(O, Properties)
            defineProperties: $defineProperties,
            // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
            getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
            // 19.1.2.7 Object.getOwnPropertyNames(O)
            getOwnPropertyNames: $getOwnPropertyNames,
            // 19.1.2.8 Object.getOwnPropertySymbols(O)
            getOwnPropertySymbols: $getOwnPropertySymbols
          });

          // 24.3.2 JSON.stringify(value [, replacer [, space]])
          $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
            var S = $Symbol();
            // MS Edge converts symbol values to JSON as {}
            // WebKit converts symbol values to JSON as null
            // V8 throws on boxed symbols
            return _stringify([S]) != '[null]' || _stringify({
              a: S
            }) != '{}' || _stringify(Object(S)) != '{}';
          })), 'JSON', {
            stringify: function stringify(it) {
              var args = [it];
              var i = 1;
              var replacer, $replacer;
              while (arguments.length > i) args.push(arguments[i++]);
              $replacer = replacer = args[1];
              if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
              if (!isArray(replacer)) replacer = function (key, value) {
                if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
                if (!isSymbol(value)) return value;
              };
              args[1] = replacer;
              return _stringify.apply($JSON, args);
            }
          });

          // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
          $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(18)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
          // 19.4.3.5 Symbol.prototype[@@toStringTag]
          setToStringTag($Symbol, 'Symbol');
          // 20.2.1.9 Math[@@toStringTag]
          setToStringTag(Math, 'Math', true);
          // 24.3.3 JSON[@@toStringTag]
          setToStringTag(global.JSON, 'JSON', true);


          /***/
        }),

      /***/
      123:
        /***/
        (function (module, exports, __webpack_require__) {

          var META = __webpack_require__(37)('meta');
          var isObject = __webpack_require__(21);
          var has = __webpack_require__(13);
          var setDesc = __webpack_require__(12).f;
          var id = 0;
          var isExtensible = Object.isExtensible || function () {
            return true;
          };
          var FREEZE = !__webpack_require__(29)(function () {
            return isExtensible(Object.preventExtensions({}));
          });
          var setMeta = function (it) {
            setDesc(it, META, {
              value: {
                i: 'O' + ++id, // object ID
                w: {} // weak collections IDs
              }
            });
          };
          var fastKey = function (it, create) {
            // return primitive with prefix
            if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
            if (!has(it, META)) {
              // can't set metadata to uncaught frozen object
              if (!isExtensible(it)) return 'F';
              // not necessary to add metadata
              if (!create) return 'E';
              // add missing metadata
              setMeta(it);
              // return object ID
            }
            return it[META].i;
          };
          var getWeak = function (it, create) {
            if (!has(it, META)) {
              // can't set metadata to uncaught frozen object
              if (!isExtensible(it)) return true;
              // not necessary to add metadata
              if (!create) return false;
              // add missing metadata
              setMeta(it);
              // return hash weak collections IDs
            }
            return it[META].w;
          };
          // add metadata on freeze-family methods calling
          var onFreeze = function (it) {
            if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
            return it;
          };
          var meta = module.exports = {
            KEY: META,
            NEED: false,
            fastKey: fastKey,
            getWeak: getWeak,
            onFreeze: onFreeze
          };


          /***/
        }),

      /***/
      124:
        /***/
        (function (module, exports, __webpack_require__) {

          // all enumerable object keys, includes symbols
          var getKeys = __webpack_require__(39);
          var gOPS = __webpack_require__(61);
          var pIE = __webpack_require__(40);
          module.exports = function (it) {
            var result = getKeys(it);
            var getSymbols = gOPS.f;
            if (getSymbols) {
              var symbols = getSymbols(it);
              var isEnum = pIE.f;
              var i = 0;
              var key;
              while (symbols.length > i)
                if (isEnum.call(it, key = symbols[i++])) result.push(key);
            }
            return result;
          };


          /***/
        }),

      /***/
      125:
        /***/
        (function (module, exports, __webpack_require__) {

          // 7.2.2 IsArray(argument)
          var cof = __webpack_require__(60);
          module.exports = Array.isArray || function isArray(arg) {
            return cof(arg) == 'Array';
          };


          /***/
        }),

      /***/
      126:
        /***/
        (function (module, exports, __webpack_require__) {

          // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
          var toIObject = __webpack_require__(19);
          var gOPN = __webpack_require__(78).f;
          var toString = {}.toString;

          var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ?
            Object.getOwnPropertyNames(window) : [];

          var getWindowNames = function (it) {
            try {
              return gOPN(it);
            } catch (e) {
              return windowNames.slice();
            }
          };

          module.exports.f = function getOwnPropertyNames(it) {
            return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
          };


          /***/
        }),

      /***/
      127:
        /***/
        (function (module, exports) {



          /***/
        }),

      /***/
      128:
        /***/
        (function (module, exports, __webpack_require__) {

          __webpack_require__(55)('asyncIterator');


          /***/
        }),

      /***/
      129:
        /***/
        (function (module, exports, __webpack_require__) {

          __webpack_require__(55)('observable');


          /***/
        }),

      /***/
      13:
        /***/
        (function (module, exports) {

          var hasOwnProperty = {}.hasOwnProperty;
          module.exports = function (it, key) {
            return hasOwnProperty.call(it, key);
          };


          /***/
        }),

      /***/
      136:
        /***/
        (function (module, exports, __webpack_require__) {

          var toString = __webpack_require__(137);

          /** Used to generate unique IDs. */
          var idCounter = 0;

          /**
           * Generates a unique ID. If `prefix` is given, the ID is appended to it.
           *
           * @static
           * @since 0.1.0
           * @memberOf _
           * @category Util
           * @param {string} [prefix=''] The value to prefix the ID with.
           * @returns {string} Returns the unique ID.
           * @example
           *
           * _.uniqueId('contact_');
           * // => 'contact_104'
           *
           * _.uniqueId();
           * // => '105'
           */
          function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
          }

          module.exports = uniqueId;


          /***/
        }),

      /***/
      137:
        /***/
        (function (module, exports, __webpack_require__) {

          var baseToString = __webpack_require__(138);

          /**
           * Converts `value` to a string. An empty string is returned for `null`
           * and `undefined` values. The sign of `-0` is preserved.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to convert.
           * @returns {string} Returns the converted string.
           * @example
           *
           * _.toString(null);
           * // => ''
           *
           * _.toString(-0);
           * // => '-0'
           *
           * _.toString([1, 2, 3]);
           * // => '1,2,3'
           */
          function toString(value) {
            return value == null ? '' : baseToString(value);
          }

          module.exports = toString;


          /***/
        }),

      /***/
      138:
        /***/
        (function (module, exports, __webpack_require__) {

          var Symbol = __webpack_require__(50),
            arrayMap = __webpack_require__(139),
            isArray = __webpack_require__(86),
            isSymbol = __webpack_require__(140);

          /** Used as references for various `Number` constants. */
          var INFINITY = 1 / 0;

          /** Used to convert symbols to primitives and strings. */
          var symbolProto = Symbol ? Symbol.prototype : undefined,
            symbolToString = symbolProto ? symbolProto.toString : undefined;

          /**
           * The base implementation of `_.toString` which doesn't convert nullish
           * values to empty strings.
           *
           * @private
           * @param {*} value The value to process.
           * @returns {string} Returns the string.
           */
          function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') {
              return value;
            }
            if (isArray(value)) {
              // Recursively convert values (susceptible to call stack limits).
              return arrayMap(value, baseToString) + '';
            }
            if (isSymbol(value)) {
              return symbolToString ? symbolToString.call(value) : '';
            }
            var result = (value + '');
            return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
          }

          module.exports = baseToString;


          /***/
        }),

      /***/
      139:
        /***/
        (function (module, exports) {

          /**
           * A specialized version of `_.map` for arrays without support for iteratee
           * shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @returns {Array} Returns the new mapped array.
           */
          function arrayMap(array, iteratee) {
            var index = -1,
              length = array == null ? 0 : array.length,
              result = Array(length);

            while (++index < length) {
              result[index] = iteratee(array[index], index, array);
            }
            return result;
          }

          module.exports = arrayMap;


          /***/
        }),

      /***/
      140:
        /***/
        (function (module, exports, __webpack_require__) {

          var baseGetTag = __webpack_require__(49),
            isObjectLike = __webpack_require__(62);

          /** `Object#toString` result references. */
          var symbolTag = '[object Symbol]';

          /**
           * Checks if `value` is classified as a `Symbol` primitive or object.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
           * @example
           *
           * _.isSymbol(Symbol.iterator);
           * // => true
           *
           * _.isSymbol('abc');
           * // => false
           */
          function isSymbol(value) {
            return typeof value == 'symbol' ||
              (isObjectLike(value) && baseGetTag(value) == symbolTag);
          }

          module.exports = isSymbol;


          /***/
        }),

      /***/
      15:
        /***/
        (function (module, exports, __webpack_require__) {

          // Thank's IE8 for his funny defineProperty
          module.exports = !__webpack_require__(29)(function () {
            return Object.defineProperty({}, 'a', {
              get: function () {
                return 7;
              }
            }).a != 7;
          });


          /***/
        }),

      /***/
      17:
        /***/
        (function (module, exports) {

          var core = module.exports = {
            version: '2.5.3'
          };
          if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


          /***/
        }),

      /***/
      18:
        /***/
        (function (module, exports, __webpack_require__) {

          var dP = __webpack_require__(12);
          var createDesc = __webpack_require__(30);
          module.exports = __webpack_require__(15) ? function (object, key, value) {
            return dP.f(object, key, createDesc(1, value));
          } : function (object, key, value) {
            object[key] = value;
            return object;
          };


          /***/
        }),

      /***/
      189:
        /***/
        (function (module, exports) {

          /*
           * DOM Level 2
           * Object DOMException
           * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
           * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
           */

          function copy(src, dest) {
            for (var p in src) {
              dest[p] = src[p];
            }
          }
          /**
          ^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
          ^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
           */
          function _extends(Class, Super) {
            var pt = Class.prototype;
            if (Object.create) {
              var ppt = Object.create(Super.prototype)
              pt.__proto__ = ppt;
            }
            if (!(pt instanceof Super)) {
              function t() { };
              t.prototype = Super.prototype;
              t = new t();
              copy(pt, t);
              Class.prototype = pt = t;
            }
            if (pt.constructor != Class) {
              if (typeof Class != 'function') {
                console.error("unknow Class:" + Class)
              }
              pt.constructor = Class
            }
          }
          var htmlns = 'http://www.w3.org/1999/xhtml';
          // Node Types
          var NodeType = {}
          var ELEMENT_NODE = NodeType.ELEMENT_NODE = 1;
          var ATTRIBUTE_NODE = NodeType.ATTRIBUTE_NODE = 2;
          var TEXT_NODE = NodeType.TEXT_NODE = 3;
          var CDATA_SECTION_NODE = NodeType.CDATA_SECTION_NODE = 4;
          var ENTITY_REFERENCE_NODE = NodeType.ENTITY_REFERENCE_NODE = 5;
          var ENTITY_NODE = NodeType.ENTITY_NODE = 6;
          var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
          var COMMENT_NODE = NodeType.COMMENT_NODE = 8;
          var DOCUMENT_NODE = NodeType.DOCUMENT_NODE = 9;
          var DOCUMENT_TYPE_NODE = NodeType.DOCUMENT_TYPE_NODE = 10;
          var DOCUMENT_FRAGMENT_NODE = NodeType.DOCUMENT_FRAGMENT_NODE = 11;
          var NOTATION_NODE = NodeType.NOTATION_NODE = 12;

          // ExceptionCode
          var ExceptionCode = {}
          var ExceptionMessage = {};
          var INDEX_SIZE_ERR = ExceptionCode.INDEX_SIZE_ERR = ((ExceptionMessage[1] = "Index size error"), 1);
          var DOMSTRING_SIZE_ERR = ExceptionCode.DOMSTRING_SIZE_ERR = ((ExceptionMessage[2] = "DOMString size error"), 2);
          var HIERARCHY_REQUEST_ERR = ExceptionCode.HIERARCHY_REQUEST_ERR = ((ExceptionMessage[3] = "Hierarchy request error"), 3);
          var WRONG_DOCUMENT_ERR = ExceptionCode.WRONG_DOCUMENT_ERR = ((ExceptionMessage[4] = "Wrong document"), 4);
          var INVALID_CHARACTER_ERR = ExceptionCode.INVALID_CHARACTER_ERR = ((ExceptionMessage[5] = "Invalid character"), 5);
          var NO_DATA_ALLOWED_ERR = ExceptionCode.NO_DATA_ALLOWED_ERR = ((ExceptionMessage[6] = "No data allowed"), 6);
          var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ((ExceptionMessage[7] = "No modification allowed"), 7);
          var NOT_FOUND_ERR = ExceptionCode.NOT_FOUND_ERR = ((ExceptionMessage[8] = "Not found"), 8);
          var NOT_SUPPORTED_ERR = ExceptionCode.NOT_SUPPORTED_ERR = ((ExceptionMessage[9] = "Not supported"), 9);
          var INUSE_ATTRIBUTE_ERR = ExceptionCode.INUSE_ATTRIBUTE_ERR = ((ExceptionMessage[10] = "Attribute in use"), 10);
          //level2
          var INVALID_STATE_ERR = ExceptionCode.INVALID_STATE_ERR = ((ExceptionMessage[11] = "Invalid state"), 11);
          var SYNTAX_ERR = ExceptionCode.SYNTAX_ERR = ((ExceptionMessage[12] = "Syntax error"), 12);
          var INVALID_MODIFICATION_ERR = ExceptionCode.INVALID_MODIFICATION_ERR = ((ExceptionMessage[13] = "Invalid modification"), 13);
          var NAMESPACE_ERR = ExceptionCode.NAMESPACE_ERR = ((ExceptionMessage[14] = "Invalid namespace"), 14);
          var INVALID_ACCESS_ERR = ExceptionCode.INVALID_ACCESS_ERR = ((ExceptionMessage[15] = "Invalid access"), 15);


          function DOMException(code, message) {
            if (message instanceof Error) {
              var error = message;
            } else {
              error = this;
              Error.call(this, ExceptionMessage[code]);
              this.message = ExceptionMessage[code];
              if (Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
            }
            error.code = code;
            if (message) this.message = this.message + ": " + message;
            return error;
          };
          DOMException.prototype = Error.prototype;
          copy(ExceptionCode, DOMException)
          /**
           * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
           * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
           * The items in the NodeList are accessible via an integral index, starting from 0.
           */
          function NodeList() { };
          NodeList.prototype = {
            /**
             * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
             * @standard level1
             */
            length: 0,
            /**
             * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
             * @standard level1
             * @param index  unsigned long
             *   Index into the collection.
             * @return Node
             * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
             */
            item: function (index) {
              return this[index] || null;
            },
            toString: function (isHTML, nodeFilter) {
              for (var buf = [], i = 0; i < this.length; i++) {
                serializeToString(this[i], buf, isHTML, nodeFilter);
              }
              return buf.join('');
            }
          };

          function LiveNodeList(node, refresh) {
            this._node = node;
            this._refresh = refresh
            _updateLiveList(this);
          }

          function _updateLiveList(list) {
            var inc = list._node._inc || list._node.ownerDocument._inc;
            if (list._inc != inc) {
              var ls = list._refresh(list._node);
              //console.log(ls.length)
              __set__(list, 'length', ls.length);
              copy(ls, list);
              list._inc = inc;
            }
          }
          LiveNodeList.prototype.item = function (i) {
            _updateLiveList(this);
            return this[i];
          }

          _extends(LiveNodeList, NodeList);
          /**
           *
           * Objects implementing the NamedNodeMap interface are used to represent collections of nodes that can be accessed by name. Note that NamedNodeMap does not inherit from NodeList; NamedNodeMaps are not maintained in any particular order. Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index, but this is simply to allow convenient enumeration of the contents of a NamedNodeMap, and does not imply that the DOM specifies an order to these Nodes.
           * NamedNodeMap objects in the DOM are live.
           * used for attributes or DocumentType entities
           */
          function NamedNodeMap() { };

          function _findNodeIndex(list, node) {
            var i = list.length;
            while (i--) {
              if (list[i] === node) {
                return i
              }
            }
          }

          function _addNamedNode(el, list, newAttr, oldAttr) {
            if (oldAttr) {
              list[_findNodeIndex(list, oldAttr)] = newAttr;
            } else {
              list[list.length++] = newAttr;
            }
            if (el) {
              newAttr.ownerElement = el;
              var doc = el.ownerDocument;
              if (doc) {
                oldAttr && _onRemoveAttribute(doc, el, oldAttr);
                _onAddAttribute(doc, el, newAttr);
              }
            }
          }

          function _removeNamedNode(el, list, attr) {
            //console.log('remove attr:'+attr)
            var i = _findNodeIndex(list, attr);
            if (i >= 0) {
              var lastIndex = list.length - 1
              while (i < lastIndex) {
                list[i] = list[++i]
              }
              list.length = lastIndex;
              if (el) {
                var doc = el.ownerDocument;
                if (doc) {
                  _onRemoveAttribute(doc, el, attr);
                  attr.ownerElement = null;
                }
              }
            } else {
              throw DOMException(NOT_FOUND_ERR, new Error(el.tagName + '@' + attr))
            }
          }
          NamedNodeMap.prototype = {
            length: 0,
            item: NodeList.prototype.item,
            getNamedItem: function (key) {
              //		if(key.indexOf(':')>0 || key == 'xmlns'){
              //			return null;
              //		}
              //console.log()
              var i = this.length;
              while (i--) {
                var attr = this[i];
                //console.log(attr.nodeName,key)
                if (attr.nodeName == key) {
                  return attr;
                }
              }
            },
            setNamedItem: function (attr) {
              var el = attr.ownerElement;
              if (el && el != this._ownerElement) {
                throw new DOMException(INUSE_ATTRIBUTE_ERR);
              }
              var oldAttr = this.getNamedItem(attr.nodeName);
              _addNamedNode(this._ownerElement, this, attr, oldAttr);
              return oldAttr;
            },
            /* returns Node */
            setNamedItemNS: function (attr) { // raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
              var el = attr.ownerElement,
                oldAttr;
              if (el && el != this._ownerElement) {
                throw new DOMException(INUSE_ATTRIBUTE_ERR);
              }
              oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
              _addNamedNode(this._ownerElement, this, attr, oldAttr);
              return oldAttr;
            },

            /* returns Node */
            removeNamedItem: function (key) {
              var attr = this.getNamedItem(key);
              _removeNamedNode(this._ownerElement, this, attr);
              return attr;


            }, // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR

            //for level2
            removeNamedItemNS: function (namespaceURI, localName) {
              var attr = this.getNamedItemNS(namespaceURI, localName);
              _removeNamedNode(this._ownerElement, this, attr);
              return attr;
            },
            getNamedItemNS: function (namespaceURI, localName) {
              var i = this.length;
              while (i--) {
                var node = this[i];
                if (node.localName == localName && node.namespaceURI == namespaceURI) {
                  return node;
                }
              }
              return null;
            }
          };
          /**
           * @see http://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490
           */
          function DOMImplementation( /* Object */ features) {
            this._features = {};
            if (features) {
              for (var feature in features) {
                this._features = features[feature];
              }
            }
          };

          DOMImplementation.prototype = {
            hasFeature: function ( /* string */ feature, /* string */ version) {
              var versions = this._features[feature.toLowerCase()];
              if (versions && (!version || version in versions)) {
                return true;
              } else {
                return false;
              }
            },
            // Introduced in DOM Level 2:
            createDocument: function (namespaceURI, qualifiedName, doctype) { // raises:INVALID_CHARACTER_ERR,NAMESPACE_ERR,WRONG_DOCUMENT_ERR
              var doc = new Document();
              doc.implementation = this;
              doc.childNodes = new NodeList();
              doc.doctype = doctype;
              if (doctype) {
                doc.appendChild(doctype);
              }
              if (qualifiedName) {
                var root = doc.createElementNS(namespaceURI, qualifiedName);
                doc.appendChild(root);
              }
              return doc;
            },
            // Introduced in DOM Level 2:
            createDocumentType: function (qualifiedName, publicId, systemId) { // raises:INVALID_CHARACTER_ERR,NAMESPACE_ERR
              var node = new DocumentType();
              node.name = qualifiedName;
              node.nodeName = qualifiedName;
              node.publicId = publicId;
              node.systemId = systemId;
              // Introduced in DOM Level 2:
              //readonly attribute DOMString        internalSubset;

              //TODO:..
              //  readonly attribute NamedNodeMap     entities;
              //  readonly attribute NamedNodeMap     notations;
              return node;
            }
          };


          /**
           * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
           */

          function Node() { };

          Node.prototype = {
            firstChild: null,
            lastChild: null,
            previousSibling: null,
            nextSibling: null,
            attributes: null,
            parentNode: null,
            childNodes: null,
            ownerDocument: null,
            nodeValue: null,
            namespaceURI: null,
            prefix: null,
            localName: null,
            // Modified in DOM Level 2:
            insertBefore: function (newChild, refChild) { //raises
              return _insertBefore(this, newChild, refChild);
            },
            replaceChild: function (newChild, oldChild) { //raises
              this.insertBefore(newChild, oldChild);
              if (oldChild) {
                this.removeChild(oldChild);
              }
            },
            removeChild: function (oldChild) {
              return _removeChild(this, oldChild);
            },
            appendChild: function (newChild) {
              return this.insertBefore(newChild, null);
            },
            hasChildNodes: function () {
              return this.firstChild != null;
            },
            cloneNode: function (deep) {
              return cloneNode(this.ownerDocument || this, this, deep);
            },
            // Modified in DOM Level 2:
            normalize: function () {
              var child = this.firstChild;
              while (child) {
                var next = child.nextSibling;
                if (next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE) {
                  this.removeChild(next);
                  child.appendData(next.data);
                } else {
                  child.normalize();
                  child = next;
                }
              }
            },
            // Introduced in DOM Level 2:
            isSupported: function (feature, version) {
              return this.ownerDocument.implementation.hasFeature(feature, version);
            },
            // Introduced in DOM Level 2:
            hasAttributes: function () {
              return this.attributes.length > 0;
            },
            lookupPrefix: function (namespaceURI) {
              var el = this;
              while (el) {
                var map = el._nsMap;
                //console.dir(map)
                if (map) {
                  for (var n in map) {
                    if (map[n] == namespaceURI) {
                      return n;
                    }
                  }
                }
                el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
              }
              return null;
            },
            // Introduced in DOM Level 3:
            lookupNamespaceURI: function (prefix) {
              var el = this;
              while (el) {
                var map = el._nsMap;
                //console.dir(map)
                if (map) {
                  if (prefix in map) {
                    return map[prefix];
                  }
                }
                el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
              }
              return null;
            },
            // Introduced in DOM Level 3:
            isDefaultNamespace: function (namespaceURI) {
              var prefix = this.lookupPrefix(namespaceURI);
              return prefix == null;
            }
          };


          function _xmlEncoder(c) {
            return c == '<' && '&lt;' ||
              c == '>' && '&gt;' ||
              c == '&' && '&amp;' ||
              c == '"' && '&quot;' ||
              '&#' + c.charCodeAt() + ';'
          }


          copy(NodeType, Node);
          copy(NodeType, Node.prototype);

          /**
           * @param callback return true for continue,false for break
           * @return boolean true: break visit;
           */
          function _visitNode(node, callback) {
            if (callback(node)) {
              return true;
            }
            if (node = node.firstChild) {
              do {
                if (_visitNode(node, callback)) {
                  return true
                }
              } while (node = node.nextSibling)
            }
          }



          function Document() { }

          function _onAddAttribute(doc, el, newAttr) {
            doc && doc._inc++;
            var ns = newAttr.namespaceURI;
            if (ns == 'http://www.w3.org/2000/xmlns/') {
              //update namespace
              el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value
            }
          }

          function _onRemoveAttribute(doc, el, newAttr, remove) {
            doc && doc._inc++;
            var ns = newAttr.namespaceURI;
            if (ns == 'http://www.w3.org/2000/xmlns/') {
              //update namespace
              delete el._nsMap[newAttr.prefix ? newAttr.localName : '']
            }
          }

          function _onUpdateChild(doc, el, newChild) {
            if (doc && doc._inc) {
              doc._inc++;
              //update childNodes
              var cs = el.childNodes;
              if (newChild) {
                cs[cs.length++] = newChild;
              } else {
                //console.log(1)
                var child = el.firstChild;
                var i = 0;
                while (child) {
                  cs[i++] = child;
                  child = child.nextSibling;
                }
                cs.length = i;
              }
            }
          }

          /**
           * attributes;
           * children;
           *
           * writeable properties:
           * nodeValue,Attr:value,CharacterData:data
           * prefix
           */
          function _removeChild(parentNode, child) {
            var previous = child.previousSibling;
            var next = child.nextSibling;
            if (previous) {
              previous.nextSibling = next;
            } else {
              parentNode.firstChild = next
            }
            if (next) {
              next.previousSibling = previous;
            } else {
              parentNode.lastChild = previous;
            }
            _onUpdateChild(parentNode.ownerDocument, parentNode);
            return child;
          }
          /**
           * preformance key(refChild == null)
           */
          function _insertBefore(parentNode, newChild, nextChild) {
            var cp = newChild.parentNode;
            if (cp) {
              cp.removeChild(newChild); //remove and update
            }
            if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
              var newFirst = newChild.firstChild;
              if (newFirst == null) {
                return newChild;
              }
              var newLast = newChild.lastChild;
            } else {
              newFirst = newLast = newChild;
            }
            var pre = nextChild ? nextChild.previousSibling : parentNode.lastChild;

            newFirst.previousSibling = pre;
            newLast.nextSibling = nextChild;


            if (pre) {
              pre.nextSibling = newFirst;
            } else {
              parentNode.firstChild = newFirst;
            }
            if (nextChild == null) {
              parentNode.lastChild = newLast;
            } else {
              nextChild.previousSibling = newLast;
            }
            do {
              newFirst.parentNode = parentNode;
            } while (newFirst !== newLast && (newFirst = newFirst.nextSibling))
            _onUpdateChild(parentNode.ownerDocument || parentNode, parentNode);
            //console.log(parentNode.lastChild.nextSibling == null)
            if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
              newChild.firstChild = newChild.lastChild = null;
            }
            return newChild;
          }

          function _appendSingleChild(parentNode, newChild) {
            var cp = newChild.parentNode;
            if (cp) {
              var pre = parentNode.lastChild;
              cp.removeChild(newChild); //remove and update
              var pre = parentNode.lastChild;
            }
            var pre = parentNode.lastChild;
            newChild.parentNode = parentNode;
            newChild.previousSibling = pre;
            newChild.nextSibling = null;
            if (pre) {
              pre.nextSibling = newChild;
            } else {
              parentNode.firstChild = newChild;
            }
            parentNode.lastChild = newChild;
            _onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
            return newChild;
            //console.log("__aa",parentNode.lastChild.nextSibling == null)
          }
          Document.prototype = {
            //implementation : null,
            nodeName: '#document',
            nodeType: DOCUMENT_NODE,
            doctype: null,
            documentElement: null,
            _inc: 1,

            insertBefore: function (newChild, refChild) { //raises
              if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
                var child = newChild.firstChild;
                while (child) {
                  var next = child.nextSibling;
                  this.insertBefore(child, refChild);
                  child = next;
                }
                return newChild;
              }
              if (this.documentElement == null && newChild.nodeType == ELEMENT_NODE) {
                this.documentElement = newChild;
              }

              return _insertBefore(this, newChild, refChild), (newChild.ownerDocument = this), newChild;
            },
            removeChild: function (oldChild) {
              if (this.documentElement == oldChild) {
                this.documentElement = null;
              }
              return _removeChild(this, oldChild);
            },
            // Introduced in DOM Level 2:
            importNode: function (importedNode, deep) {
              return importNode(this, importedNode, deep);
            },
            // Introduced in DOM Level 2:
            getElementById: function (id) {
              var rtv = null;
              _visitNode(this.documentElement, function (node) {
                if (node.nodeType == ELEMENT_NODE) {
                  if (node.getAttribute('id') == id) {
                    rtv = node;
                    return true;
                  }
                }
              })
              return rtv;
            },

            //document factory method:
            createElement: function (tagName) {
              var node = new Element();
              node.ownerDocument = this;
              node.nodeName = tagName;
              node.tagName = tagName;
              node.childNodes = new NodeList();
              var attrs = node.attributes = new NamedNodeMap();
              attrs._ownerElement = node;
              return node;
            },
            createDocumentFragment: function () {
              var node = new DocumentFragment();
              node.ownerDocument = this;
              node.childNodes = new NodeList();
              return node;
            },
            createTextNode: function (data) {
              var node = new Text();
              node.ownerDocument = this;
              node.appendData(data)
              return node;
            },
            createComment: function (data) {
              var node = new Comment();
              node.ownerDocument = this;
              node.appendData(data)
              return node;
            },
            createCDATASection: function (data) {
              var node = new CDATASection();
              node.ownerDocument = this;
              node.appendData(data)
              return node;
            },
            createProcessingInstruction: function (target, data) {
              var node = new ProcessingInstruction();
              node.ownerDocument = this;
              node.tagName = node.target = target;
              node.nodeValue = node.data = data;
              return node;
            },
            createAttribute: function (name) {
              var node = new Attr();
              node.ownerDocument = this;
              node.name = name;
              node.nodeName = name;
              node.localName = name;
              node.specified = true;
              return node;
            },
            createEntityReference: function (name) {
              var node = new EntityReference();
              node.ownerDocument = this;
              node.nodeName = name;
              return node;
            },
            // Introduced in DOM Level 2:
            createElementNS: function (namespaceURI, qualifiedName) {
              var node = new Element();
              var pl = qualifiedName.split(':');
              var attrs = node.attributes = new NamedNodeMap();
              node.childNodes = new NodeList();
              node.ownerDocument = this;
              node.nodeName = qualifiedName;
              node.tagName = qualifiedName;
              node.namespaceURI = namespaceURI;
              if (pl.length == 2) {
                node.prefix = pl[0];
                node.localName = pl[1];
              } else {
                //el.prefix = null;
                node.localName = qualifiedName;
              }
              attrs._ownerElement = node;
              return node;
            },
            // Introduced in DOM Level 2:
            createAttributeNS: function (namespaceURI, qualifiedName) {
              var node = new Attr();
              var pl = qualifiedName.split(':');
              node.ownerDocument = this;
              node.nodeName = qualifiedName;
              node.name = qualifiedName;
              node.namespaceURI = namespaceURI;
              node.specified = true;
              if (pl.length == 2) {
                node.prefix = pl[0];
                node.localName = pl[1];
              } else {
                //el.prefix = null;
                node.localName = qualifiedName;
              }
              return node;
            }
          };
          _extends(Document, Node);


          function Element() {
            this._nsMap = {};
          };
          Element.prototype = {
            nodeType: ELEMENT_NODE,
            hasAttribute: function (name) {
              return this.getAttributeNode(name) != null;
            },
            getAttribute: function (name) {
              var attr = this.getAttributeNode(name);
              return attr && attr.value || '';
            },
            getAttributeNode: function (name) {
              return this.attributes.getNamedItem(name);
            },
            setAttribute: function (name, value) {
              var attr = this.ownerDocument.createAttribute(name);
              attr.value = attr.nodeValue = "" + value;
              this.setAttributeNode(attr)
            },
            removeAttribute: function (name) {
              var attr = this.getAttributeNode(name)
              attr && this.removeAttributeNode(attr);
            },

            //four real opeartion method
            appendChild: function (newChild) {
              if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
                return this.insertBefore(newChild, null);
              } else {
                return _appendSingleChild(this, newChild);
              }
            },
            setAttributeNode: function (newAttr) {
              return this.attributes.setNamedItem(newAttr);
            },
            setAttributeNodeNS: function (newAttr) {
              return this.attributes.setNamedItemNS(newAttr);
            },
            removeAttributeNode: function (oldAttr) {
              //console.log(this == oldAttr.ownerElement)
              return this.attributes.removeNamedItem(oldAttr.nodeName);
            },
            //get real attribute name,and remove it by removeAttributeNode
            removeAttributeNS: function (namespaceURI, localName) {
              var old = this.getAttributeNodeNS(namespaceURI, localName);
              old && this.removeAttributeNode(old);
            },

            hasAttributeNS: function (namespaceURI, localName) {
              return this.getAttributeNodeNS(namespaceURI, localName) != null;
            },
            getAttributeNS: function (namespaceURI, localName) {
              var attr = this.getAttributeNodeNS(namespaceURI, localName);
              return attr && attr.value || '';
            },
            setAttributeNS: function (namespaceURI, qualifiedName, value) {
              var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
              attr.value = attr.nodeValue = "" + value;
              this.setAttributeNode(attr)
            },
            getAttributeNodeNS: function (namespaceURI, localName) {
              return this.attributes.getNamedItemNS(namespaceURI, localName);
            },

            getElementsByTagName: function (tagName) {
              return new LiveNodeList(this, function (base) {
                var ls = [];
                _visitNode(base, function (node) {
                  if (node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) {
                    ls.push(node);
                  }
                });
                return ls;
              });
            },
            getElementsByTagNameNS: function (namespaceURI, localName) {
              return new LiveNodeList(this, function (base) {
                var ls = [];
                _visitNode(base, function (node) {
                  if (node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) {
                    ls.push(node);
                  }
                });
                return ls;

              });
            }
          };
          Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
          Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;


          _extends(Element, Node);

          function Attr() { };
          Attr.prototype.nodeType = ATTRIBUTE_NODE;
          _extends(Attr, Node);


          function CharacterData() { };
          CharacterData.prototype = {
            data: '',
            substringData: function (offset, count) {
              return this.data.substring(offset, offset + count);
            },
            appendData: function (text) {
              text = this.data + text;
              this.nodeValue = this.data = text;
              this.length = text.length;
            },
            insertData: function (offset, text) {
              this.replaceData(offset, 0, text);

            },
            appendChild: function (newChild) {
              throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR])
            },
            deleteData: function (offset, count) {
              this.replaceData(offset, count, "");
            },
            replaceData: function (offset, count, text) {
              var start = this.data.substring(0, offset);
              var end = this.data.substring(offset + count);
              text = start + text + end;
              this.nodeValue = this.data = text;
              this.length = text.length;
            }
          }
          _extends(CharacterData, Node);

          function Text() { };
          Text.prototype = {
            nodeName: "#text",
            nodeType: TEXT_NODE,
            splitText: function (offset) {
              var text = this.data;
              var newText = text.substring(offset);
              text = text.substring(0, offset);
              this.data = this.nodeValue = text;
              this.length = text.length;
              var newNode = this.ownerDocument.createTextNode(newText);
              if (this.parentNode) {
                this.parentNode.insertBefore(newNode, this.nextSibling);
              }
              return newNode;
            }
          }
          _extends(Text, CharacterData);

          function Comment() { };
          Comment.prototype = {
            nodeName: "#comment",
            nodeType: COMMENT_NODE
          }
          _extends(Comment, CharacterData);

          function CDATASection() { };
          CDATASection.prototype = {
            nodeName: "#cdata-section",
            nodeType: CDATA_SECTION_NODE
          }
          _extends(CDATASection, CharacterData);


          function DocumentType() { };
          DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
          _extends(DocumentType, Node);

          function Notation() { };
          Notation.prototype.nodeType = NOTATION_NODE;
          _extends(Notation, Node);

          function Entity() { };
          Entity.prototype.nodeType = ENTITY_NODE;
          _extends(Entity, Node);

          function EntityReference() { };
          EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
          _extends(EntityReference, Node);

          function DocumentFragment() { };
          DocumentFragment.prototype.nodeName = "#document-fragment";
          DocumentFragment.prototype.nodeType = DOCUMENT_FRAGMENT_NODE;
          _extends(DocumentFragment, Node);


          function ProcessingInstruction() { }
          ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
          _extends(ProcessingInstruction, Node);

          function XMLSerializer() { }
          XMLSerializer.prototype.serializeToString = function (node, isHtml, nodeFilter) {
            return nodeSerializeToString.call(node, isHtml, nodeFilter);
          }
          Node.prototype.toString = nodeSerializeToString;

          function nodeSerializeToString(isHtml, nodeFilter) {
            var buf = [];
            var refNode = this.nodeType == 9 ? this.documentElement : this;
            var prefix = refNode.prefix;
            var uri = refNode.namespaceURI;

            if (uri && prefix == null) {
              //console.log(prefix)
              var prefix = refNode.lookupPrefix(uri);
              if (prefix == null) {
                //isHTML = true;
                var visibleNamespaces = [{
                  namespace: uri,
                  prefix: null
                }
                  //{namespace:uri,prefix:''}
                ]
              }
            }
            serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
            //console.log('###',this.nodeType,uri,prefix,buf.join(''))
            return buf.join('');
          }

          function needNamespaceDefine(node, isHTML, visibleNamespaces) {
            var prefix = node.prefix || '';
            var uri = node.namespaceURI;
            if (!prefix && !uri) {
              return false;
            }
            if (prefix === "xml" && uri === "http://www.w3.org/XML/1998/namespace" ||
              uri == 'http://www.w3.org/2000/xmlns/') {
              return false;
            }

            var i = visibleNamespaces.length
            //console.log('@@@@',node.tagName,prefix,uri,visibleNamespaces)
            while (i--) {
              var ns = visibleNamespaces[i];
              // get namespace prefix
              //console.log(node.nodeType,node.tagName,ns.prefix,prefix)
              if (ns.prefix == prefix) {
                return ns.namespace != uri;
              }
            }
            //console.log(isHTML,uri,prefix=='')
            //if(isHTML && prefix ==null && uri == 'http://www.w3.org/1999/xhtml'){
            //	return false;
            //}
            //node.flag = '11111'
            //console.error(3,true,node.flag,node.prefix,node.namespaceURI)
            return true;
          }

          function serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
            if (nodeFilter) {
              node = nodeFilter(node);
              if (node) {
                if (typeof node == 'string') {
                  buf.push(node);
                  return;
                }
              } else {
                return;
              }
              //buf.sort.apply(attrs, attributeSorter);
            }
            switch (node.nodeType) {
              case ELEMENT_NODE:
                if (!visibleNamespaces) visibleNamespaces = [];
                var startVisibleNamespaces = visibleNamespaces.length;
                var attrs = node.attributes;
                var len = attrs.length;
                var child = node.firstChild;
                var nodeName = node.tagName;

                isHTML = (htmlns === node.namespaceURI) || isHTML
                buf.push('<', nodeName);



                for (var i = 0; i < len; i++) {
                  // add namespaces for attributes
                  var attr = attrs.item(i);
                  if (attr.prefix == 'xmlns') {
                    visibleNamespaces.push({
                      prefix: attr.localName,
                      namespace: attr.value
                    });
                  } else if (attr.nodeName == 'xmlns') {
                    visibleNamespaces.push({
                      prefix: '',
                      namespace: attr.value
                    });
                  }
                }
                for (var i = 0; i < len; i++) {
                  var attr = attrs.item(i);
                  if (needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
                    var prefix = attr.prefix || '';
                    var uri = attr.namespaceURI;
                    var ns = prefix ? ' xmlns:' + prefix : " xmlns";
                    buf.push(ns, '="', uri, '"');
                    visibleNamespaces.push({
                      prefix: prefix,
                      namespace: uri
                    });
                  }
                  serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
                }
                // add namespace for current node
                if (needNamespaceDefine(node, isHTML, visibleNamespaces)) {
                  var prefix = node.prefix || '';
                  var uri = node.namespaceURI;
                  var ns = prefix ? ' xmlns:' + prefix : " xmlns";
                  buf.push(ns, '="', uri, '"');
                  visibleNamespaces.push({
                    prefix: prefix,
                    namespace: uri
                  });
                }

                if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
                  buf.push('>');
                  //if is cdata child node
                  if (isHTML && /^script$/i.test(nodeName)) {
                    while (child) {
                      if (child.data) {
                        buf.push(child.data);
                      } else {
                        serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces);
                      }
                      child = child.nextSibling;
                    }
                  } else {
                    while (child) {
                      serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces);
                      child = child.nextSibling;
                    }
                  }
                  buf.push('</', nodeName, '>');
                } else {
                  buf.push('/>');
                }
                // remove added visible namespaces
                //visibleNamespaces.length = startVisibleNamespaces;
                return;
              case DOCUMENT_NODE:
              case DOCUMENT_FRAGMENT_NODE:
                var child = node.firstChild;
                while (child) {
                  serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces);
                  child = child.nextSibling;
                }
                return;
              case ATTRIBUTE_NODE:
                return buf.push(' ', node.name, '="', node.value.replace(/[<&"]/g, _xmlEncoder), '"');
              case TEXT_NODE:
                return buf.push(node.data.replace(/[<&]/g, _xmlEncoder));
              case CDATA_SECTION_NODE:
                return buf.push('<![CDATA[', node.data, ']]>');
              case COMMENT_NODE:
                return buf.push("<!--", node.data, "-->");
              case DOCUMENT_TYPE_NODE:
                var pubid = node.publicId;
                var sysid = node.systemId;
                buf.push('<!DOCTYPE ', node.name);
                if (pubid) {
                  buf.push(' PUBLIC "', pubid);
                  if (sysid && sysid != '.') {
                    buf.push('" "', sysid);
                  }
                  buf.push('">');
                } else if (sysid && sysid != '.') {
                  buf.push(' SYSTEM "', sysid, '">');
                } else {
                  var sub = node.internalSubset;
                  if (sub) {
                    buf.push(" [", sub, "]");
                  }
                  buf.push(">");
                }
                return;
              case PROCESSING_INSTRUCTION_NODE:
                return buf.push("<?", node.target, " ", node.data, "?>");
              case ENTITY_REFERENCE_NODE:
                return buf.push('&', node.nodeName, ';');
              //case ENTITY_NODE:
              //case NOTATION_NODE:
              default:
                buf.push('??', node.nodeName);
            }
          }

          function importNode(doc, node, deep) {
            var node2;
            switch (node.nodeType) {
              case ELEMENT_NODE:
                node2 = node.cloneNode(false);
                node2.ownerDocument = doc;
              //var attrs = node2.attributes;
              //var len = attrs.length;
              //for(var i=0;i<len;i++){
              //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
              //}
              case DOCUMENT_FRAGMENT_NODE:
                break;
              case ATTRIBUTE_NODE:
                deep = true;
                break;
              //case ENTITY_REFERENCE_NODE:
              //case PROCESSING_INSTRUCTION_NODE:
              ////case TEXT_NODE:
              //case CDATA_SECTION_NODE:
              //case COMMENT_NODE:
              //	deep = false;
              //	break;
              //case DOCUMENT_NODE:
              //case DOCUMENT_TYPE_NODE:
              //cannot be imported.
              //case ENTITY_NODE:
              //case NOTATION_NODE：
              //can not hit in level3
              //default:throw e;
            }
            if (!node2) {
              node2 = node.cloneNode(false); //false
            }
            node2.ownerDocument = doc;
            node2.parentNode = null;
            if (deep) {
              var child = node.firstChild;
              while (child) {
                node2.appendChild(importNode(doc, child, deep));
                child = child.nextSibling;
              }
            }
            return node2;
          }
          //
          //var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
          //					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
          function cloneNode(doc, node, deep) {
            var node2 = new node.constructor();
            for (var n in node) {
              var v = node[n];
              if (typeof v != 'object') {
                if (v != node2[n]) {
                  node2[n] = v;
                }
              }
            }
            if (node.childNodes) {
              node2.childNodes = new NodeList();
            }
            node2.ownerDocument = doc;
            switch (node2.nodeType) {
              case ELEMENT_NODE:
                var attrs = node.attributes;
                var attrs2 = node2.attributes = new NamedNodeMap();
                var len = attrs.length
                attrs2._ownerElement = node2;
                for (var i = 0; i < len; i++) {
                  node2.setAttributeNode(cloneNode(doc, attrs.item(i), true));
                }
                break;;
              case ATTRIBUTE_NODE:
                deep = true;
            }
            if (deep) {
              var child = node.firstChild;
              while (child) {
                node2.appendChild(cloneNode(doc, child, deep));
                child = child.nextSibling;
              }
            }
            return node2;
          }

          function __set__(object, key, value) {
            object[key] = value
          }
          //do dynamic
          try {
            if (Object.defineProperty) {
              Object.defineProperty(LiveNodeList.prototype, 'length', {
                get: function () {
                  _updateLiveList(this);
                  return this.$$length;
                }
              });
              Object.defineProperty(Node.prototype, 'textContent', {
                get: function () {
                  return getTextContent(this);
                },
                set: function (data) {
                  switch (this.nodeType) {
                    case ELEMENT_NODE:
                    case DOCUMENT_FRAGMENT_NODE:
                      while (this.firstChild) {
                        this.removeChild(this.firstChild);
                      }
                      if (data || String(data)) {
                        this.appendChild(this.ownerDocument.createTextNode(data));
                      }
                      break;
                    default:
                      //TODO:
                      this.data = data;
                      this.value = data;
                      this.nodeValue = data;
                  }
                }
              })

              function getTextContent(node) {
                switch (node.nodeType) {
                  case ELEMENT_NODE:
                  case DOCUMENT_FRAGMENT_NODE:
                    var buf = [];
                    node = node.firstChild;
                    while (node) {
                      if (node.nodeType !== 7 && node.nodeType !== 8) {
                        buf.push(getTextContent(node));
                      }
                      node = node.nextSibling;
                    }
                    return buf.join('');
                  default:
                    return node.nodeValue;
                }
              }
              __set__ = function (object, key, value) {
                //console.log(value)
                object['$$' + key] = value
              }
            }
          } catch (e) { //ie8
          }

          //if(typeof require == 'function'){
          exports.DOMImplementation = DOMImplementation;
          exports.XMLSerializer = XMLSerializer;
          //}


          /***/
        }),

      /***/
      19:
        /***/
        (function (module, exports, __webpack_require__) {

          // to indexed object, toObject with fallback for non-array-like ES3 strings
          var IObject = __webpack_require__(83);
          var defined = __webpack_require__(44);
          module.exports = function (it) {
            return IObject(defined(it));
          };


          /***/
        }),

      /***/
      2:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          /**
           * 将im控制消息语义话
           */
          var __assign = (this && this.__assign) || Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                  t[p] = s[p];
            }
            return t;
          };
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.CONTROL_MSGS = {
            // 引导结束
            'LEAD_END': 'LEAD_END',
            // 专家将用户拉入诊室
            'PULL_IN_CONSULTING_ROOM': 'PULL_IN_CONSULTING_ROOM',
            // 续费
            'RE_NEW': 'RE_NEW',
            // 待确认超时
            'TO_CONFIRM_OVERTIME': 'TO_CONFIRM_OVERTIME',
            // 转诊
            'CONSULT_TRANSFER': 'CONSULT_TRANSFER',
            // 用户取消了排队
            'USER_DEQUEUE': 'USER_DEQUEUE',
            // 排队超时领券
            'CONSULT_COUPON': 'CONSULT_COUPON',
            // 私人医生场景 - 值班医生咨询弹窗
            'CONSULT_AGENT': 'CONSULT_AGENT',
            // 私人医生场景 - 换签
            'EXCHANGE_DOCTOR': 'EXCHANGE_DOCTOR',
            // 医生发起RTC视频聊天请求
            'RTC_REQUEST': 'RTC_REQUEST'
          };
          exports.EVENTS_MAP = {
            // 引导结束
            '10002': exports.CONTROL_MSGS['LEAD_END'],
            // 专家将用户拉入诊室
            '10005': exports.CONTROL_MSGS['PULL_IN_CONSULTING_ROOM'],
            // 续费
            '10013': exports.CONTROL_MSGS['RE_NEW'],
            // 待确认超时
            '10024': exports.CONTROL_MSGS['TO_CONFIRM_OVERTIME'],
            // 用户取消了排队
            '10025': exports.CONTROL_MSGS['USER_DEQUEUE'],
            // 医生发起RTC视频聊天请求
            '17001': exports.CONTROL_MSGS['RTC_REQUEST'],
          };
          exports.APP_EVENTS = __assign({
            // im断开 网络异常
            'IM_DISCONNECTED': 'IM_DISCONNECTED',
            // im连接成功
            'IM_CONNECTED': 'IM_CONNECTED',
            // im冲突
            'IM_CONFLICT': 'IM_CONFLICT',
            // im重连成功
            'IM_RECONNECTED': 'IM_RECONNECTED',
            // im异常toast
            'IM_TOAST': 'IM_TOAST',
            // 刷新上下文
            'REFRESH_CONTEXT': 'REFRESH_CONTEXT',
            // 再次问诊
            'RE_CONSULT': 'RE_CONSULT',
            // 刷新排队信息
            'REFRESH_QUEUE': 'REFRESH_QUEUE',
            // 刷新滚动栏
            'REFRESH_SCROLLER': 'REFRESH_SCROLLER',
            // 渲染消息
            'RENDER_MSG': 'RENDER_MSG',
            // 可交互控制消息(同意问诊 引导结束 引导续费等)
            'OPTION_CONTROL_MSG': 'OPTION_CONTROL_MSG',
            // 发送消息
            'SEND_MESSGE': 'SEND_MESSGE',
            // 消息发送反馈
            'SEND_MESSGE_ACK': 'SEND_MESSGE_ACK',
            // 重发消息
            'RE_SEND_MESSGE': 'RE_SEND_MESSGE',
            // 重现加载图片
            'RE_LOAD_IMAGE': 'RE_LOAD_IMAGE',
            // 图片加载成功
            'IMAGE_LOAD_SUCCESS': 'IMAGE_LOAD_SUCCESS',
            // 关闭调和面板
            'CLOSE_RECONCILE': 'CLOSE_RECONCILE',
            // 上下文切换
            'CONTEXT_CHANGE': 'CONTEXT_CHANGE',
            // 转诊
            'REFERRAL_TO': 'REFERRAL_TO',
            // 加载更多消息
            'LOAD_MORE_MSG': 'LOAD_MORE_MSG',
            // 针对不识别的机器人消息 发送空的机器人消息推动到下个节点
            'SEND_EMPTY_ROBOT_MSG': 'SEND_EMPTY_ROBOT_MSG',
            // 点击医生或者用户头像
            'CLICK_IM_AVATAR': 'CLICK_IM_AVATAR',
            // 底部调和面板消息
            'RECONCILE_PANEL_MSG': 'RECONCILE_PANEL_MSG',
            // 机器人面板
            'ROBOT_PANEL_EMITTER': 'ROBOT_PANEL_EMITTER',
            // 输入框面板
            'INPUT_PANEL_EMITTER': 'INPUT_PANEL_EMITTER',
            // 消息渲染错误
            'MESSAGE_RENDER_ERROR': 'MESSAGE_RENDER_ERROR',
            // api网关错误 例如 -180 -320等
            'API_GATE_WAY_ERROR': 'API_GATE_WAY_ERROR',
            // 完成加载更多
            'FINISH_LOAD_MORE_MSG': 'FINISH_LOAD_MORE_MSG',
            // 获取消息盒子未读消息
            'LOAD_UNREAD_INBOX_MSG': 'LOAD_UNREAD_INBOX_MSG',
            // 渲染消息盒子中的消息
            'RENDER_INBOX_MSG': 'RENDER_INBOX_MSG'
          }, exports.CONTROL_MSGS);


          /***/
        }),

      /***/
      21:
        /***/
        (function (module, exports) {

          module.exports = function (it) {
            return typeof it === 'object' ? it !== null : typeof it === 'function';
          };


          /***/
        }),

      /***/
      27:
        /***/
        (function (module, exports, __webpack_require__) {

          var isObject = __webpack_require__(21);
          module.exports = function (it) {
            if (!isObject(it)) throw TypeError(it + ' is not an object!');
            return it;
          };


          /***/
        }),

      /***/
      28:
        /***/
        (function (module, exports, __webpack_require__) {

          var global = __webpack_require__(9);
          var core = __webpack_require__(17);
          var ctx = __webpack_require__(69);
          var hide = __webpack_require__(18);
          var PROTOTYPE = 'prototype';

          var $export = function (type, name, source) {
            var IS_FORCED = type & $export.F;
            var IS_GLOBAL = type & $export.G;
            var IS_STATIC = type & $export.S;
            var IS_PROTO = type & $export.P;
            var IS_BIND = type & $export.B;
            var IS_WRAP = type & $export.W;
            var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
            var expProto = exports[PROTOTYPE];
            var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
            var key, own, out;
            if (IS_GLOBAL) source = name;
            for (key in source) {
              // contains in native
              own = !IS_FORCED && target && target[key] !== undefined;
              if (own && key in exports) continue;
              // export native or passed
              out = own ? target[key] : source[key];
              // prevent global pollution for namespaces
              exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
                // bind timers to global for call from export context
                :
                IS_BIND && own ? ctx(out, global)
                  // wrap global constructors for prevent change them in library
                  :
                  IS_WRAP && target[key] == out ? (function (C) {
                    var F = function (a, b, c) {
                      if (this instanceof C) {
                        switch (arguments.length) {
                          case 0:
                            return new C();
                          case 1:
                            return new C(a);
                          case 2:
                            return new C(a, b);
                        }
                        return new C(a, b, c);
                      }
                      return C.apply(this, arguments);
                    };
                    F[PROTOTYPE] = C[PROTOTYPE];
                    return F;
                    // make static versions for prototype methods
                  })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
              // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
              if (IS_PROTO) {
                (exports.virtual || (exports.virtual = {}))[key] = out;
                // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
                if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
              }
            }
          };
          // type bitmap
          $export.F = 1; // forced
          $export.G = 2; // global
          $export.S = 4; // static
          $export.P = 8; // proto
          $export.B = 16; // bind
          $export.W = 32; // wrap
          $export.U = 64; // safe
          $export.R = 128; // real proto method for `library`
          module.exports = $export;


          /***/
        }),

      /***/
      29:
        /***/
        (function (module, exports) {

          module.exports = function (exec) {
            try {
              return !!exec();
            } catch (e) {
              return true;
            }
          };


          /***/
        }),

      /***/
      30:
        /***/
        (function (module, exports) {

          module.exports = function (bitmap, value) {
            return {
              enumerable: !(bitmap & 1),
              configurable: !(bitmap & 2),
              writable: !(bitmap & 4),
              value: value
            };
          };


          /***/
        }),

      /***/
      31:
        /***/
        (function (module, exports, __webpack_require__) {

          var freeGlobal = __webpack_require__(85);

          /** Detect free variable `self`. */
          var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

          /** Used as a reference to the global object. */
          var root = freeGlobal || freeSelf || Function('return this')();

          module.exports = root;


          /***/
        }),

      /***/
      37:
        /***/
        (function (module, exports) {

          var id = 0;
          var px = Math.random();
          module.exports = function (key) {
            return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
          };


          /***/
        }),

      /***/
      38:
        /***/
        (function (module, exports) {

          module.exports = {};


          /***/
        }),

      /***/
      39:
        /***/
        (function (module, exports, __webpack_require__) {

          // 19.1.2.14 / 15.2.3.14 Object.keys(O)
          var $keys = __webpack_require__(72);
          var enumBugKeys = __webpack_require__(48);

          module.exports = Object.keys || function keys(O) {
            return $keys(O, enumBugKeys);
          };


          /***/
        }),

      /***/
      40:
        /***/
        (function (module, exports) {

          exports.f = {}.propertyIsEnumerable;


          /***/
        }),

      /***/
      41:
        /***/
        (function (module, exports) {

          var g;

          // This works in non-strict mode
          g = (function () {
            return this;
          })();

          try {
            // This works if eval is allowed (see CSP)
            g = g || Function("return this")() || (1, eval)("this");
          } catch (e) {
            // This works if the window reference is available
            if (typeof window === "object")
              g = window;
          }

          // g can still be undefined, but nothing to do about it...
          // We return undefined, instead of nothing here, so it's
          // easier to handle this case. if(!global) { ...}

          module.exports = g;


          /***/
        }),

      /***/
      43:
        /***/
        (function (module, exports, __webpack_require__) {

          // 7.1.1 ToPrimitive(input [, PreferredType])
          var isObject = __webpack_require__(21);
          // instead of the ES6 spec version, we didn't implement @@toPrimitive case
          // and the second argument - flag - preferred type is a string
          module.exports = function (it, S) {
            if (!isObject(it)) return it;
            var fn, val;
            if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
            if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
            if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
            throw TypeError("Can't convert object to primitive value");
          };


          /***/
        }),

      /***/
      44:
        /***/
        (function (module, exports) {

          // 7.2.1 RequireObjectCoercible(argument)
          module.exports = function (it) {
            if (it == undefined) throw TypeError("Can't call method on  " + it);
            return it;
          };


          /***/
        }),

      /***/
      45:
        /***/
        (function (module, exports) {

          // 7.1.4 ToInteger
          var ceil = Math.ceil;
          var floor = Math.floor;
          module.exports = function (it) {
            return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
          };


          /***/
        }),

      /***/
      46:
        /***/
        (function (module, exports, __webpack_require__) {

          var shared = __webpack_require__(47)('keys');
          var uid = __webpack_require__(37);
          module.exports = function (key) {
            return shared[key] || (shared[key] = uid(key));
          };


          /***/
        }),

      /***/
      47:
        /***/
        (function (module, exports, __webpack_require__) {

          var global = __webpack_require__(9);
          var SHARED = '__core-js_shared__';
          var store = global[SHARED] || (global[SHARED] = {});
          module.exports = function (key) {
            return store[key] || (store[key] = {});
          };


          /***/
        }),

      /***/
      48:
        /***/
        (function (module, exports) {

          // IE 8- don't enum bug keys
          module.exports = (
            'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
          ).split(',');


          /***/
        }),

      /***/
      49:
        /***/
        (function (module, exports, __webpack_require__) {

          var Symbol = __webpack_require__(50),
            getRawTag = __webpack_require__(107),
            objectToString = __webpack_require__(108);

          /** `Object#toString` result references. */
          var nullTag = '[object Null]',
            undefinedTag = '[object Undefined]';

          /** Built-in value references. */
          var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

          /**
           * The base implementation of `getTag` without fallbacks for buggy environments.
           *
           * @private
           * @param {*} value The value to query.
           * @returns {string} Returns the `toStringTag`.
           */
          function baseGetTag(value) {
            if (value == null) {
              return value === undefined ? undefinedTag : nullTag;
            }
            return (symToStringTag && symToStringTag in Object(value)) ?
              getRawTag(value) :
              objectToString(value);
          }

          module.exports = baseGetTag;


          /***/
        }),

      /***/
      495:
        /***/
        (function (module, exports, __webpack_require__) {

          module.exports = __webpack_require__(496);


          /***/
        }),

      /***/
      496:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          // 小程序服务透出
          var IMService_compat_1 = __webpack_require__(497);
          exports.IMService = IMService_compat_1.default;
          var IMEventBus_1 = __webpack_require__(1);
          exports.IMEventBus = IMEventBus_1.default;
          var IRobotMessage_1 = __webpack_require__(7);
          exports.IRobotMessage = IRobotMessage_1.default;
          var AnimationRunner_1 = __webpack_require__(56);
          exports.AnimationRunner = AnimationRunner_1.default;


          /***/
        }),

      /***/
      497:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          var __assign = (this && this.__assign) || Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                  t[p] = s[p];
            }
            return t;
          };
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          /**
           * Created by evan on 2017/4/26.
           * @Last Modified by: lisanjie
           * @Last Modified time: 2018-10-30 19:16:28
           */
          var strophe_compat_1 = __webpack_require__(498);
          var IMessage_1 = __webpack_require__(95);
          var uniqueId = __webpack_require__(136);
          var IMEventBus_1 = __webpack_require__(1);
          var WXMessageClassfy_1 = __webpack_require__(501);
          var IMEventMap_1 = __webpack_require__(2);
          /**
           * 基于Strophe的Status
           *  Status.ERROR - An error has occurred
           *  Status.CONNECTING - The connection is currently being made
           *  Status.CONNFAIL - The connection attempt failed
           *  Status.AUTHENTICATING - The connection is authenticating
           *  Status.AUTHFAIL - The authentication attempt failed
           *  Status.CONNECTED - The connection has succeeded
           *  Status.DISCONNECTED - The connection has been terminated
           *  Status.DISCONNECTING - The connection is currently being terminated
           *  Status.ATTACHED - The connection has been attached
           * @type {{ERROR: number; CONNECTING: number; CONNFAIL: number; AUTHENTICATING: number; AUTHFAIL: number; CONNECTED: number; DISCONNECTED: number; DISCONNECTING: number; ATTACHED: number}}
           */
          var StropheStatus;
          (function (StropheStatus) {
            StropheStatus[StropheStatus["ERROR"] = 0] = "ERROR";
            StropheStatus[StropheStatus["CONNECTING"] = 1] = "CONNECTING";
            StropheStatus[StropheStatus["CONNFAIL"] = 2] = "CONNFAIL";
            StropheStatus[StropheStatus["AUTHENTICATING"] = 3] = "AUTHENTICATING";
            StropheStatus[StropheStatus["AUTHFAIL"] = 4] = "AUTHFAIL";
            StropheStatus[StropheStatus["CONNECTED"] = 5] = "CONNECTED";
            StropheStatus[StropheStatus["DISCONNECTED"] = 6] = "DISCONNECTED";
            StropheStatus[StropheStatus["DISCONNECTING"] = 7] = "DISCONNECTING";
            StropheStatus[StropheStatus["ATTACHED"] = 8] = "ATTACHED";
          })(StropheStatus || (StropheStatus = {}));
          // 记录所有的定时器 每次实例化imservice需清空
          var timerList = [];
          /**
           * IMService，包装Strophe库
           * 内部增加重试、容错、日志等机制
           */
          var IMService = /** @class */ (function () {
            /**
             * IM服务构造函数
             * @param options
             */
            function IMService(options) {
              var _this = this;
              /**
               * Ping XMPP服务器的间隔
               * 默认19s
               * @type {number}
               */
              this.pingInterval = 6000;
              /**
               * Ping XMPP服务器的超时时间
               * 默认是10s
               * @type {number}
               */
              this.pingTimeout = 6000;
              /**
               * XMPP连接断开重连间隔
               * 默认10s
               * @type {number}
               */
              this.reconnectInterval = 6000;
              /**
               * ping定时器句柄
               * @type {number}
               */
              this.pingTimer = 0;
              /**
               * ping的错误次数
               */
              this.pingErrorTimers = 0;
              /**
               * ping当前状态
               */
              this.pingStatu = true;
              /**
               * 重连定时器句柄
               * @type {number}
               */
              this.reconnectTimer = 0;
              /**
               * 是否自动重连
               * @type {boolean}
               */
              this.needAutoReconnect = true;
              /**
               *是否已销毁
               */
              this.hasDestory = false;
              /**
               * 消息监听
               * @private
               */
              this._onMessageListener = function () { };
              /**
               * 连接监听
               * @private
               */
              this._onConnectListener = function () { };
              /**
               * 连接处理器
               * @param status
               * @param condition
               * @private
               */
              this._onConnectHandler = function (status, condition) {
                // 如果当前im已经销毁 直接返回
                if (_this.hasDestory) {
                  return;
                }
                switch (status) {
                  case StropheStatus.DISCONNECTED:
                  case StropheStatus.CONNFAIL:
                  case StropheStatus.AUTHFAIL:
                    IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.IM_DISCONNECTED);
                    if (_this.needAutoReconnect) {
                      _this.stopPing();
                      console.log('need reconnect');
                      _this.startReconnect();
                    } else {
                      _this.stopPing();
                      _this.stopReconnect();
                      // this.startPing();
                    }
                    break;
                  case StropheStatus.ERROR:
                    if (condition === 'conflict') {
                      // IM互踢，需要退出重新登录
                      IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.IM_CONFLICT);
                    }
                    break;
                  case StropheStatus.CONNECTED:
                    _this.stopReconnect();
                    _this.startPing();
                    IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.IM_CONNECTED);
                }
                _this._onConnectListener(status, condition);
              };
              this._onMessageHandler = function (stanza) {
                // 异常消息体直接返回
                if (stanza && stanza.tagName === 'message' && stanza.getAttribute("type") === 'error') {
                  return;
                }
                var message = _this.parseXMPPMessage(stanza);
                // 发送consumeack 和 readack
                if (message && message.msgBody !== 'messageack') {
                  _this.sendConsumeAck(message);
                }
                message && _this._onMessageListener(message);
              };
              this._onSendHandler = function (stanza) {
                console.debug(stanza);
              };
              var _a = options.protocol,
                protocol = _a === void 0 ? 'ws' : _a,
                jidHost = options.jidHost,
                _b = options.host,
                host = _b === void 0 ? 'localhost' : _b,
                _c = options.port,
                port = _c === void 0 ? 5290 : _c,
                _d = options.path,
                path = _d === void 0 ? '' : _d,
                _e = options.resource,
                resource = _e === void 0 ? 'webim' : _e,
                _f = options.ticketInfo,
                ticketInfo = _f === void 0 ? '' : _f;
              this.options = options;
              this.jidHost = jidHost || host;
              var serviceUrl = protocol + "://" + host + ":" + path;
              this.jidPrefix = this.jidHost + "/" + resource;
              var xmppConnector = new strophe_compat_1.default.Connection(serviceUrl, {
                ticketInfo: ticketInfo
              });
              xmppConnector.xmlInput = this._onMessageHandler;
              xmppConnector.xmlOutput = this._onSendHandler;
              this.xmppConnector = xmppConnector;
              // 方法绑定
              this.connect = this.connect.bind(this);
              this.isConnected = this.isConnected.bind(this);
              this.disconnect = this.disconnect.bind(this);
              this.reconnect = this.reconnect.bind(this);
              // 初始化消息分类处理器
              this.msgClassfy = new WXMessageClassfy_1.default();
              this.clearTimerList();
            }
            /**
             * 清空定时器列表
             */
            IMService.prototype.clearTimerList = function () {
              timerList.forEach(function (timer) {
                clearInterval(timer);
              });
              timerList.length = 0;
            };
            /**
             * 连接XMPP服务器
             * @param jid
             * @param password
             */
            IMService.prototype.connect = function (jid, password) {
              var _jid = jid || this.jid;
              if (!_jid) {
                throw new Error('jid is null.');
              }
              this.jid = _jid;
              this.password = password || this.password;
              var jidUri = this.jid + "@" + this.jidPrefix;
              this.xmppConnector.connect(jidUri, this.password, this._onConnectHandler);
              console.debug('connect xmpp server', jidUri, this.password);
              this.needAutoReconnect = true;
            };
            /**
             * 判断当前XMPP是否已经连接
             * @returns {any|boolean}
             */
            IMService.prototype.isConnected = function () {
              return this.xmppConnector && this.xmppConnector.connected;
            };
            /**
             * 断开当前XMPP服务器连接
             * @param reason
             * @param autoReconnect
             */
            IMService.prototype.disconnect = function (reason, autoReconnect) {
              if (autoReconnect === void 0) {
                autoReconnect = true;
              }
              var xmppConnector = this.xmppConnector;
              console.debug('disconnect xmpp');
              this.stopPing();
              this.stopReconnect();
              this.needAutoReconnect = false;
              xmppConnector.flush();
              xmppConnector.disconnect(reason);
              xmppConnector.reset();
            };
            /**
             * 重连
             */
            IMService.prototype.reconnect = function () {
              console.log('reconnect xmpp');
              this.disconnect('auto reconnect');
              this.connect();
            };
            /**
             * 发送消息
             * @param message
             */
            IMService.prototype.sendMessage = function (message) {
              const date = Date.now()
              var feature = {
                did: message.did,
                aid: 20,
                dir: 2  //用户发为2，医生发赋1
              };
              if (message.feature) {
                typeof message.feature === 'object' ?
                  (feature = __assign({}, feature, message.feature)) :
                  (feature = __assign({}, feature, JSON.parse(message.feature)));
              }

              var data = {
                fromId: message.fromId,
                toId: message.toId,
                content: message.content,
                type: message.type || 1,
                sid: message.id || date,
                subType: message.subType || 1,
                feature: JSON.stringify(feature),
                created: date,
                dir: 2
              };
              var bodyData = {
                action: 1,
                data: data
              };
              var messageData = {
                type: data.type,
                toId: data.toId,
                fromId: data.fromId,
                sid: data.sid,
                did: message.did,
                body: JSON.stringify(bodyData)
              };
              var xmppMsg = this.createMessage('chat', messageData);
              try {
                this.send(xmppMsg.tree());
              } catch (e) { }
              return data.sid;
            };
            /**
             * 消息发送
             * @param stanza
             */
            IMService.prototype.send = function (stanza) {
              if (this.xmppConnector) {
                this.xmppConnector.send(stanza);
              }
            };
            /**
             * 发送ConsumeAck消息
             * @param message
             */
            IMService.prototype.sendConsumeAck = function (message) {
              console.log('send consume ack');
              var data = message.data;
              var consumeAckBase = {
                did: data.did,
                toId: data.fromId,
                fromId: data.toId,
                sid: data.sid,
                mid: message.data.id,
                body: 'ack'
              };
              // 私人医生场景
              if (data.feature.pid) {
                consumeAckBase['pid'] = data.feature.pid;
              }
              var msgEl = this.createMessage('ack', consumeAckBase);
              this.send(msgEl.tree());
            };
            /**
             * 发送ReadAck消息
             * @param message
             */
            IMService.prototype.sendReadAck = function (message) {
              console.log('send read ack');
              var readAckBase = {
                did: message.did,
                toId: message.fromId,
                fromId: message.toId,
                cid: message.cid,
                mid: message.id,
                body: 'ack'
              };
              // 私人医生场景
              if (message.feature.pid) {
                readAckBase['pid'] = message.feature.persopid||message.feature.pid
              }
              var msgEl = this.createMessage('readAck', readAckBase);
              this.send(msgEl.tree());
            };
            IMService.prototype.setOnMessageListener = function (listener) {
              this._onMessageListener = listener;
            };
            IMService.prototype.setOnConnectListener = function (listener) {
              this._onConnectListener = listener;
            };
            IMService.prototype.removeOnMessageListener = function () {
              this._onMessageListener = function () { };
            };
            IMService.prototype.removeOnConnectListener = function () {
              this._onConnectListener = function () { };
            };
            // 启动重连接
            IMService.prototype.startReconnect = function () {
              console.debug('start to reconnect xmpp');
              if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
              }
              if (!this.hasDestory) {
                this.reconnectTimer = setInterval(this.connect, this.reconnectInterval);
                timerList.push(this.reconnectTimer);
              }
            };
            // 停止重连接
            IMService.prototype.stopReconnect = function () {
              console.debug('stop to reconnect xmpp');
              if (this.reconnectTimer) {
                clearInterval(this.reconnectTimer);
                this.reconnectTimer = 0;
              }
            };
            // 启动ping服务
            IMService.prototype.startPing = function () {
              var _this = this;
              console.debug('start to ping xmpp');
              var that = this;
              if (this.pingTimer) {
                clearInterval(this.pingTimer);
              }
              this.pingTimer = setInterval(function () {
                // 清除pingTimer
                if (that.hasDestory && that.pingTimer) {
                  clearInterval(that.pingTimer);
                  return;
                }
                _this.xmppConnector.ping.ping(_this.jidHost, function () {
                  // console.log('Send ping success');
                  if (!_this.pingStatu) {
                    _this.pingStatu = true;
                    !that.hasDestory && IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.IM_RECONNECTED);
                  }
                }, function () {
                  // console.log('Send ping error, the connection is alive? %s', this.isConnected());
                  _this.pingStatu = false;
                  !that.hasDestory && IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.IM_DISCONNECTED);
                }, _this.pingTimeout);
              }, this.pingInterval);
              timerList.push(this.pingTimer);
            };
            // 停止ping服务
            IMService.prototype.stopPing = function () {
              console.debug('stop to ping xmpp');
              if (this.pingTimer) {
                clearInterval(this.pingTimer);
                this.pingTimer = 0;
              }
            };
            /**
             * 创建XMPP消息体
             */
            IMService.prototype.createMessage = function (type, data) {
              var that = this;
              var _a = this.options,
                protocol = _a.protocol,
                jidHost = _a.jidHost,
                host = _a.host,
                port = _a.port,
                _b = _a.path,
                path = _b === void 0 ? '' : _b,
                _c = _a.resource,
                resource = _c === void 0 ? 'webim' : _c;
              var map = {
                chat: function (attrs) {
                  var node = strophe_compat_1.default.xmlHtmlNode("<properties xmlns=\"http://www.jivesoftware.com/xmlns/xmpp/properties\">\n                <property><name>type</name><value type=\"string\">" + attrs.type + "</value></property>\n                <property><name>sid</name><value type=\"string\">" + attrs.sid + "</value></property>\n                <property><name>uid</name><value type=\"string\">" + attrs.fromId + "</value> </property>\n                <property><name>did</name><value type=\"string\">" + attrs.did + "</value></property>\n                <property><name>ver</name><value type=\"string\">0.1</value></property>\n             </properties>");
                  var message = {
                    type: 'chat',
                    to: attrs.toId + '@' + jidHost,
                    resource: resource
                  };
                  var request = new strophe_compat_1.default.Builder('message', message);
                  request.cnode(strophe_compat_1.default.copyElement(node.documentElement)).up();
                  request.cnode(strophe_compat_1.default.xmlElement('body', attrs.body)).up();
                  return request;
                },
                ack: function (attrs) {
                  var node = strophe_compat_1.default.xmlHtmlNode("<properties xmlns=\"http://www.jivesoftware.com/xmlns/xmpp/properties\">\n                    <property><name>statusCode</name><value type=\"string\"/></property>\n                    <property><name>uid</name><value type=\"string\">" + attrs.fromId + "</value></property>\n                    " + (attrs.pid ?
                    "\n                    <property>\n                        <name>pid</name>\n                        <value type=\"string\">" + attrs.pid + "</value>\n                    </property>\n                   " :
                    '') + "\n                    <property><name>mid</name><value type=\"string\">" + attrs.mid + "</value></property>\n                    <property><name>ver</name><value type=\"string\">0.1</value></property>\n                </properties>\n                  ");
                  var thread = '<thread>' + uniqueId('thread_') + '</thread>';
                  var threadNode = strophe_compat_1.default.xmlHtmlNode(thread);
                  var message = {
                    id: 'B5INc-20',
                    type: 'chat',
                    to: attrs.toId + '@' + jidHost,
                    xmlns: 'urn:ietf:params:xml:ns:messageConsumeACK'
                  };
                  var request = new strophe_compat_1.default.Builder('message', message);
                  request.cnode(strophe_compat_1.default.copyElement(node.documentElement)).up();
                  request.cnode(strophe_compat_1.default.copyElement(threadNode.documentElement)).up();
                  request.cnode(strophe_compat_1.default.xmlElement('body', attrs.body)).up();
                  return request;
                },
                readAck: function (attrs) {
                  var node = strophe_compat_1.default.xmlHtmlNode("<properties xmlns=\"http://www.jivesoftware.com/xmlns/xmpp/properties\">\n                    <property>\n                        <name>did</name>\n                        <value type=\"string\">" + attrs.did + "</value>\n                    </property>\n                    " + (attrs.pid ?
                    "\n                    <property>\n                        <name>pid</name>\n                        <value type=\"string\">" + attrs.pid + "</value>\n                    </property>\n                    " :
                    '') + "\n                    <property>\n                         <name>fromId</name>\n                         <value type=\"string\">" + attrs.fromId + "</value>\n                    </property>\n                    <property>\n                         <name>uid</name>\n                         <value type=\"string\">" + attrs.fromId + "</value>\n                    </property>\n                    <property>\n                         <name>lastMessageId</name>\n                         <value type=\"string\">" + attrs.mid + "</value>\n                    </property>\n                    <property>\n                         <name>ver</name>\n                         <value type=\"string\">0.1</value>\n                    </property>\n                  </properties>");
                  var thread = '<thread>' + uniqueId('thread_') + '</thread>';
                  var threadNode = strophe_compat_1.default.xmlHtmlNode(thread);
                  var message = {
                    id: 'B5INc-20',
                    type: 'chat',
                    to: attrs.toId + '@' + jidHost,
                    xmlns: 'urn:ietf:params:xml:ns:messageReadACK'
                  };
                  var request = new strophe_compat_1.default.Builder('message', message);
                  request.cnode(strophe_compat_1.default.copyElement(node.documentElement)).up();
                  request.cnode(strophe_compat_1.default.copyElement(threadNode.documentElement)).up();
                  request.cnode(strophe_compat_1.default.xmlElement('body', attrs.body)).up();
                  return request;
                }
              };
              if (typeof map[type] === 'function') {
                return map[type](data);
              }
            };
            /**x x
             * 解析XMPP消息
             * @returns {IMessage}
             */
            IMService.prototype.parseXMPPMessage = function (stanza) {
              if (stanza.tagName && stanza.tagName !== 'message' && stanza.tagName !== 'body') {
                // 屏蔽除了message以外的消息
                return;
              }
              console.log('IM', stanza);
              var data = 'messageack';
              // 原始消息体
              var msgBody = '';
              // 解析消息体（Body）
              // 消息体内容是JSON
              var itemBodys = stanza.getElementsByTagName('body');
              var itemBody;
              if (itemBodys.length > 0) {
                // 默认只有一个body子元素
                itemBody = itemBodys.item(0);
                var text = itemBody.textContent;
                msgBody = text;
                if (text && text !== 'messageack' && text !== 'ack') {
                  data = text;
                }
              }
              if (data !== 'messageack') {
                data = SystemUtil.json_parse(data);
                if (data.data) {
                  data = data.data;
                }
              }
              // 解析属性内容
              var props = {
                msgBody: msgBody
              };
              var propsHandler = {
                created: function (v) {
                  return parseInt(v, 10);
                }
              };
              // 属性列表处理
              var properties = stanza.getElementsByTagName('property');
              var propertyEl, properyName, propertyValue, action;
              if (properties.length > 0) {
                for (var i = 0; i < properties.length; i++) {
                  propertyEl = properties.item(i);
                  properyName = propertyEl.getElementsByTagName('name').item(0).textContent;
                  propertyValue = propertyEl.getElementsByTagName('value').item(0).textContent;
                  action = propsHandler[properyName];
                  action ? (props[properyName] = action(propertyValue)) : (props[properyName] = propertyValue);
                }
              }
              console.log(props, data);
              return IMessage_1.default.format(props, data);
            };
            IMService.prototype.startMsgProcessing = function (entranceDoctorId, personId) {
              this.msgClassfy.setDid(entranceDoctorId);
              // 私人医生场景
              this.msgClassfy.setPid(personId || 0);
              this.setOnMessageListener(this.processMessage);
            };
            IMService.prototype.processMessage = function (msg) {
              var did = this.msgClassfy.getDid();
              if (msg.data && !msg.data.did && msg.data.feature && msg.data.feature.did) {
                msg.data.did = msg.data.feature.did
              }
              // 内部医生问诊 主医生不一致 消息直接过滤
              if (did &&
                msg.data &&
                msg.data.did &&
                msg.data.did !== did) {
                return;
              }
              // 私人医生问诊 主医生一致 档案人id不一致 则直接过滤该消息
              // var pid = this.msgClassfy.getPid();
              // if (did &&
              //   msg.data &&
              //   msg.data.did &&
              //   msg.data.did === did &&
              //   msg.data.feature &&
              //   pid &&
              //   msg.data.feature.pid !== pid
              // ) {
              //   return;
              // }
              if (
                msg.data &&
                msg.data.feature &&
                msg.data.feature.channel === 'wx-proxy'
              ) {
                return;
              }

              // 发送readack消息
              if (msg.msgBody !== 'messageack') {
                this.sendReadAck(msg.data);
              }
              this.msgClassfy.processMessage(msg);
            };
            return IMService;
          }());
          exports.default = IMService;


          /***/
        }),

      /***/
      498:
        /***/
        (function (module, __webpack_exports__, __webpack_require__) {

          "use strict";
          Object.defineProperty(__webpack_exports__, "__esModule", {
            value: true
          });
          /* harmony import */
          var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(51);
          /* harmony import */
          var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
          /* harmony import */
          var __WEBPACK_IMPORTED_MODULE_1_xmldom__ = __webpack_require__(499);
          /* harmony import */
          var __WEBPACK_IMPORTED_MODULE_1_xmldom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xmldom__);

          // 通用dom操作库
          // A PURE JS W3C Standard based(XML DOM Level2 CORE) DOMParser and XMLSerializer

          // This code was written by Tyler Akins and has been placed in the
          // public domain.  It would be nice if you left this header intact.
          // Base64 code from Tyler Akins -- http://rumkin.com
          /* eslint-disable */
          // 构建dom解析器具
          var DOMParser = __WEBPACK_IMPORTED_MODULE_1_xmldom___default.a.DOMParser;
          /**
           * 重写json parse 处理 消息id精度问题
           */
          var json_parse = function () {
            "use strict";

            // This is a function that can parse a JSON text, producing a JavaScript
            // data structure. It is a simple, recursive descent parser. It does not use
            // eval or regular expressions, so it can be used as a model for implementing
            // a JSON parser in other languages.

            // We are defining the function inside of another function to avoid creating
            // global variables.

            var at,
              // The index of the current character
              ch,
              // The current character
              escapee = {
                '"': '"',
                '\\': '\\',
                '/': '/',
                b: '\b',
                f: '\f',
                n: '\n',
                r: '\r',
                t: '\t'
              },
              text,
              error = function error(m) {

                // Call error when something is wrong.

                throw {
                  name: 'SyntaxError',
                  message: m,
                  at: at,
                  text: text
                };
              },
              next = function next(c) {

                // If a c parameter is provided, verify that it matches the current character.

                if (c && c !== ch) {
                  error("Expected '" + c + "' instead of '" + ch + "'");
                }

                // Get the next character. When there are no more characters,
                // return the empty string.

                ch = text.charAt(at);
                at += 1;
                return ch;
              },
              number = function number() {

                // Parse a number value.

                var number,
                  string = '';

                if (ch === '-') {
                  string = '-';
                  next('-');
                }
                while (ch >= '0' && ch <= '9') {
                  string += ch;
                  next();
                }
                if (ch === '.') {
                  string += '.';
                  while (next() && ch >= '0' && ch <= '9') {
                    string += ch;
                  }
                }
                if (ch === 'e' || ch === 'E') {
                  string += ch;
                  next();
                  if (ch === '-' || ch === '+') {
                    string += ch;
                    next();
                  }
                  while (ch >= '0' && ch <= '9') {
                    string += ch;
                    next();
                  }
                }
                // number = +string;

                if (string.length < 17) {
                  number = +string;
                } else {
                  number = string;
                }

                if (!isFinite(number)) {
                  error("Bad number");
                } else {
                  return number;
                }
              },
              string = function string() {

                // Parse a string value.

                var hex,
                  i,
                  string = '',
                  uffff;

                // When parsing for string values, we must look for " and \ characters.

                if (ch === '"') {
                  while (next()) {
                    if (ch === '"') {
                      next();
                      return string;
                    }
                    if (ch === '\\') {
                      next();
                      if (ch === 'u') {
                        uffff = 0;
                        for (i = 0; i < 4; i += 1) {
                          hex = parseInt(next(), 16);
                          if (!isFinite(hex)) {
                            break;
                          }
                          uffff = uffff * 16 + hex;
                        }
                        string += String.fromCharCode(uffff);
                      } else if (typeof escapee[ch] === 'string') {
                        string += escapee[ch];
                      } else {
                        break;
                      }
                    } else {
                      string += ch;
                    }
                  }
                }
                error("Bad string");
              },
              white = function white() {

                // Skip whitespace.

                while (ch && ch <= ' ') {
                  next();
                }
              },
              word = function word() {

                // true, false, or null.

                switch (ch) {
                  case 't':
                    next('t');
                    next('r');
                    next('u');
                    next('e');
                    return true;
                  case 'f':
                    next('f');
                    next('a');
                    next('l');
                    next('s');
                    next('e');
                    return false;
                  case 'n':
                    next('n');
                    next('u');
                    next('l');
                    next('l');
                    return null;
                }
                error("Unexpected '" + ch + "'");
              },
              value,
              // Place holder for the value function.

              array = function array() {

                // Parse an array value.

                var array = [];

                if (ch === '[') {
                  next('[');
                  white();
                  if (ch === ']') {
                    next(']');
                    return array; // empty array
                  }
                  while (ch) {
                    array.push(value());
                    white();
                    if (ch === ']') {
                      next(']');
                      return array;
                    }
                    next(',');
                    white();
                  }
                }
                error("Bad array");
              },
              object = function object() {

                // Parse an object value.

                var key,
                  object = {};

                if (ch === '{') {
                  next('{');
                  white();
                  if (ch === '}') {
                    next('}');
                    return object; // empty object
                  }
                  while (ch) {
                    key = string();
                    white();
                    next(':');
                    if (Object.hasOwnProperty.call(object, key)) {
                      error('Duplicate key "' + key + '"');
                    }
                    object[key] = value();
                    white();
                    if (ch === '}') {
                      next('}');
                      return object;
                    }
                    next(',');
                    white();
                  }
                }
                error("Bad object");
              };

            value = function value() {

              // Parse a JSON value. It could be an object, an array, a string, a number,
              // or a word.

              white();
              switch (ch) {
                case '{':
                  return object();
                case '[':
                  return array();
                case '"':
                  return string();
                case '-':
                  return number();
                default:
                  return ch >= '0' && ch <= '9' ? number() : word();
              }
            };

            // Return the json_parse function. It will have access to all of the above
            // functions and variables.

            return function (source, reviver) {
              var result;

              text = source;
              at = 0;
              ch = ' ';
              result = value();
              white();
              if (ch) {
                error("Syntax error");
              }

              // If there is a reviver function, we recursively walk the new structure,
              // passing each name/value pair to the reviver function for possible
              // transformation, starting with a temporary root object that holds the result
              // in an empty key. If there is not a reviver function, we simply return the
              // result.

              return typeof reviver === 'function' ? function walk(holder, key) {
                var k,
                  v,
                  value = holder[key];
                if (value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
                  for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                      v = walk(value, k);
                      if (v !== undefined) {
                        value[k] = v;
                      } else {
                        delete value[k];
                      }
                    }
                  }
                }
                return reviver.call(holder, key, value);
              }({
                '': result
              }, '') : result;
            };
          }();

          // JSON.parse = json_parse;

          var Base64 = function () {
            var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

            var obj = {
              /**
               * Encodes a string in base64
               * @param {String} input The string to encode in base64.
               */
              encode: function encode(input) {
                var output = "";
                var chr1, chr2, chr3;
                var enc1, enc2, enc3, enc4;
                var i = 0;

                do {
                  chr1 = input.charCodeAt(i++);
                  chr2 = input.charCodeAt(i++);
                  chr3 = input.charCodeAt(i++);

                  enc1 = chr1 >> 2;
                  enc2 = (chr1 & 3) << 4 | chr2 >> 4;
                  enc3 = (chr2 & 15) << 2 | chr3 >> 6;
                  enc4 = chr3 & 63;

                  if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                  } else if (isNaN(chr3)) {
                    enc4 = 64;
                  }

                  output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
                } while (i < input.length);

                return output;
              },

              /**
               * Decodes a base64 string.
               * @param {String} input The string to decode.
               */
              decode: function decode(input) {
                var output = "";
                var chr1, chr2, chr3;
                var enc1, enc2, enc3, enc4;
                var i = 0;

                // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
                input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

                do {
                  enc1 = keyStr.indexOf(input.charAt(i++));
                  enc2 = keyStr.indexOf(input.charAt(i++));
                  enc3 = keyStr.indexOf(input.charAt(i++));
                  enc4 = keyStr.indexOf(input.charAt(i++));

                  chr1 = enc1 << 2 | enc2 >> 4;
                  chr2 = (enc2 & 15) << 4 | enc3 >> 2;
                  chr3 = (enc3 & 3) << 6 | enc4;

                  output = output + String.fromCharCode(chr1);

                  if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                  }
                  if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                  }
                } while (i < input.length);

                return output;
              }
            };

            return obj;
          }();

          /*
           * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
           * in FIPS PUB 180-1
           * Version 2.1a Copyright Paul Johnston 2000 - 2002.
           * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
           * Distributed under the BSD License
           * See http://pajhome.org.uk/crypt/md5 for details.
           */

          /* Some functions and variables have been stripped for use with Strophe */

          /*
           * These are the functions you'll usually want to call
           * They take string arguments and return either hex or base-64 encoded strings
           */
          function b64_sha1(s) {
            return binb2b64(core_sha1(str2binb(s), s.length * 8));
          }

          function str_sha1(s) {
            return binb2str(core_sha1(str2binb(s), s.length * 8));
          }

          function b64_hmac_sha1(key, data) {
            return binb2b64(core_hmac_sha1(key, data));
          }

          function str_hmac_sha1(key, data) {
            return binb2str(core_hmac_sha1(key, data));
          }

          /*
           * Calculate the SHA-1 of an array of big-endian words, and a bit length
           */
          function core_sha1(x, len) {
            /* append padding */
            x[len >> 5] |= 0x80 << 24 - len % 32;
            x[(len + 64 >> 9 << 4) + 15] = len;

            var w = new Array(80);
            var a = 1732584193;
            var b = -271733879;
            var c = -1732584194;
            var d = 271733878;
            var e = -1009589776;

            var i, j, t, olda, oldb, oldc, oldd, olde;
            for (i = 0; i < x.length; i += 16) {
              olda = a;
              oldb = b;
              oldc = c;
              oldd = d;
              olde = e;

              for (j = 0; j < 80; j++) {
                if (j < 16) {
                  w[j] = x[i + j];
                } else {
                  w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
                }
                t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)), safe_add(safe_add(e, w[j]), sha1_kt(j)));
                e = d;
                d = c;
                c = rol(b, 30);
                b = a;
                a = t;
              }

              a = safe_add(a, olda);
              b = safe_add(b, oldb);
              c = safe_add(c, oldc);
              d = safe_add(d, oldd);
              e = safe_add(e, olde);
            }
            return [a, b, c, d, e];
          }

          /*
           * Perform the appropriate triplet combination function for the current
           * iteration
           */
          function sha1_ft(t, b, c, d) {
            if (t < 20) {
              return b & c | ~b & d;
            }
            if (t < 40) {
              return b ^ c ^ d;
            }
            if (t < 60) {
              return b & c | b & d | c & d;
            }
            return b ^ c ^ d;
          }

          /*
           * Determine the appropriate additive constant for the current iteration
           */
          function sha1_kt(t) {
            return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
          }

          /*
           * Calculate the HMAC-SHA1 of a key and some data
           */
          function core_hmac_sha1(key, data) {
            var bkey = str2binb(key);
            if (bkey.length > 16) {
              bkey = core_sha1(bkey, key.length * 8);
            }

            var ipad = new Array(16),
              opad = new Array(16);
            for (var i = 0; i < 16; i++) {
              ipad[i] = bkey[i] ^ 0x36363636;
              opad[i] = bkey[i] ^ 0x5C5C5C5C;
            }

            var hash = core_sha1(ipad.concat(str2binb(data)), 512 + data.length * 8);
            return core_sha1(opad.concat(hash), 512 + 160);
          }

          /*
           * Add integers, wrapping at 2^32. This uses 16-bit operations internally
           * to work around bugs in some JS interpreters.
           */
          function safe_add(x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF);
            var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return msw << 16 | lsw & 0xFFFF;
          }

          /*
           * Bitwise rotate a 32-bit number to the left.
           */
          function rol(num, cnt) {
            return num << cnt | num >>> 32 - cnt;
          }

          /*
           * Convert an 8-bit or 16-bit string to an array of big-endian words
           * In 8-bit function, characters >255 have their hi-byte silently ignored.
           */
          function str2binb(str) {
            var bin = [];
            var mask = 255;
            for (var i = 0; i < str.length * 8; i += 8) {
              bin[i >> 5] |= (str.charCodeAt(i / 8) & mask) << 24 - i % 32;
            }
            return bin;
          }

          /*
           * Convert an array of big-endian words to a string
           */
          function binb2str(bin) {
            var str = "";
            var mask = 255;
            for (var i = 0; i < bin.length * 32; i += 8) {
              str += String.fromCharCode(bin[i >> 5] >>> 24 - i % 32 & mask);
            }
            return str;
          }

          /*
           * Convert an array of big-endian words to a base-64 string
           */
          function binb2b64(binarray) {
            var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var str = "";
            var triplet, j;
            for (var i = 0; i < binarray.length * 4; i += 3) {
              triplet = (binarray[i >> 2] >> 8 * (3 - i % 4) & 0xFF) << 16 | (binarray[i + 1 >> 2] >> 8 * (3 - (i + 1) % 4) & 0xFF) << 8 | binarray[i + 2 >> 2] >> 8 * (3 - (i + 2) % 4) & 0xFF;
              for (j = 0; j < 4; j++) {
                if (i * 8 + j * 6 > binarray.length * 32) {
                  str += "=";
                } else {
                  str += tab.charAt(triplet >> 6 * (3 - j) & 0x3F);
                }
              }
            }
            return str;
          }

          /*
           * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
           * Digest Algorithm, as defined in RFC 1321.
           * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
           * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
           * Distributed under the BSD License
           * See http://pajhome.org.uk/crypt/md5 for more info.
           */

          /*
           * Everything that isn't used by Strophe has been stripped here!
           */

          var MD5 = function () {
            /*
             * Add integers, wrapping at 2^32. This uses 16-bit operations internally
             * to work around bugs in some JS interpreters.
             */
            var safe_add = function safe_add(x, y) {
              var lsw = (x & 0xFFFF) + (y & 0xFFFF);
              var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
              return msw << 16 | lsw & 0xFFFF;
            };

            /*
             * Bitwise rotate a 32-bit number to the left.
             */
            var bit_rol = function bit_rol(num, cnt) {
              return num << cnt | num >>> 32 - cnt;
            };

            /*
             * Convert a string to an array of little-endian words
             */
            var str2binl = function str2binl(str) {
              var bin = [];
              for (var i = 0; i < str.length * 8; i += 8) {
                bin[i >> 5] |= (str.charCodeAt(i / 8) & 255) << i % 32;
              }
              return bin;
            };

            /*
             * Convert an array of little-endian words to a string
             */
            var binl2str = function binl2str(bin) {
              var str = "";
              for (var i = 0; i < bin.length * 32; i += 8) {
                str += String.fromCharCode(bin[i >> 5] >>> i % 32 & 255);
              }
              return str;
            };

            /*
             * Convert an array of little-endian words to a hex string.
             */
            var binl2hex = function binl2hex(binarray) {
              var hex_tab = "0123456789abcdef";
              var str = "";
              for (var i = 0; i < binarray.length * 4; i++) {
                str += hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 & 0xF);
              }
              return str;
            };

            /*
             * These functions implement the four basic operations the algorithm uses.
             */
            var md5_cmn = function md5_cmn(q, a, b, x, s, t) {
              return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
            };

            var md5_ff = function md5_ff(a, b, c, d, x, s, t) {
              return md5_cmn(b & c | ~b & d, a, b, x, s, t);
            };

            var md5_gg = function md5_gg(a, b, c, d, x, s, t) {
              return md5_cmn(b & d | c & ~d, a, b, x, s, t);
            };

            var md5_hh = function md5_hh(a, b, c, d, x, s, t) {
              return md5_cmn(b ^ c ^ d, a, b, x, s, t);
            };

            var md5_ii = function md5_ii(a, b, c, d, x, s, t) {
              return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
            };

            /*
             * Calculate the MD5 of an array of little-endian words, and a bit length
             */
            var core_md5 = function core_md5(x, len) {
              /* append padding */
              x[len >> 5] |= 0x80 << len % 32;
              x[(len + 64 >>> 9 << 4) + 14] = len;

              var a = 1732584193;
              var b = -271733879;
              var c = -1732584194;
              var d = 271733878;

              var olda, oldb, oldc, oldd;
              for (var i = 0; i < x.length; i += 16) {
                olda = a;
                oldb = b;
                oldc = c;
                oldd = d;

                a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
                d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
                c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
                b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
                a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
                d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
                c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
                b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
                a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
                d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
                c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
                b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
                a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
                d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
                c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
                b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

                a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
                d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
                c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
                b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
                a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
                d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
                c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
                b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
                a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
                d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
                c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
                b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
                a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
                d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
                c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
                b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

                a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
                d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
                c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
                b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
                a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
                d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
                c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
                b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
                a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
                d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
                c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
                b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
                a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
                d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
                c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
                b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

                a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
                d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
                c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
                b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
                a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
                d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
                c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
                b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
                a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
                d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
                c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
                b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
                a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
                d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
                c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
                b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

                a = safe_add(a, olda);
                b = safe_add(b, oldb);
                c = safe_add(c, oldc);
                d = safe_add(d, oldd);
              }
              return [a, b, c, d];
            };

            var obj = {
              /*
               * These are the functions you'll usually want to call.
               * They take string arguments and return either hex or base-64 encoded
               * strings.
               */
              hexdigest: function hexdigest(s) {
                return binl2hex(core_md5(str2binl(s), s.length * 8));
              },

              hash: function hash(s) {
                return binl2str(core_md5(str2binl(s), s.length * 8));
              }
            };

            return obj;
          }();

          /*
           This program is distributed under the terms of the MIT license.
           Please see the LICENSE file for details.
    
           Copyright 2006-2008, OGG, LLC
           */

          /* jshint undef: true, unused: true:, noarg: true, latedef: true */
          /*global document, window, setTimeout, clearTimeout, console,
           ActiveXObject, Base64, MD5, DOMParser */
          // from sha1.js
          /*global core_hmac_sha1, binb2str, str_hmac_sha1, str_sha1, b64_hmac_sha1*/

          /** File: strophe.js
           *  A JavaScript library for XMPP BOSH/XMPP over Websocket.
           *
           *  This is the JavaScript version of the Strophe library.  Since JavaScript
           *  had no facilities for persistent TCP connections, this library uses
           *  Bidirectional-streams Over Synchronous HTTP (BOSH) to emulate
           *  a persistent, stateful, two-way connection to an XMPP server.  More
           *  information on BOSH can be found in XEP 124.
           *
           *  This version of Strophe also works with WebSockets.
           *  For more information on XMPP-over WebSocket see this RFC draft:
           *  http://tools.ietf.org/html/draft-ietf-xmpp-websocket-00
           */

          /** PrivateFunction: Function.prototype.bind
           *  Bind a function to an instance.
           *
           *  This Function object extension method creates a bound method similar
           *  to those in Python.  This means that the 'this' object will point
           *  to the instance you want.  See
           *  <a href='https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Function/bind'>MDC's bind() documentation</a> and
           *  <a href='http://benjamin.smedbergs.us/blog/2007-01-03/bound-functions-and-function-imports-in-javascript/'>Bound Functions and Function Imports in JavaScript</a>
           *  for a complete explanation.
           *
           *  This extension already exists in some browsers (namely, Firefox 3), but
           *  we provide it to support those that don't.
           *
           *  Parameters:
           *    (Object) obj - The object that will become 'this' in the bound function.
           *    (Object) argN - An option argument that will be prepended to the
           *      arguments given for the function call
           *
           *  Returns:
           *    The bound function.
           */
          if (!Function.prototype.bind) {
            Function.prototype.bind = function (obj /*, arg1, arg2, ... */) {
              var func = this;
              var _slice = Array.prototype.slice;
              var _concat = Array.prototype.concat;
              var _args = _slice.call(arguments, 1);

              return function () {
                return func.apply(obj ? obj : this, _concat.call(_args, _slice.call(arguments, 0)));
              };
            };
          }

          /** PrivateFunction: Array.prototype.indexOf
           *  Return the index of an object in an array.
           *
           *  This function is not supplied by some JavaScript implementations, so
           *  we provide it if it is missing.  This code is from:
           *  http://developer.mozilla.org/En/Core_JavaScript_1.5_Reference:Objects:Array:indexOf
           *
           *  Parameters:
           *    (Object) elt - The object to look for.
           *    (Integer) from - The index from which to start looking. (optional).
           *
           *  Returns:
           *    The index of elt in the array or -1 if not found.
           */
          if (!Array.prototype.indexOf) {
            Array.prototype.indexOf = function (elt /*, from*/) {
              var len = this.length;

              var from = Number(arguments[1]) || 0;
              from = from < 0 ? Math.ceil(from) : Math.floor(from);
              if (from < 0) {
                from += len;
              }

              for (; from < len; from++) {
                if (from in this && this[from] === elt) {
                  return from;
                }
              }

              return -1;
            };
          }

          var Strophe, $build, $msg, $iq, $pres;

          /* All of the Strophe globals are defined in this special function below so
           * that references to the globals become closures.  This will ensure that
           * on page reload, these references will still be available to callbacks
           * that are still executing.
           */

          (function (callback) {

            /** Function: $build
             *  Create a Strophe.Builder.
             *  This is an alias for 'new Strophe.Builder(name, attrs)'.
             *
             *  Parameters:
             *    (String) name - The root element name.
             *    (Object) attrs - The attributes for the root element in object notation.
             *
             *  Returns:
             *    A new Strophe.Builder object.
             */
            function $build(name, attrs) {
              return new Strophe.Builder(name, attrs);
            }

            /** Function: $msg
             *  Create a Strophe.Builder with a <message/> element as the root.
             *
             *  Parmaeters:
             *    (Object) attrs - The <message/> element attributes in object notation.
             *
             *  Returns:
             *    A new Strophe.Builder object.
             */
            function $msg(attrs) {
              return new Strophe.Builder("message", attrs);
            }

            /** Function: $iq
             *  Create a Strophe.Builder with an <iq/> element as the root.
             *
             *  Parameters:
             *    (Object) attrs - The <iq/> element attributes in object notation.
             *
             *  Returns:
             *    A new Strophe.Builder object.
             */
            function $iq(attrs) {
              return new Strophe.Builder("iq", attrs);
            }

            /** Function: $pres
             *  Create a Strophe.Builder with a <presence/> element as the root.
             *
             *  Parameters:
             *    (Object) attrs - The <presence/> element attributes in object notation.
             *
             *  Returns:
             *    A new Strophe.Builder object.
             */
            function $pres(attrs) {
              return new Strophe.Builder("presence", attrs);
            }

            /** Class: Strophe
             *  An object container for all Strophe library functions.
             *
             *  This class is just a container for all the objects and constants
             *  used in the library.  It is not meant to be instantiated, but to
             *  provide a namespace for library objects, constants, and functions.
             */
            Strophe = {
              /** Constant: VERSION
               *  The version of the Strophe library. Unreleased builds will have
               *  a version of head-HASH where HASH is a partial revision.
               */
              VERSION: "1.1.3",

              /** Constants: XMPP Namespace Constants
               *  Common namespace constants from the XMPP RFCs and XEPs.
               *
               *  NS.HTTPBIND - HTTP BIND namespace from XEP 124.
               *  NS.BOSH - BOSH namespace from XEP 206.
               *  NS.CLIENT - Main XMPP client namespace.
               *  NS.AUTH - Legacy authentication namespace.
               *  NS.ROSTER - Roster operations namespace.
               *  NS.PROFILE - Profile namespace.
               *  NS.DISCO_INFO - Service discovery info namespace from XEP 30.
               *  NS.DISCO_ITEMS - Service discovery items namespace from XEP 30.
               *  NS.MUC - Multi-User Chat namespace from XEP 45.
               *  NS.SASL - XMPP SASL namespace from RFC 3920.
               *  NS.STREAM - XMPP Streams namespace from RFC 3920.
               *  NS.BIND - XMPP Binding namespace from RFC 3920.
               *  NS.SESSION - XMPP Session namespace from RFC 3920.
               *  NS.XHTML_IM - XHTML-IM namespace from XEP 71.
               *  NS.XHTML - XHTML body namespace from XEP 71.
               */
              NS: {
                HTTPBIND: "http://jabber.org/protocol/httpbind",
                BOSH: "urn:xmpp:xbosh",
                CLIENT: "jabber:client",
                AUTH: "jabber:iq:auth",
                ROSTER: "jabber:iq:roster",
                PROFILE: "jabber:iq:profile",
                DISCO_INFO: "http://jabber.org/protocol/disco#info",
                DISCO_ITEMS: "http://jabber.org/protocol/disco#items",
                MUC: "http://jabber.org/protocol/muc",
                SASL: "urn:ietf:params:xml:ns:xmpp-sasl",
                STREAM: "http://etherx.jabber.org/streams",
                BIND: "urn:ietf:params:xml:ns:xmpp-bind",
                PING: "urn:xmpp:ping",
                SESSION: "urn:ietf:params:xml:ns:xmpp-session",
                VERSION: "jabber:iq:version",
                STANZAS: "urn:ietf:params:xml:ns:xmpp-stanzas",
                XHTML_IM: "http://jabber.org/protocol/xhtml-im",
                XHTML: "http://www.w3.org/1999/xhtml"
              },

              /** Constants: XHTML_IM Namespace
               *  contains allowed tags, tag attributes, and css properties.
               *  Used in the createHtml function to filter incoming html into the allowed XHTML-IM subset.
               *  See http://xmpp.org/extensions/xep-0071.html#profile-summary for the list of recommended
               *  allowed tags and their attributes.
               */
              XHTML: {
                tags: ['a', 'blockquote', 'br', 'cite', 'em', 'img', 'li', 'ol', 'p', 'span', 'strong', 'ul', 'body'],
                attributes: {
                  'a': ['href'],
                  'blockquote': ['style'],
                  'br': [],
                  'cite': ['style'],
                  'em': [],
                  'img': ['src', 'alt', 'style', 'height', 'width'],
                  'li': ['style'],
                  'ol': ['style'],
                  'p': ['style'],
                  'span': ['style'],
                  'strong': [],
                  'ul': ['style'],
                  'body': []
                },
                css: ['background-color', 'color', 'font-family', 'font-size', 'font-style', 'font-weight', 'margin-left', 'margin-right', 'text-align', 'text-decoration'],
                validTag: function validTag(tag) {
                  for (var i = 0; i < Strophe.XHTML.tags.length; i++) {
                    if (tag == Strophe.XHTML.tags[i]) {
                      return true;
                    }
                  }
                  return false;
                },
                validAttribute: function validAttribute(tag, attribute) {
                  if (typeof Strophe.XHTML.attributes[tag] !== 'undefined' && Strophe.XHTML.attributes[tag].length > 0) {
                    for (var i = 0; i < Strophe.XHTML.attributes[tag].length; i++) {
                      if (attribute == Strophe.XHTML.attributes[tag][i]) {
                        return true;
                      }
                    }
                  }
                  return false;
                },
                validCSS: function validCSS(style) {
                  for (var i = 0; i < Strophe.XHTML.css.length; i++) {
                    if (style == Strophe.XHTML.css[i]) {
                      return true;
                    }
                  }
                  return false;
                }
              },

              /** Constants: Connection Status Constants
               *  Connection status constants for use by the connection handler
               *  callback.
               *
               *  Status.ERROR - An error has occurred
               *  Status.CONNECTING - The connection is currently being made
               *  Status.CONNFAIL - The connection attempt failed
               *  Status.AUTHENTICATING - The connection is authenticating
               *  Status.AUTHFAIL - The authentication attempt failed
               *  Status.CONNECTED - The connection has succeeded
               *  Status.DISCONNECTED - The connection has been terminated
               *  Status.DISCONNECTING - The connection is currently being terminated
               *  Status.ATTACHED - The connection has been attached
               */
              Status: {
                ERROR: 0,
                CONNECTING: 1,
                CONNFAIL: 2,
                AUTHENTICATING: 3,
                AUTHFAIL: 4,
                CONNECTED: 5,
                DISCONNECTED: 6,
                DISCONNECTING: 7,
                ATTACHED: 8
              },

              /** Constants: Log Level Constants
               *  Logging level indicators.
               *
               *  LogLevel.DEBUG - Debug output
               *  LogLevel.INFO - Informational output
               *  LogLevel.WARN - Warnings
               *  LogLevel.ERROR - Errors
               *  LogLevel.FATAL - Fatal errors
               */
              LogLevel: {
                DEBUG: 0,
                INFO: 1,
                WARN: 2,
                ERROR: 3,
                FATAL: 4
              },

              /** PrivateConstants: DOM Element Type Constants
               *  DOM element types.
               *
               *  ElementType.NORMAL - Normal element.
               *  ElementType.TEXT - Text data element.
               *  ElementType.FRAGMENT - XHTML fragment element.
               */
              ElementType: {
                NORMAL: 1,
                TEXT: 3,
                CDATA: 4,
                FRAGMENT: 11
              },

              /** PrivateConstants: Timeout Values
               *  Timeout values for error states.  These values are in seconds.
               *  These should not be changed unless you know exactly what you are
               *  doing.
               *
               *  TIMEOUT - Timeout multiplier. A waiting request will be considered
               *      failed after Math.floor(TIMEOUT * wait) seconds have elapsed.
               *      This defaults to 1.1, and with default wait, 66 seconds.
               *  SECONDARY_TIMEOUT - Secondary timeout multiplier. In cases where
               *      Strophe can detect early failure, it will consider the request
               *      failed if it doesn't return after
               *      Math.floor(SECONDARY_TIMEOUT * wait) seconds have elapsed.
               *      This defaults to 0.1, and with default wait, 6 seconds.
               */
              TIMEOUT: 1.1,
              SECONDARY_TIMEOUT: 0.1,

              /** Function: addNamespace
               *  This function is used to extend the current namespaces in
               *  Strophe.NS.  It takes a key and a value with the key being the
               *  name of the new namespace, with its actual value.
               *  For example:
               *  Strophe.addNamespace('PUBSUB', "http://jabber.org/protocol/pubsub");
               *
               *  Parameters:
               *    (String) name - The name under which the namespace will be
               *      referenced under Strophe.NS
               *    (String) value - The actual namespace.
               */
              addNamespace: function addNamespace(name, value) {
                Strophe.NS[name] = value;
              },

              /** Function: forEachChild
               *  Map a function over some or all child elements of a given element.
               *
               *  This is a small convenience function for mapping a function over
               *  some or all of the children of an element.  If elemName is null, all
               *  children will be passed to the function, otherwise only children
               *  whose tag names match elemName will be passed.
               *
               *  Parameters:
               *    (XMLElement) elem - The element to operate on.
               *    (String) elemName - The child element tag name filter.
               *    (Function) func - The function to apply to each child.  This
               *      function should take a single argument, a DOM element.
               */
              forEachChild: function forEachChild(elem, elemName, func) {
                var i, childNode;

                for (i = 0; i < elem.childNodes.length; i++) {
                  childNode = elem.childNodes[i];
                  if (childNode.nodeType == Strophe.ElementType.NORMAL && (!elemName || this.isTagEqual(childNode, elemName))) {
                    func(childNode);
                  }
                }
              },

              /** Function: isTagEqual
               *  Compare an element's tag name with a string.
               *
               *  This function is case insensitive.
               *
               *  Parameters:
               *    (XMLElement) el - A DOM element.
               *    (String) name - The element name.
               *
               *  Returns:
               *    true if the element's tag name matches _el_, and false
               *    otherwise.
               */
              isTagEqual: function isTagEqual(el, name) {
                return el.tagName == name;
              },

              /** PrivateVariable: _xmlGenerator
               *  _Private_ variable that caches a DOM document to
               *  generate elements.
               */
              _xmlGenerator: null,

              /** PrivateFunction: _makeGenerator
               *  _Private_ function that creates a dummy XML DOM document to serve as
               *  an element and text node generator.
               */
              _makeGenerator: function _makeGenerator() {
                var doc;
                var docImplementation = new __WEBPACK_IMPORTED_MODULE_1_xmldom___default.a.DOMImplementation();
                doc = docImplementation.createDocument('jabber:client', 'strophe', null);
                return doc;
              },

              /** Function: xmlGenerator
               *  Get the DOM document to generate elements.
               *
               *  Returns:
               *    The currently used DOM document.
               */
              xmlGenerator: function xmlGenerator() {
                if (!Strophe._xmlGenerator) {
                  Strophe._xmlGenerator = Strophe._makeGenerator();
                }
                return Strophe._xmlGenerator;
              },

              /** PrivateFunction: _getIEXmlDom
               *  Gets IE xml doc object
               *
               *  Returns:
               *    A Microsoft XML DOM Object
               *  See Also:
               *    http://msdn.microsoft.com/en-us/library/ms757837%28VS.85%29.aspx
               */
              _getIEXmlDom: function _getIEXmlDom() {
                var doc = null;
                var docStrings = ["Msxml2.DOMDocument.6.0", "Msxml2.DOMDocument.5.0", "Msxml2.DOMDocument.4.0", "MSXML2.DOMDocument.3.0", "MSXML2.DOMDocument", "MSXML.DOMDocument", "Microsoft.XMLDOM"];

                for (var d = 0; d < docStrings.length; d++) {
                  if (doc === null) {
                    try {
                      doc = new ActiveXObject(docStrings[d]);
                    } catch (e) {
                      doc = null;
                    }
                  } else {
                    break;
                  }
                }

                return doc;
              },

              /** Function: xmlElement
               *  Create an XML DOM element.
               *
               *  This function creates an XML DOM element correctly across all
               *  implementations. Note that these are not HTML DOM elements, which
               *  aren't appropriate for XMPP stanzas.
               *
               *  Parameters:
               *    (String) name - The name for the element.
               *    (Array|Object) attrs - An optional array or object containing
               *      key/value pairs to use as element attributes. The object should
               *      be in the format {'key': 'value'} or {key: 'value'}. The array
               *      should have the format [['key1', 'value1'], ['key2', 'value2']].
               *    (String) text - The text child data for the element.
               *
               *  Returns:
               *    A new XML DOM element.
               */
              xmlElement: function xmlElement(name) {
                if (!name) {
                  return null;
                }

                var node = Strophe.xmlGenerator().createElement(name);

                // FIXME: this should throw errors if args are the wrong type or
                // there are more than two optional args
                var a, i, k;
                for (a = 1; a < arguments.length; a++) {
                  if (!arguments[a]) {
                    continue;
                  }
                  if (typeof arguments[a] == "string" || typeof arguments[a] == "number") {
                    node.appendChild(Strophe.xmlTextNode(arguments[a]));
                  } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(arguments[a]) == "object" && typeof arguments[a].sort == "function") {
                    for (i = 0; i < arguments[a].length; i++) {
                      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(arguments[a][i]) == "object" && typeof arguments[a][i].sort == "function") {
                        node.setAttribute(arguments[a][i][0], arguments[a][i][1]);
                      }
                    }
                  } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(arguments[a]) == "object") {
                    for (k in arguments[a]) {
                      if (arguments[a].hasOwnProperty(k)) {
                        node.setAttribute(k, arguments[a][k]);
                      }
                    }
                  }
                }

                return node;
              },

              /*  Function: xmlescape
               *  Excapes invalid xml characters.
               *
               *  Parameters:
               *     (String) text - text to escape.
               *
               *  Returns:
               *      Escaped text.
               */
              xmlescape: function xmlescape(text) {
                text = text.replace(/\&/g, "&amp;");
                text = text.replace(/</g, "&lt;");
                text = text.replace(/>/g, "&gt;");
                text = text.replace(/'/g, "&apos;");
                text = text.replace(/"/g, "&quot;");
                return text;
              },

              /** Function: xmlTextNode
               *  Creates an XML DOM text node.
               *
               *  Provides a cross implementation version of document.createTextNode.
               *
               *  Parameters:
               *    (String) text - The content of the text node.
               *
               *  Returns:
               *    A new XML DOM text node.
               */
              xmlTextNode: function xmlTextNode(text) {
                return Strophe.xmlGenerator().createTextNode(text);
              },

              /** Function: xmlHtmlNode
               *  Creates an XML DOM html node.
               *
               *  Parameters:
               *    (String) html - The content of the html node.
               *
               *  Returns:
               *    A new XML DOM text node.
               */
              xmlHtmlNode: function xmlHtmlNode(html) {
                var node;
                //ensure text is escaped
                var parser = new DOMParser();
                node = parser.parseFromString(html, "text/xml");
                return node;
              },

              /** Function: getText
               *  Get the concatenation of all text children of an element.
               *
               *  Parameters:
               *    (XMLElement) elem - A DOM element.
               *
               *  Returns:
               *    A String with the concatenated text of all text element children.
               */
              getText: function getText(elem) {
                if (!elem) {
                  return null;
                }

                var str = "";
                if (elem.childNodes.length === 0 && elem.nodeType == Strophe.ElementType.TEXT) {
                  str += elem.nodeValue;
                }

                for (var i = 0; i < elem.childNodes.length; i++) {
                  if (elem.childNodes[i].nodeType == Strophe.ElementType.TEXT) {
                    str += elem.childNodes[i].nodeValue;
                  }
                }

                return Strophe.xmlescape(str);
              },

              /** Function: copyElement
               *  Copy an XML DOM element.
               *
               *  This function copies a DOM element and all its descendants and returns
               *  the new copy.
               *
               *  Parameters:
               *    (XMLElement) elem - A DOM element.
               *
               *  Returns:
               *    A new, copied DOM element tree.
               */
              copyElement: function copyElement(elem) {
                var i, el;
                if (elem.nodeType == Strophe.ElementType.NORMAL) {
                  el = Strophe.xmlElement(elem.tagName);

                  for (i = 0; i < elem.attributes.length; i++) {
                    el.setAttribute(elem.attributes[i].nodeName, elem.attributes[i].value);
                  }

                  for (i = 0; i < elem.childNodes.length; i++) {
                    el.appendChild(Strophe.copyElement(elem.childNodes[i]));
                  }
                } else if (elem.nodeType == Strophe.ElementType.TEXT) {
                  el = Strophe.xmlGenerator().createTextNode(elem.nodeValue);
                }

                return el;
              },

              /** Function: createHtml
               *  Copy an HTML DOM element into an XML DOM.
               *
               *  This function copies a DOM element and all its descendants and returns
               *  the new copy.
               *
               *  Parameters:
               *    (HTMLElement) elem - A DOM element.
               *
               *  Returns:
               *    A new, copied DOM element tree.
               */
              createHtml: function createHtml(elem) {
                var i, el, j, tag, attribute, value, css, cssAttrs, attr, cssName, cssValue;
                if (elem.nodeType == Strophe.ElementType.NORMAL) {
                  tag = elem.nodeName;
                  if (Strophe.XHTML.validTag(tag)) {
                    try {
                      el = Strophe.xmlElement(tag);
                      for (i = 0; i < Strophe.XHTML.attributes[tag].length; i++) {
                        attribute = Strophe.XHTML.attributes[tag][i];
                        value = elem.getAttribute(attribute);
                        if (typeof value == 'undefined' || value === null || value === '' || value === false || value === 0) {
                          continue;
                        }
                        if (attribute == 'style' && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) == 'object') {
                          if (typeof value.cssText != 'undefined') {
                            value = value.cssText; // we're dealing with IE, need to get CSS out
                          }
                        }
                        // filter out invalid css styles
                        if (attribute == 'style') {
                          css = [];
                          cssAttrs = value.split(';');
                          for (j = 0; j < cssAttrs.length; j++) {
                            attr = cssAttrs[j].split(':');
                            cssName = attr[0].replace(/^\s*/, "").replace(/\s*$/, "").toLowerCase();
                            if (Strophe.XHTML.validCSS(cssName)) {
                              cssValue = attr[1].replace(/^\s*/, "").replace(/\s*$/, "");
                              css.push(cssName + ': ' + cssValue);
                            }
                          }
                          if (css.length > 0) {
                            value = css.join('; ');
                            el.setAttribute(attribute, value);
                          }
                        } else {
                          el.setAttribute(attribute, value);
                        }
                      }

                      for (i = 0; i < elem.childNodes.length; i++) {
                        el.appendChild(Strophe.createHtml(elem.childNodes[i]));
                      }
                    } catch (e) {
                      // invalid elements
                      el = Strophe.xmlTextNode('');
                    }
                  } else {
                    el = Strophe.xmlGenerator().createDocumentFragment();
                    for (i = 0; i < elem.childNodes.length; i++) {
                      el.appendChild(Strophe.createHtml(elem.childNodes[i]));
                    }
                  }
                } else if (elem.nodeType == Strophe.ElementType.FRAGMENT) {
                  el = Strophe.xmlGenerator().createDocumentFragment();
                  for (i = 0; i < elem.childNodes.length; i++) {
                    el.appendChild(Strophe.createHtml(elem.childNodes[i]));
                  }
                } else if (elem.nodeType == Strophe.ElementType.TEXT) {
                  el = Strophe.xmlTextNode(elem.nodeValue);
                }

                return el;
              },

              /** Function: escapeNode
               *  Escape the node part (also called local part) of a JIDHOST.
               *
               *  Parameters:
               *    (String) node - A node (or local part).
               *
               *  Returns:
               *    An escaped node (or local part).
               */
              escapeNode: function escapeNode(node) {
                return node.replace(/^\s+|\s+$/g, '').replace(/\\/g, "\\5c").replace(/ /g, "\\20").replace(/\"/g, "\\22").replace(/\&/g, "\\26").replace(/\'/g, "\\27").replace(/\//g, "\\2f").replace(/:/g, "\\3a").replace(/</g, "\\3c").replace(/>/g, "\\3e").replace(/@/g, "\\40");
              },

              /** Function: unescapeNode
               *  Unescape a node part (also called local part) of a JIDHOST.
               *
               *  Parameters:
               *    (String) node - A node (or local part).
               *
               *  Returns:
               *    An unescaped node (or local part).
               */
              unescapeNode: function unescapeNode(node) {
                return node.replace(/\\20/g, " ").replace(/\\22/g, '"').replace(/\\26/g, "&").replace(/\\27/g, "'").replace(/\\2f/g, "/").replace(/\\3a/g, ":").replace(/\\3c/g, "<").replace(/\\3e/g, ">").replace(/\\40/g, "@").replace(/\\5c/g, "\\");
              },

              /** Function: getNodeFromJid
               *  Get the node portion of a JIDHOST String.
               *
               *  Parameters:
               *    (String) jid - A JIDHOST.
               *
               *  Returns:
               *    A String containing the node.
               */
              getNodeFromJid: function getNodeFromJid(jid) {
                if (jid.indexOf("@") < 0) {
                  return null;
                }
                return jid.split("@")[0];
              },

              /** Function: getDomainFromJid
               *  Get the domain portion of a JIDHOST String.
               *
               *  Parameters:
               *    (String) jid - A JIDHOST.
               *
               *  Returns:
               *    A String containing the domain.
               */
              getDomainFromJid: function getDomainFromJid(jid) {
                var bare = Strophe.getBareJidFromJid(jid);
                if (bare.indexOf("@") < 0) {
                  return bare;
                } else {
                  var parts = bare.split("@");
                  parts.splice(0, 1);
                  return parts.join('@');
                }
              },

              /** Function: getResourceFromJid
               *  Get the resource portion of a JIDHOST String.
               *
               *  Parameters:
               *    (String) jid - A JIDHOST.
               *
               *  Returns:
               *    A String containing the resource.
               */
              getResourceFromJid: function getResourceFromJid(jid) {
                var s = jid.split("/");
                if (s.length < 2) {
                  return null;
                }
                s.splice(0, 1);
                return s.join('/');
              },

              /** Function: getBareJidFromJid
               *  Get the bare JIDHOST from a JIDHOST String.
               *
               *  Parameters:
               *    (String) jid - A JIDHOST.
               *
               *  Returns:
               *    A String containing the bare JIDHOST.
               */
              getBareJidFromJid: function getBareJidFromJid(jid) {
                return jid ? jid.split("/")[0] : null;
              },

              /** Function: log
               *  User overrideable logging function.
               *
               *  This function is called whenever the Strophe library calls any
               *  of the logging functions.  The default implementation of this
               *  function does nothing.  If client code wishes to handle the logging
               *  messages, it should override this with
               *  > Strophe.log = function (level, msg) {
               *  >   (user code here)
               *  > };
               *
               *  Please note that data sent and received over the wire is logged
               *  via Strophe.Connection.rawInput() and Strophe.Connection.rawOutput().
               *
               *  The different levels and their meanings are
               *
               *    DEBUG - Messages useful for debugging purposes.
               *    INFO - Informational messages.  This is mostly information like
               *      'disconnect was called' or 'SASL auth succeeded'.
               *    WARN - Warnings about potential problems.  This is mostly used
               *      to report transient connection errors like request timeouts.
               *    ERROR - Some error occurred.
               *    FATAL - A non-recoverable fatal error occurred.
               *
               *  Parameters:
               *    (Integer) level - The log level of the log message.  This will
               *      be one of the values in Strophe.LogLevel.
               *    (String) msg - The log message.
               */
              /* jshint ignore:start */
              log: function log(level, msg) {
                //console.log(level,msg);
                return;
              },
              /* jshint ignore:end */

              /** Function: debug
               *  Log a message at the Strophe.LogLevel.DEBUG level.
               *
               *  Parameters:
               *    (String) msg - The log message.
               */
              debug: function debug(msg) {
                this.log(this.LogLevel.DEBUG, msg);
              },

              /** Function: info
               *  Log a message at the Strophe.LogLevel.INFO level.
               *
               *  Parameters:
               *    (String) msg - The log message.
               */
              info: function info(msg) {
                this.log(this.LogLevel.INFO, msg);
              },

              /** Function: warn
               *  Log a message at the Strophe.LogLevel.WARN level.
               *
               *  Parameters:
               *    (String) msg - The log message.
               */
              warn: function warn(msg) {
                this.log(this.LogLevel.WARN, msg);
              },

              /** Function: error
               *  Log a message at the Strophe.LogLevel.ERROR level.
               *
               *  Parameters:
               *    (String) msg - The log message.
               */
              error: function error(msg) {
                this.log(this.LogLevel.ERROR, msg);
              },

              /** Function: fatal
               *  Log a message at the Strophe.LogLevel.FATAL level.
               *
               *  Parameters:
               *    (String) msg - The log message.
               */
              fatal: function fatal(msg) {
                this.log(this.LogLevel.FATAL, msg);
              },

              /** Function: serialize
               *  Render a DOM element and all descendants to a String.
               *
               *  Parameters:
               *    (XMLElement) elem - A DOM element.
               *
               *  Returns:
               *    The serialized element tree as a String.
               */
              serialize: function serialize(elem) {
                var result;
                //debugger
                if (!elem) {
                  return null;
                }

                if (typeof elem.tree === "function") {
                  elem = elem.tree();
                }

                var nodeName = elem.nodeName;
                var i, child;

                if (elem.getAttribute("_realname")) {
                  nodeName = elem.getAttribute("_realname");
                }

                result = "<" + nodeName;
                for (i = 0; i < elem.attributes.length; i++) {
                  if (elem.attributes[i].nodeName != "_realname") {
                    result += " " + elem.attributes[i].nodeName + "='" + elem.attributes[i].value.replace(/&/g, "&amp;").replace(/\'/g, "&apos;").replace(/>/g, "&gt;").replace(/</g, "&lt;") + "'";
                  }
                }

                if (elem.childNodes.length > 0) {
                  result += ">";
                  for (i = 0; i < elem.childNodes.length; i++) {
                    child = elem.childNodes[i];
                    switch (child.nodeType) {
                      case Strophe.ElementType.NORMAL:
                        // normal element, so recurse
                        result += Strophe.serialize(child);
                        break;
                      case Strophe.ElementType.TEXT:
                        // text element to escape values
                        result += Strophe.xmlescape(child.nodeValue);
                        break;
                      case Strophe.ElementType.CDATA:
                        // cdata section so don't escape values
                        result += "<![CDATA[" + child.nodeValue + "]]>";
                    }
                  }
                  result += "</" + nodeName + ">";
                } else {
                  result += "/>";
                }
                // debugger
                return result;
              },

              /** PrivateVariable: _requestId
               *  _Private_ variable that keeps track of the request ids for
               *  connections.
               */
              _requestId: 0,

              /** PrivateVariable: Strophe.connectionPlugins
               *  _Private_ variable Used to store plugin names that need
               *  initialization on Strophe.Connection construction.
               */
              _connectionPlugins: {},

              /** Function: addConnectionPlugin
               *  Extends the Strophe.Connection object with the given plugin.
               *
               *  Parameters:
               *    (String) name - The name of the extension.
               *    (Object) ptype - The plugin's prototype.
               */
              addConnectionPlugin: function addConnectionPlugin(name, ptype) {
                Strophe._connectionPlugins[name] = ptype;
              }
            };

            /** Class: Strophe.Builder
             *  XML DOM builder.
             *
             *  This object provides an interface similar to JQuery but for building
             *  DOM element easily and rapidly.  All the functions except for toString()
             *  and tree() return the object, so calls can be chained.  Here's an
             *  example using the $iq() builder helper.
             *  > $iq({to: 'you', from: 'me', type: 'get', id: '1'})
             *  >     .c('query', {xmlns: 'strophe:example'})
             *  >     .c('example')
             *  >     .toString()
             *  The above generates this XML fragment
             *  > <iq to='you' from='me' type='get' id='1'>
             *  >   <query xmlns='strophe:example'>
             *  >     <example/>
             *  >   </query>
             *  > </iq>
             *  The corresponding DOM manipulations to get a similar fragment would be
             *  a lot more tedious and probably involve several helper variables.
             *
             *  Since adding children makes new operations operate on the child, up()
             *  is provided to traverse up the tree.  To add two children, do
             *  > builder.c('child1', ...).up().c('child2', ...)
             *  The next operation on the Builder will be relative to the second child.
             */

            /** Constructor: Strophe.Builder
             *  Create a Strophe.Builder object.
             *
             *  The attributes should be passed in object notation.  For example
             *  > var b = new Builder('message', {to: 'you', from: 'me'});
             *  or
             *  > var b = new Builder('messsage', {'xml:lang': 'en'});
             *
             *  Parameters:
             *    (String) name - The name of the root element.
             *    (Object) attrs - The attributes for the root element in object notation.
             *
             *  Returns:
             *    A new Strophe.Builder.
             */
            Strophe.Builder = function (name, attrs) {
              // Set correct namespace for jabber:client elements
              if (name == "presence" || name == "message" || name == "iq") {
                if (attrs && !attrs.xmlns) {
                  attrs.xmlns = Strophe.NS.CLIENT;
                } else if (!attrs) {
                  attrs = {
                    xmlns: Strophe.NS.CLIENT
                  };
                }
              }

              // Holds the tree being built.
              this.nodeTree = Strophe.xmlElement(name, attrs);

              // Points to the current operation node.
              this.node = this.nodeTree;
            };

            Strophe.Builder.prototype = {
              /** Function: tree
               *  Return the DOM tree.
               *
               *  This function returns the current DOM tree as an element object.  This
               *  is suitable for passing to functions like Strophe.Connection.send().
               *
               *  Returns:
               *    The DOM tree as a element object.
               */
              tree: function tree() {
                return this.nodeTree;
              },

              /** Function: toString
               *  Serialize the DOM tree to a String.
               *
               *  This function returns a string serialization of the current DOM
               *  tree.  It is often used internally to pass data to a
               *  Strophe.Request object.
               *
               *  Returns:
               *    The serialized DOM tree in a String.
               */
              toString: function toString() {
                return Strophe.serialize(this.nodeTree);
              },

              /** Function: up
               *  Make the current parent element the new current element.
               *
               *  This function is often used after c() to traverse back up the tree.
               *  For example, to add two children to the same element
               *  > builder.c('child1', {}).up().c('child2', {});
               *
               *  Returns:
               *    The Stophe.Builder object.
               */
              up: function up() {
                this.node = this.node.parentNode;
                return this;
              },

              /** Function: attrs
               *  Add or modify attributes of the current element.
               *
               *  The attributes should be passed in object notation.  This function
               *  does not move the current element pointer.
               *
               *  Parameters:
               *    (Object) moreattrs - The attributes to add/modify in object notation.
               *
               *  Returns:
               *    The Strophe.Builder object.
               */
              attrs: function attrs(moreattrs) {
                for (var k in moreattrs) {
                  if (moreattrs.hasOwnProperty(k)) {
                    this.node.setAttribute(k, moreattrs[k]);
                  }
                }
                return this;
              },

              /** Function: c
               *  Add a child to the current element and make it the new current
               *  element.
               *
               *  This function moves the current element pointer to the child,
               *  unless text is provided.  If you need to add another child, it
               *  is necessary to use up() to go back to the parent in the tree.
               *
               *  Parameters:
               *    (String) name - The name of the child.
               *    (Object) attrs - The attributes of the child in object notation.
               *    (String) text - The text to add to the child.
               *
               *  Returns:
               *    The Strophe.Builder object.
               */
              c: function c(name, attrs, text) {
                var child = Strophe.xmlElement(name, attrs, text);
                this.node.appendChild(child);
                if (!text) {
                  this.node = child;
                }
                return this;
              },

              /** Function: cnode
               *  Add a child to the current element and make it the new current
               *  element.
               *
               *  This function is the same as c() except that instead of using a
               *  name and an attributes object to create the child it uses an
               *  existing DOM element object.
               *
               *  Parameters:
               *    (XMLElement) elem - A DOM element.
               *
               *  Returns:
               *    The Strophe.Builder object.
               */
              cnode: function cnode(elem) {
                var impNode;
                var xmlGen = Strophe.xmlGenerator();
                try {
                  impNode = xmlGen.importNode !== undefined;
                } catch (e) {
                  impNode = false;
                }
                var newElem = impNode ? xmlGen.importNode(elem, true) : Strophe.copyElement(elem);
                this.node.appendChild(newElem);
                this.node = newElem;
                return this;
              },

              /** Function: t
               *  Add a child text element.
               *
               *  This *does not* make the child the new current element since there
               *  are no children of text elements.
               *
               *  Parameters:
               *    (String) text - The text data to append to the current element.
               *
               *  Returns:
               *    The Strophe.Builder object.
               */
              t: function t(text) {
                var child = Strophe.xmlTextNode(text);
                this.node.appendChild(child);
                return this;
              },

              /** Function: h
               *  Replace current element contents with the HTML passed in.
               *
               *  This *does not* make the child the new current element
               *
               *  Parameters:
               *    (String) html - The html to insert as contents of current element.
               *
               *  Returns:
               *    The Strophe.Builder object.
               */
              h: function h(html) {
                var fragment = Strophe.xmlGenerator().createElement('body');

                // force the browser to try and fix any invalid HTML tags
                fragment.innerHTML = html;

                // copy cleaned html into an xml dom
                var xhtml = Strophe.createHtml(fragment);

                while (xhtml.childNodes.length > 0) {
                  this.node.appendChild(xhtml.childNodes[0]);
                }
                return this;
              }
            };

            /** PrivateClass: Strophe.Handler
             *  _Private_ helper class for managing stanza handlers.
             *
             *  A Strophe.Handler encapsulates a user provided callback function to be
             *  executed when matching stanzas are received by the connection.
             *  Handlers can be either one-off or persistant depending on their
             *  return value. Returning true will cause a Handler to remain active, and
             *  returning false will remove the Handler.
             *
             *  Users will not use Strophe.Handler objects directly, but instead they
             *  will use Strophe.Connection.addHandler() and
             *  Strophe.Connection.deleteHandler().
             */

            /** PrivateConstructor: Strophe.Handler
             *  Create and initialize a new Strophe.Handler.
             *
             *  Parameters:
             *    (Function) handler - A function to be executed when the handler is run.
             *    (String) ns - The namespace to match.
             *    (String) name - The element name to match.
             *    (String) type - The element type to match.
             *    (String) id - The element id attribute to match.
             *    (String) from - The element from attribute to match.
             *    (Object) options - Handler options
             *
             *  Returns:
             *    A new Strophe.Handler object.
             */
            Strophe.Handler = function (handler, ns, name, type, id, from, options) {
              this.handler = handler;
              this.ns = ns;
              this.name = name;
              this.type = type;
              this.id = id;
              this.options = options || {
                matchBare: false
              };

              // default matchBare to false if undefined
              if (!this.options.matchBare) {
                this.options.matchBare = false;
              }

              if (this.options.matchBare) {
                this.from = from ? Strophe.getBareJidFromJid(from) : null;
              } else {
                this.from = from;
              }

              // whether the handler is a user handler or a system handler
              this.user = true;
            };

            Strophe.Handler.prototype = {
              /** PrivateFunction: isMatch
               *  Tests if a stanza matches the Strophe.Handler.
               *
               *  Parameters:
               *    (XMLElement) elem - The XML element to test.
               *
               *  Returns:
               *    true if the stanza matches and false otherwise.
               */
              isMatch: function isMatch(elem) {
                var nsMatch;
                var from = null;

                if (this.options.matchBare) {
                  from = Strophe.getBareJidFromJid(elem.getAttribute('from'));
                } else {
                  from = elem.getAttribute('from');
                }

                nsMatch = false;
                if (!this.ns) {
                  nsMatch = true;
                } else {
                  var that = this;
                  Strophe.forEachChild(elem, null, function (elem) {
                    if (elem.getAttribute("xmlns") == that.ns) {
                      nsMatch = true;
                    }
                  });

                  nsMatch = nsMatch || elem.getAttribute("xmlns") == this.ns;
                }

                if (nsMatch && (!this.name || Strophe.isTagEqual(elem, this.name)) && (!this.type || elem.getAttribute("type") == this.type) && (!this.id || elem.getAttribute("id") == this.id) && (!this.from || from == this.from)) {
                  return true;
                }

                return false;
              },

              /** PrivateFunction: run
               *  Run the callback on a matching stanza.
               *
               *  Parameters:
               *    (XMLElement) elem - The DOM element that triggered the
               *      Strophe.Handler.
               *
               *  Returns:
               *    A boolean indicating if the handler should remain active.
               */
              run: function run(elem) {
                var result = null;
                try {
                  result = this.handler(elem);
                } catch (e) {
                  if (e.sourceURL) {
                    Strophe.fatal("error: " + this.handler + " " + e.sourceURL + ":" + e.line + " - " + e.name + ": " + e.message);
                  } else if (e.fileName) {
                    if (typeof console != "undefined") {
                      console.trace();
                      console.error(this.handler, " - error - ", e, e.message);
                    }
                    Strophe.fatal("error: " + this.handler + " " + e.fileName + ":" + e.lineNumber + " - " + e.name + ": " + e.message);
                  } else {
                    Strophe.fatal("error: " + e.message + "\n" + e.stack);
                  }

                  throw e;
                }

                return result;
              },

              /** PrivateFunction: toString
               *  Get a String representation of the Strophe.Handler object.
               *
               *  Returns:
               *    A String.
               */
              toString: function toString() {
                return "{Handler: " + this.handler + "(" + this.name + "," + this.id + "," + this.ns + ")}";
              }
            };

            /** PrivateClass: Strophe.TimedHandler
             *  _Private_ helper class for managing timed handlers.
             *
             *  A Strophe.TimedHandler encapsulates a user provided callback that
             *  should be called after a certain period of time or at regular
             *  intervals.  The return value of the callback determines whether the
             *  Strophe.TimedHandler will continue to fire.
             *
             *  Users will not use Strophe.TimedHandler objects directly, but instead
             *  they will use Strophe.Connection.addTimedHandler() and
             *  Strophe.Connection.deleteTimedHandler().
             */

            /** PrivateConstructor: Strophe.TimedHandler
             *  Create and initialize a new Strophe.TimedHandler object.
             *
             *  Parameters:
             *    (Integer) period - The number of milliseconds to wait before the
             *      handler is called.
             *    (Function) handler - The callback to run when the handler fires.  This
             *      function should take no arguments.
             *
             *  Returns:
             *    A new Strophe.TimedHandler object.
             */
            Strophe.TimedHandler = function (period, handler) {
              this.period = period;
              this.handler = handler;

              this.lastCalled = new Date().getTime();
              this.user = true;
            };

            Strophe.TimedHandler.prototype = {
              /** PrivateFunction: run
               *  Run the callback for the Strophe.TimedHandler.
               *
               *  Returns:
               *    true if the Strophe.TimedHandler should be called again, and false
               *      otherwise.
               */
              run: function run() {
                this.lastCalled = new Date().getTime();
                return this.handler();
              },

              /** PrivateFunction: reset
               *  Reset the last called time for the Strophe.TimedHandler.
               */
              reset: function reset() {
                this.lastCalled = new Date().getTime();
              },

              /** PrivateFunction: toString
               *  Get a string representation of the Strophe.TimedHandler object.
               *
               *  Returns:
               *    The string representation.
               */
              toString: function toString() {
                return "{TimedHandler: " + this.handler + "(" + this.period + ")}";
              }
            };

            /** Class: Strophe.Connection
             *  XMPP Connection manager.
             *
             *  This class is the main part of Strophe.  It manages a BOSH connection
             *  to an XMPP server and dispatches events to the user callbacks as
             *  data arrives.  It supports SASL PLAIN, SASL DIGEST-MD5, SASL SCRAM-SHA1
             *  and legacy authentication.
             *
             *  After creating a Strophe.Connection object, the user will typically
             *  call connect() with a user supplied callback to handle connection level
             *  events like authentication failure, disconnection, or connection
             *  complete.
             *
             *  The user will also have several event handlers defined by using
             *  addHandler() and addTimedHandler().  These will allow the user code to
             *  respond to interesting stanzas or do something periodically with the
             *  connection.  These handlers will be active once authentication is
             *  finished.
             *
             *  To send data to the connection, use send().
             */

            /** Constructor: Strophe.Connection
             *  Create and initialize a Strophe.Connection object.
             *
             *  The transport-protocol for this connection will be chosen automatically
             *  based on the given service parameter. URLs starting with "ws://" or
             *  "wss://" will use WebSockets, URLs starting with "http://", "https://"
             *  or without a protocol will use BOSH.
             *
             *  To make Strophe connect to the current host you can leave out the protocol
             *  and host part and just pass the path, e.g.
             *
             *  > var conn = new Strophe.Connection("/http-bind/");
             *
             *  WebSocket options:
             *
             *  If you want to connect to the current host with a WebSocket connection you
             *  can tell Strophe to use WebSockets through a "protocol" attribute in the
             *  optional options parameter. Valid values are "ws" for WebSocket and "wss"
             *  for Secure WebSocket.
             *  So to connect to "wss://CURRENT_HOSTNAME/xmpp-websocket" you would call
             *
             *  > var conn = new Strophe.Connection("/xmpp-websocket/", {protocol: "wss"});
             *
             *  Note that relative URLs _NOT_ starting with a "/" will also include the path
             *  of the current site.
             *
             *  Also because downgrading security is not permitted by browsers, when using
             *  relative URLs both BOSH and WebSocket connections will use their secure
             *  variants if the current connection to the site is also secure (https).
             *
             *  BOSH options:
             *
             *  by adding "sync" to the options, you can control if requests will
             *  be made synchronously or not. The default behaviour is asynchronous.
             *  If you want to make requests synchronous, make "sync" evaluate to true:
             *  > var conn = new Strophe.Connection("/http-bind/", {sync: true});
             *  You can also toggle this on an already established connection:
             *  > conn.options.sync = true;
             *
             *
             *  Parameters:
             *    (String) service - The BOSH or WebSocket service URL.
             *    (Object) options - A hash of configuration options
             *
             *  Returns:
             *    A new Strophe.Connection object.
             */
            // Strophe.Connection = function (service, loginservice, options)
            Strophe.Connection = function (service, options) {

              // @author Michael.Lee
              // @description 将loginservice地址设置到loginservice上去
              this.loginservice = service;
              this.baseservice = service;

              // The service URL
              this.service = service;

              // Configuration options
              this.options = options || {};
              var proto = this.options.protocol || "";

              // Select protocal based on service or options
              if (service.indexOf("ws:") === 0 || service.indexOf("wss:") === 0 || proto.indexOf("ws") === 0) {
                this._proto = new Strophe.Websocket(this);
              }
              /* The connected JIDHOST. */
              this.jid = "";
              /* the JIDs domain */
              this.domain = null;
              /* stream:features */
              this.features = null;

              // SASL
              this._sasl_data = {};
              this.do_session = false;
              this.do_bind = false;

              // handler lists
              this.timedHandlers = [];
              this.handlers = [];
              this.removeTimeds = [];
              this.removeHandlers = [];
              this.addTimeds = [];
              this.addHandlers = [];

              this._authentication = {};
              this._idleTimeout = null;
              this._disconnectTimeout = null;

              this.do_authentication = true;
              this.authenticated = false;
              this.disconnecting = false;
              this.connected = false;

              this.paused = false;

              this._data = [];
              this._uniqueId = 0;

              this._sasl_success_handler = null;
              this._sasl_failure_handler = null;
              this._sasl_challenge_handler = null;

              // Max retries before disconnecting
              this.maxRetries = 5;

              // setup onIdle callback every 1/10th of a second
              this._idleTimeout = setTimeout(this._onIdle.bind(this), 100);

              // initialize plugins
              for (var k in Strophe._connectionPlugins) {
                if (Strophe._connectionPlugins.hasOwnProperty(k)) {
                  var ptype = Strophe._connectionPlugins[k];
                  // jslint complaints about the below line, but this is fine
                  var F = function F() { }; // jshint ignore:line
                  F.prototype = ptype;
                  this[k] = new F();
                  this[k].init(this);
                }
              }
            };

            Strophe.Connection.prototype = {
              /** Function: reset
               *  Reset the connection.
               *
               *  This function should be called after a connection is disconnected
               *  before that connection is reused.
               */
              reset: function reset() {
                this._proto._reset();

                // SASL
                this.do_session = false;
                this.do_bind = false;

                // handler lists
                this.timedHandlers = [];
                this.handlers = [];
                this.removeTimeds = [];
                this.removeHandlers = [];
                this.addTimeds = [];
                this.addHandlers = [];
                this._authentication = {};

                this.authenticated = false;
                this.disconnecting = false;
                this.connected = false;

                this._requests = [];
                this._uniqueId = 0;
              },

              /** Function: pause
               *  Pause the request manager.
               *
               *  This will prevent Strophe from sending any more requests to the
               *  server.  This is very useful for temporarily pausing
               *  BOSH-Connections while a lot of send() calls are happening quickly.
               *  This causes Strophe to send the data in a single request, saving
               *  many request trips.
               */
              pause: function pause() {
                this.paused = true;
              },

              /** Function: resume
               *  Resume the request manager.
               *
               *  This resumes after pause() has been called.
               */
              resume: function resume() {
                this.paused = false;
              },

              /** Function: getUniqueId
               *  Generate a unique ID for use in <iq/> elements.
               *
               *  All <iq/> stanzas are required to have unique id attributes.  This
               *  function makes creating these easy.  Each connection instance has
               *  a counter which starts from zero, and the value of this counter
               *  plus a colon followed by the suffix becomes the unique id. If no
               *  suffix is supplied, the counter is used as the unique id.
               *
               *  Suffixes are used to make debugging easier when reading the stream
               *  data, and their use is recommended.  The counter resets to 0 for
               *  every new connection for the same reason.  For connections to the
               *  same server that authenticate the same way, all the ids should be
               *  the same, which makes it easy to see changes.  This is useful for
               *  automated testing as well.
               *
               *  Parameters:
               *    (String) suffix - A optional suffix to append to the id.
               *
               *  Returns:
               *    A unique string to be used for the id attribute.
               */
              getUniqueId: function getUniqueId(suffix) {
                if (typeof suffix == "string" || typeof suffix == "number") {
                  return ++this._uniqueId + ":" + suffix;
                } else {
                  return ++this._uniqueId + "";
                }
              },

              /** Function: connect
               *  Starts the connection process.
               *
               *  As the connection process proceeds, the user supplied callback will
               *  be triggered multiple times with status updates.  The callback
               *  should take two arguments - the status code and the error condition.
               *
               *  The status code will be one of the values in the Strophe.Status
               *  constants.  The error condition will be one of the conditions
               *  defined in RFC 3920 or the condition 'strophe-parsererror'.
               *
               *  The Parameters _wait_, _hold_ and _route_ are optional and only relevant
               *  for BOSH connections. Please see XEP 124 for a more detailed explanation
               *  of the optional parameters.
               *
               *  Parameters:
               *    (String) jid - The user's JIDHOST.  This may be a bare JIDHOST,
               *      or a full JIDHOST.  If a node is not supplied, SASL ANONYMOUS
               *      authentication will be attempted.
               *    (String) pass - The user's password.
               *    (Function) callback - The connect callback function.
               *    (Integer) wait - The optional HTTPBIND wait value.  This is the
               *      time the server will wait before returning an empty result for
               *      a request.  The default setting of 60 seconds is recommended.
               *    (Integer) hold - The optional HTTPBIND hold value.  This is the
               *      number of connections the server will hold at one time.  This
               *      should almost always be set to 1 (the default).
               *    (String) route - The optional route value.
               */
              connect: function connect(jid, pass, callback, wait, hold, route) {
                this.jid = jid;
                /** Variable: authzid
                 *  Authorization identity.
                 */
                this.authzid = Strophe.getBareJidFromJid(this.jid);
                /** Variable: authcid
                 *  Authentication identity (User name).
                 */
                this.authcid = Strophe.getNodeFromJid(this.jid);
                /** Variable: pass
                 *  Authentication identity (User password).
                 */
                this.pass = pass;
                /** Variable: servtype
                 *  Digest MD5 compatibility.
                 */
                this.servtype = "xmpp";
                this.connect_callback = callback;
                this.disconnecting = false;
                this.connected = false;
                this.authenticated = false;

                // parse jid for domain
                this.domain = Strophe.getDomainFromJid(this.jid);

                this._changeConnectStatus(Strophe.Status.CONNECTING, null);

                this._proto._connect(wait, hold, route);
              },

              /** Function: attach
               *  Attach to an already created and authenticated BOSH session.
               *
               *  This function is provided to allow Strophe to attach to BOSH
               *  sessions which have been created externally, perhaps by a Web
               *  application.  This is often used to support auto-login type features
               *  without putting user credentials into the page.
               *
               *  Parameters:
               *    (String) jid - The full JIDHOST that is bound by the session.
               *    (String) sid - The SID of the BOSH session.
               *    (String) rid - The current RID of the BOSH session.  This RID
               *      will be used by the next request.
               *    (Function) callback The connect callback function.
               *    (Integer) wait - The optional HTTPBIND wait value.  This is the
               *      time the server will wait before returning an empty result for
               *      a request.  The default setting of 60 seconds is recommended.
               *      Other settings will require tweaks to the Strophe.TIMEOUT value.
               *    (Integer) hold - The optional HTTPBIND hold value.  This is the
               *      number of connections the server will hold at one time.  This
               *      should almost always be set to 1 (the default).
               *    (Integer) wind - The optional HTTBIND window value.  This is the
               *      allowed range of request ids that are valid.  The default is 5.
               */
              attach: function attach(jid, sid, rid, callback, wait, hold, wind) {
                this._proto._attach(jid, sid, rid, callback, wait, hold, wind);
              },

              /** Function: xmlInput
               *  User overrideable function that receives XML data coming into the
               *  connection.
               *
               *  The default function does nothing.  User code can override this with
               *  > Strophe.Connection.xmlInput = function (elem) {
               *  >   (user code)
               *  > };
               *
               *  Due to limitations of current Browsers' XML-Parsers the opening and closing
               *  <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
               *
               *  BOSH-Connections will have all stanzas wrapped in a <body> tag. See
               *
               *  Parameters:
               *    (XMLElement) elem - The XML data received by the connection.
               */
              /* jshint unused:false */
              xmlInput: function xmlInput(elem) {
                return;
              },
              /* jshint unused:true */

              /** Function: xmlOutput
               *  User overrideable function that receives XML data sent to the
               *  connection.
               *
               *  The default function does nothing.  User code can override this with
               *  > Strophe.Connection.xmlOutput = function (elem) {
               *  >   (user code)
               *  > };
               *
               *  Due to limitations of current Browsers' XML-Parsers the opening and closing
               *  <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
               *
               *  BOSH-Connections will have all stanzas wrapped in a <body> tag. See
               *
               *  Parameters:
               *    (XMLElement) elem - The XMLdata sent by the connection.
               */
              /* jshint unused:false */
              xmlOutput: function xmlOutput(elem) {
                return;
              },
              /* jshint unused:true */

              /** Function: rawInput
               *  User overrideable function that receives raw data coming into the
               *  connection.
               *
               *  The default function does nothing.  User code can override this with
               *  > Strophe.Connection.rawInput = function (data) {
               *  >   (user code)
               *  > };
               *
               *  Parameters:
               *    (String) data - The data received by the connection.
               */
              /* jshint unused:false */
              rawInput: function rawInput(data) {
                return;
              },
              /* jshint unused:true */

              /** Function: rawOutput
               *  User overrideable function that receives raw data sent to the
               *  connection.
               *
               *  The default function does nothing.  User code can override this with
               *  > Strophe.Connection.rawOutput = function (data) {
               *  >   (user code)
               *  > };
               *
               *  Parameters:
               *    (String) data - The data sent by the connection.
               */
              /* jshint unused:false */
              rawOutput: function rawOutput(data) {
                return;
              },
              /* jshint unused:true */

              /** Function: send
               *  Send a stanza.
               *
               *  This function is called to push data onto the send queue to
               *  go out over the wire.  Whenever a request is sent to the BOSH
               *  server, all pending data is sent and the queue is flushed.
               *
               *  Parameters:
               *    (XMLElement |
               *     [XMLElement] |
               *     Strophe.Builder) elem - The stanza to send.
               */
              send: function send(elem) {
                if (elem === null) {
                  return;
                }
                if (typeof elem.sort === "function") {
                  for (var i = 0; i < elem.length; i++) {
                    this._queueData(elem[i]);
                  }
                } else if (typeof elem.tree === "function") {
                  this._queueData(elem.tree());
                } else {
                  this._queueData(elem);
                }

                this._proto._send();
              },

              /** Function: flush
               *  Immediately send any pending outgoing data.
               *
               *  Normally send() queues outgoing data until the next idle period
               *  (100ms), which optimizes network use in the common cases when
               *  several send()s are called in succession. flush() can be used to
               *  immediately send all pending data.
               */
              flush: function flush() {
                // cancel the pending idle period and run the idle function
                // immediately
                clearTimeout(this._idleTimeout);
                this._onIdle();
              },

              /** Function: sendIQ
               *  Helper function to send IQ stanzas.
               *
               *  Parameters:
               *    (XMLElement) elem - The stanza to send.
               *    (Function) callback - The callback function for a successful request.
               *    (Function) errback - The callback function for a failed or timed
               *      out request.  On timeout, the stanza will be null.
               *    (Integer) timeout - The time specified in milliseconds for a
               *      timeout to occur.
               *
               *  Returns:
               *    The id used to send the IQ.
               */
              sendIQ: function sendIQ(elem, callback, errback, timeout) {
                var timeoutHandler = null;
                var that = this;

                if (typeof elem.tree === "function") {
                  elem = elem.tree();
                }
                var id = elem.getAttribute('id');

                // inject id if not found
                if (!id) {
                  id = this.getUniqueId("sendIQ");
                  elem.setAttribute("id", id);
                }

                var expectedFrom = elem.getAttribute("to");
                var fulljid = this.jid;

                var handler = this.addHandler(function (stanza) {
                  // remove timeout handler if there is one
                  if (timeoutHandler) {
                    that.deleteTimedHandler(timeoutHandler);
                  }

                  var acceptable = false;
                  var from = stanza.getAttribute("from");
                  if (from === expectedFrom || expectedFrom === null && (from === Strophe.getBareJidFromJid(fulljid) || from === Strophe.getDomainFromJid(fulljid) || from === fulljid)) {
                    acceptable = true;
                  }

                  if (!acceptable) {
                    throw {
                      name: "StropheError",
                      message: "Got answer to IQ from wrong jid:" + from + "\nExpected jid: " + expectedFrom
                    };
                  }

                  var iqtype = stanza.getAttribute('type');
                  if (iqtype == 'result') {
                    if (callback) {
                      callback(stanza);
                    }
                  } else if (iqtype == 'error') {
                    if (errback) {
                      errback(stanza);
                    }
                  } else {
                    throw {
                      name: "StropheError",
                      message: "Got bad IQ type of " + iqtype
                    };
                  }
                }, null, 'iq', null, id);

                // if timeout specified, setup timeout handler.
                if (timeout) {
                  timeoutHandler = this.addTimedHandler(timeout, function () {
                    // get rid of normal handler
                    that.deleteHandler(handler);

                    // call errback on timeout with null stanza
                    if (errback) {
                      errback(null);
                    }
                    return false;
                  });
                }

                this.send(elem);

                return id;
              },

              /** PrivateFunction: _queueData
               *  Queue outgoing data for later sending.  Also ensures that the data
               *  is a DOMElement.
               */
              _queueData: function _queueData(element) {
                if (element === null || !element.tagName || !element.childNodes) {
                  throw {
                    name: "StropheError",
                    message: "Cannot queue non-DOMElement."
                  };
                }

                this._data.push(element);
              },

              /** PrivateFunction: _sendRestart
               *  Send an xmpp:restart stanza.
               */
              _sendRestart: function _sendRestart() {
                this._data.push("restart");

                this._proto._sendRestart();

                this._idleTimeout = setTimeout(this._onIdle.bind(this), 100);
              },

              /** Function: addTimedHandler
               *  Add a timed handler to the connection.
               *
               *  This function adds a timed handler.  The provided handler will
               *  be called every period milliseconds until it returns false,
               *  the connection is terminated, or the handler is removed.  Handlers
               *  that wish to continue being invoked should return true.
               *
               *  Because of method binding it is necessary to save the result of
               *  this function if you wish to remove a handler with
               *  deleteTimedHandler().
               *
               *  Note that user handlers are not active until authentication is
               *  successful.
               *
               *  Parameters:
               *    (Integer) period - The period of the handler.
               *    (Function) handler - The callback function.
               *
               *  Returns:
               *    A reference to the handler that can be used to remove it.
               */
              addTimedHandler: function addTimedHandler(period, handler) {
                var thand = new Strophe.TimedHandler(period, handler);
                this.addTimeds.push(thand);
                return thand;
              },

              /** Function: deleteTimedHandler
               *  Delete a timed handler for a connection.
               *
               *  This function removes a timed handler from the connection.  The
               *  handRef parameter is *not* the function passed to addTimedHandler(),
               *  but is the reference returned from addTimedHandler().
               *
               *  Parameters:
               *    (Strophe.TimedHandler) handRef - The handler reference.
               */
              deleteTimedHandler: function deleteTimedHandler(handRef) {
                // this must be done in the Idle loop so that we don't change
                // the handlers during iteration
                this.removeTimeds.push(handRef);
              },

              /** Function: addHandler
               *  Add a stanza handler for the connection.
               *
               *  This function adds a stanza handler to the connection.  The
               *  handler callback will be called for any stanza that matches
               *  the parameters.  Note that if multiple parameters are supplied,
               *  they must all match for the handler to be invoked.
               *
               *  The handler will receive the stanza that triggered it as its argument.
               *  The handler should return true if it is to be invoked again;
               *  returning false will remove the handler after it returns.
               *
               *  As a convenience, the ns parameters applies to the top level element
               *  and also any of its immediate children.  This is primarily to make
               *  matching /iq/query elements easy.
               *
               *  The options argument contains handler matching flags that affect how
               *  matches are determined. Currently the only flag is matchBare (a
               *  boolean). When matchBare is true, the from parameter and the from
               *  attribute on the stanza will be matched as bare JIDs instead of
               *  full JIDs. To use this, pass {matchBare: true} as the value of
               *  options. The default value for matchBare is false.
               *
               *  The return value should be saved if you wish to remove the handler
               *  with deleteHandler().
               *
               *  Parameters:
               *    (Function) handler - The user callback.
               *    (String) ns - The namespace to match.
               *    (String) name - The stanza name to match.
               *    (String) type - The stanza type attribute to match.
               *    (String) id - The stanza id attribute to match.
               *    (String) from - The stanza from attribute to match.
               *    (String) options - The handler options
               *
               *  Returns:
               *    A reference to the handler that can be used to remove it.
               */
              addHandler: function addHandler(handler, ns, name, type, id, from, options) {
                var hand = new Strophe.Handler(handler, ns, name, type, id, from, options);
                this.addHandlers.push(hand);
                return hand;
              },

              /** Function: deleteHandler
               *  Delete a stanza handler for a connection.
               *
               *  This function removes a stanza handler from the connection.  The
               *  handRef parameter is *not* the function passed to addHandler(),
               *  but is the reference returned from addHandler().
               *
               *  Parameters:
               *    (Strophe.Handler) handRef - The handler reference.
               */
              deleteHandler: function deleteHandler(handRef) {
                // this must be done in the Idle loop so that we don't change
                // the handlers during iteration
                this.removeHandlers.push(handRef);
                // If a handler is being deleted while it is being added,
                // prevent it from getting added
                var i = this.addHandlers.indexOf(handRef);
                if (i >= 0) {
                  this.addHandlers.splice(i, 1);
                }
              },

              /** Function: disconnect
               *  Start the graceful disconnection process.
               *
               *  This function starts the disconnection process.  This process starts
               *  by sending unavailable presence and sending BOSH body of type
               *  terminate.  A timeout handler makes sure that disconnection happens
               *  even if the BOSH server does not respond.
               *
               *  The user supplied connection callback will be notified of the
               *  progress as this process happens.
               *
               *  Parameters:
               *    (String) reason - The reason the disconnect is occuring.
               */
              disconnect: function disconnect(reason) {
                this._changeConnectStatus(Strophe.Status.DISCONNECTING, reason);

                Strophe.info("Disconnect was called because: " + reason);
                if (this.connected) {
                  var pres = false;
                  this.disconnecting = true;
                  if (this.authenticated) {
                    pres = $pres({
                      xmlns: Strophe.NS.CLIENT,
                      type: 'unavailable'
                    });
                  }
                  // setup timeout handler
                  this._disconnectTimeout = this._addSysTimedHandler(3000, this._onDisconnectTimeout.bind(this));
                  this._proto._disconnect(pres);
                }
              },

              /** PrivateFunction: _changeConnectStatus
               *  _Private_ helper function that makes sure plugins and the user's
               *  callback are notified of connection status changes.
               *
               *  Parameters:
               *    (Integer) status - the new connection status, one of the values
               *      in Strophe.Status
               *    (String) condition - the error condition or null
               */
              _changeConnectStatus: function _changeConnectStatus(status, condition) {
                // notify all plugins listening for status changes
                for (var k in Strophe._connectionPlugins) {
                  if (Strophe._connectionPlugins.hasOwnProperty(k)) {
                    var plugin = this[k];
                    if (plugin.statusChanged) {
                      try {
                        plugin.statusChanged(status, condition);
                      } catch (err) {
                        Strophe.error("" + k + " plugin caused an exception " + "changing status: " + err);
                      }
                    }
                  }
                }

                // @author Michael.Lee
                // @description 在status被设置在Connecting时将地址改变
                if (status === Strophe.Status.CONNECTING && this.service) {
                  this.service = this.loginservice;
                } else {
                  this.service = this.baseservice;
                }

                // notify the user's callback
                if (this.connect_callback) {
                  try {
                    this.connect_callback(status, condition);
                  } catch (e) {
                    Strophe.error("User connection callback caused an " + "exception: " + e);
                  }
                }
              },

              /** PrivateFunction: _doDisconnect
               *  _Private_ function to disconnect.
               *
               *  This is the last piece of the disconnection logic.  This resets the
               *  connection and alerts the user's connection callback.
               */
              _doDisconnect: function _doDisconnect() {
                if (typeof this._idleTimeout == "number") {
                  clearTimeout(this._idleTimeout);
                }

                // Cancel Disconnect Timeout
                if (this._disconnectTimeout !== null) {
                  this.deleteTimedHandler(this._disconnectTimeout);
                  this._disconnectTimeout = null;
                }

                Strophe.info("_doDisconnect was called");
                this._proto._doDisconnect();

                this.authenticated = false;
                this.disconnecting = false;

                // delete handlers
                this.handlers = [];
                this.timedHandlers = [];
                this.removeTimeds = [];
                this.removeHandlers = [];
                this.addTimeds = [];
                this.addHandlers = [];

                // tell the parent we disconnected
                this._changeConnectStatus(Strophe.Status.DISCONNECTED, null);
                this.connected = false;
              },

              /** PrivateFunction: _dataRecv
               *  _Private_ handler to processes incoming data from the the connection.
               *
               *  Except for _connect_cb handling the initial connection request,
               *  this function handles the incoming data for all requests.  This
               *  function also fires stanza handlers that match each incoming
               *  stanza.
               *
               *  Parameters:
               *    (Strophe.Request) req - The request that has data ready.
               *    (string) req - The stanza a raw string (optiona).
               */
              _dataRecv: function _dataRecv(req, raw) {
                Strophe.info("_dataRecv called");
                var elem = this._proto._reqToData(req);
                if (elem === null) {
                  return;
                }

                if (this.xmlInput !== Strophe.Connection.prototype.xmlInput) {
                  if (elem.nodeName === this._proto.strip && elem.childNodes.length) {
                    this.xmlInput(elem.childNodes[0]);
                  } else {
                    this.xmlInput(elem);
                  }
                }
                if (this.rawInput !== Strophe.Connection.prototype.rawInput) {
                  if (raw) {
                    this.rawInput(raw);
                  } else {
                    this.rawInput(Strophe.serialize(elem));
                  }
                }

                // remove handlers scheduled for deletion
                var i, hand;
                while (this.removeHandlers.length > 0) {
                  hand = this.removeHandlers.pop();
                  i = this.handlers.indexOf(hand);
                  if (i >= 0) {
                    this.handlers.splice(i, 1);
                  }
                }

                // add handlers scheduled for addition
                while (this.addHandlers.length > 0) {
                  this.handlers.push(this.addHandlers.pop());
                }

                // handle graceful disconnect
                if (this.disconnecting && this._proto._emptyQueue()) {
                  this._doDisconnect();
                  return;
                }

                var type = elem.getAttribute("type");
                var cond, conflict;
                if (type !== null && type == "terminate") {
                  // Don't process stanzas that come in after disconnect
                  if (this.disconnecting) {
                    return;
                  }

                  // an error occurred
                  cond = elem.getAttribute("condition");
                  conflict = elem.getElementsByTagName("conflict");
                  if (cond !== null) {
                    if (cond == "remote-stream-error" && conflict.length > 0) {
                      cond = "conflict";
                    }
                    this._changeConnectStatus(Strophe.Status.CONNFAIL, cond);
                  } else {
                    this._changeConnectStatus(Strophe.Status.CONNFAIL, "unknown");
                  }
                  this._doDisconnect();
                  return;
                }

                // send each incoming stanza through the handler chain
                var that = this;
                Strophe.forEachChild(elem, null, function (child) {
                  var i, newList;
                  // process handlers
                  newList = that.handlers;
                  that.handlers = [];
                  for (i = 0; i < newList.length; i++) {
                    var hand = newList[i];
                    // encapsulate 'handler.run' not to lose the whole handler list if
                    // one of the handlers throws an exception
                    try {
                      if (hand.isMatch(child) && (that.authenticated || !hand.user)) {
                        if (hand.run(child)) {
                          that.handlers.push(hand);
                        }
                      } else {
                        that.handlers.push(hand);
                      }
                    } catch (e) {
                      // if the handler throws an exception, we consider it as false
                      Strophe.warn('Removing Strophe handlers due to uncaught exception: ' + e.message);
                    }
                  }
                });
              },

              /** Attribute: mechanisms
               *  SASL Mechanisms available for Conncection.
               */
              mechanisms: {},

              /** PrivateFunction: _connect_cb
               *  _Private_ handler for initial connection request.
               *
               *  This handler is used to process the initial connection request
               *  response from the BOSH server. It is used to set up authentication
               *  handlers and start the authentication process.
               *
               *  SASL authentication will be attempted if available, otherwise
               *  the code will fall back to legacy authentication.
               *
               *  Parameters:
               *    (Strophe.Request) req - The current request.
               *    (Function) _callback - low level (xmpp) connect callback function.
               *      Useful for plugins with their own xmpp connect callback (when their)
               *      want to do something special).
               */
              _connect_cb: function _connect_cb(req, _callback, raw) {
                Strophe.info("_connect_cb was called");

                this.connected = true;

                var bodyWrap = this._proto._reqToData(req);
                if (!bodyWrap) {
                  return;
                }

                if (this.xmlInput !== Strophe.Connection.prototype.xmlInput) {
                  if (bodyWrap.nodeName === this._proto.strip && bodyWrap.childNodes.length) {
                    this.xmlInput(bodyWrap.childNodes[0]);
                  } else {
                    this.xmlInput(bodyWrap);
                  }
                }
                if (this.rawInput !== Strophe.Connection.prototype.rawInput) {
                  if (raw) {
                    this.rawInput(raw);
                  } else {
                    this.rawInput(Strophe.serialize(bodyWrap));
                  }
                }

                var conncheck = this._proto._connect_cb(bodyWrap);
                if (conncheck === Strophe.Status.CONNFAIL) {
                  return;
                }

                this._authentication.sasl_scram_sha1 = false;
                this._authentication.sasl_plain = false;
                this._authentication.sasl_digest_md5 = false;
                this._authentication.sasl_anonymous = false;

                this._authentication.legacy_auth = false;

                // Check for the stream:features tag
                var hasFeatures = bodyWrap.getElementsByTagNameNS(Strophe.NS.STREAM, "features").length > 0;
                var mechanisms = bodyWrap.getElementsByTagName("mechanism");
                var matched = [];
                var i,
                  mech,
                  found_authentication = false;
                if (!hasFeatures) {
                  this._proto._no_auth_received(_callback);
                  return;
                }
                if (mechanisms.length > 0) {
                  for (i = 0; i < mechanisms.length; i++) {
                    mech = Strophe.getText(mechanisms[i]);
                    if (this.mechanisms[mech]) matched.push(this.mechanisms[mech]);
                  }
                }
                this._authentication.legacy_auth = bodyWrap.getElementsByTagName("auth").length > 0;
                found_authentication = this._authentication.legacy_auth || matched.length > 0;
                if (!found_authentication) {
                  this._proto._no_auth_received(_callback);
                  return;
                }
                if (this.do_authentication !== false) this.authenticate(matched);
              },

              /** Function: authenticate
               * Set up authentication
               *
               *  Contiunues the initial connection request by setting up authentication
               *  handlers and start the authentication process.
               *
               *  SASL authentication will be attempted if available, otherwise
               *  the code will fall back to legacy authentication.
               *
               */
              authenticate: function authenticate(matched) {
                var i;
                // Sorting matched mechanisms according to priority.
                for (i = 0; i < matched.length - 1; ++i) {
                  var higher = i;
                  for (var j = i + 1; j < matched.length; ++j) {
                    if (matched[j].prototype.priority > matched[higher].prototype.priority) {
                      higher = j;
                    }
                  }
                  if (higher != i) {
                    var swap = matched[i];
                    matched[i] = matched[higher];
                    matched[higher] = swap;
                  }
                }

                // run each mechanism
                var mechanism_found = false;
                for (i = 0; i < matched.length; ++i) {
                  if (!matched[i].test(this)) continue;

                  this._sasl_success_handler = this._addSysHandler(this._sasl_success_cb.bind(this), null, "success", null, null);
                  this._sasl_failure_handler = this._addSysHandler(this._sasl_failure_cb.bind(this), null, "failure", null, null);
                  this._sasl_challenge_handler = this._addSysHandler(this._sasl_challenge_cb.bind(this), null, "challenge", null, null);

                  this._sasl_mechanism = new matched[i]();
                  this._sasl_mechanism.onStart(this);

                  var request_auth_exchange = $build("auth", {
                    xmlns: Strophe.NS.SASL,
                    mechanism: this._sasl_mechanism.name
                  });

                  if (this._sasl_mechanism.isClientFirst) {
                    var response = this._sasl_mechanism.onChallenge(this, null);
                    //@todo
                    request_auth_exchange.t(Base64.encode(response));
                  }

                  this.send(request_auth_exchange.tree());
                  mechanism_found = true;
                  break;
                }

                if (!mechanism_found) {
                  // if none of the mechanism worked
                  if (Strophe.getNodeFromJid(this.jid) === null) {
                    // we don't have a node, which is required for non-anonymous
                    // client connections
                    this._changeConnectStatus(Strophe.Status.CONNFAIL, 'x-strophe-bad-non-anon-jid');
                    this.disconnect('x-strophe-bad-non-anon-jid');
                  } else {
                    // fall back to legacy authentication
                    this._changeConnectStatus(Strophe.Status.AUTHENTICATING, null);
                    this._addSysHandler(this._auth1_cb.bind(this), null, null, null, "_auth_1");

                    this.send($iq({
                      type: "get",
                      to: this.domain,
                      id: "_auth_1"
                    }).c("query", {
                      xmlns: Strophe.NS.AUTH
                    }).c("username", {}).t(Strophe.getNodeFromJid(this.jid)).tree());
                  }
                }
              },

              _sasl_challenge_cb: function _sasl_challenge_cb(elem) {
                var challenge = Base64.decode(Strophe.getText(elem));
                var response = this._sasl_mechanism.onChallenge(this, challenge);

                var stanza = $build('response', {
                  xmlns: Strophe.NS.SASL
                });
                if (response !== "") {
                  stanza.t(Base64.encode(response));
                }
                this.send(stanza.tree());

                return true;
              },

              /** PrivateFunction: _auth1_cb
               *  _Private_ handler for legacy authentication.
               *
               *  This handler is called in response to the initial <iq type='get'/>
               *  for legacy authentication.  It builds an authentication <iq/> and
               *  sends it, creating a handler (calling back to _auth2_cb()) to
               *  handle the result
               *
               *  Parameters:
               *    (XMLElement) elem - The stanza that triggered the callback.
               *
               *  Returns:
               *    false to remove the handler.
               */
              /* jshint unused:false */
              _auth1_cb: function _auth1_cb(elem) {
                // build plaintext auth iq
                var iq = $iq({
                  type: "set",
                  id: "_auth_2"
                }).c('query', {
                  xmlns: Strophe.NS.AUTH
                }).c('username', {}).t(Strophe.getNodeFromJid(this.jid)).up().c('password').t(this.pass);

                if (!Strophe.getResourceFromJid(this.jid)) {
                  // since the user has not supplied a resource, we pick
                  // a default one here.  unlike other auth methods, the server
                  // cannot do this for us.
                  this.jid = Strophe.getBareJidFromJid(this.jid) + '/strophe';
                }
                iq.up().c('resource', {}).t(Strophe.getResourceFromJid(this.jid));

                this._addSysHandler(this._auth2_cb.bind(this), null, null, null, "_auth_2");

                this.send(iq.tree());

                return false;
              },
              /* jshint unused:true */

              /** PrivateFunction: _sasl_success_cb
               *  _Private_ handler for succesful SASL authentication.
               *
               *  Parameters:
               *    (XMLElement) elem - The matching stanza.
               *
               *  Returns:
               *    false to remove the handler.
               */
              _sasl_success_cb: function _sasl_success_cb(elem) {
                if (this._sasl_data["server-signature"]) {
                  var serverSignature;
                  var success = Base64.decode(Strophe.getText(elem));
                  var attribMatch = /([a-z]+)=([^,]+)(,|$)/;
                  var matches = success.match(attribMatch);
                  if (matches[1] == "v") {
                    serverSignature = matches[2];
                  }

                  if (serverSignature != this._sasl_data["server-signature"]) {
                    // remove old handlers
                    this.deleteHandler(this._sasl_failure_handler);
                    this._sasl_failure_handler = null;
                    if (this._sasl_challenge_handler) {
                      this.deleteHandler(this._sasl_challenge_handler);
                      this._sasl_challenge_handler = null;
                    }

                    this._sasl_data = {};
                    return this._sasl_failure_cb(null);
                  }
                }

                Strophe.info("SASL authentication succeeded.");

                if (this._sasl_mechanism) this._sasl_mechanism.onSuccess();

                // remove old handlers
                this.deleteHandler(this._sasl_failure_handler);
                this._sasl_failure_handler = null;
                if (this._sasl_challenge_handler) {
                  this.deleteHandler(this._sasl_challenge_handler);
                  this._sasl_challenge_handler = null;
                }

                this._addSysHandler(this._sasl_auth1_cb.bind(this), null, "stream:features", null, null);

                // we must send an xmpp:restart now
                this._sendRestart();

                return false;
              },

              /** PrivateFunction: _sasl_auth1_cb
               *  _Private_ handler to start stream binding.
               *
               *  Parameters:
               *    (XMLElement) elem - The matching stanza.
               *
               *  Returns:
               *    false to remove the handler.
               */
              _sasl_auth1_cb: function _sasl_auth1_cb(elem) {
                // save stream:features for future usage
                this.features = elem;

                var i, child;

                for (i = 0; i < elem.childNodes.length; i++) {
                  child = elem.childNodes[i];
                  if (child.nodeName == 'bind') {
                    this.do_bind = true;
                  }

                  if (child.nodeName == 'session') {
                    this.do_session = true;
                  }
                }

                if (!this.do_bind) {
                  this._changeConnectStatus(Strophe.Status.AUTHFAIL, null);
                  return false;
                } else {
                  this._addSysHandler(this._sasl_bind_cb.bind(this), null, null, null, "_bind_auth_2");

                  var resource = Strophe.getResourceFromJid(this.jid);
                  if (resource) {
                    this.send($iq({
                      type: "set",
                      id: "_bind_auth_2"
                    }).c('bind', {
                      xmlns: Strophe.NS.BIND
                    }).c('resource', {}).t(resource).tree());
                  } else {
                    this.send($iq({
                      type: "set",
                      id: "_bind_auth_2"
                    }).c('bind', {
                      xmlns: Strophe.NS.BIND
                    }).tree());
                  }
                }

                return false;
              },

              /** PrivateFunction: _sasl_bind_cb
               *  _Private_ handler for binding result and session start.
               *
               *  Parameters:
               *    (XMLElement) elem - The matching stanza.
               *
               *  Returns:
               *    false to remove the handler.
               */
              _sasl_bind_cb: function _sasl_bind_cb(elem) {
                if (elem.getAttribute("type") == "error") {
                  Strophe.info("SASL binding failed.");
                  var conflict = elem.getElementsByTagName("conflict"),
                    condition;
                  if (conflict.length > 0) {
                    condition = 'conflict';
                  }
                  this._changeConnectStatus(Strophe.Status.AUTHFAIL, condition);
                  return false;
                }

                // TODO - need to grab errors
                var bind = elem.getElementsByTagName("bind");
                var jidNode;
                if (bind.length > 0) {
                  // Grab jid
                  jidNode = bind[0].getElementsByTagName("jid");
                  if (jidNode.length > 0) {
                    this.jid = Strophe.getText(jidNode[0]);

                    if (this.do_session) {
                      this._addSysHandler(this._sasl_session_cb.bind(this), null, null, null, "_session_auth_2");

                      this.send($iq({
                        type: "set",
                        id: "_session_auth_2"
                      }).c('session', {
                        xmlns: Strophe.NS.SESSION
                      }).tree());
                    } else {
                      this.authenticated = true;
                      this._changeConnectStatus(Strophe.Status.CONNECTED, null);
                    }
                  }
                } else {
                  Strophe.info("SASL binding failed.");
                  this._changeConnectStatus(Strophe.Status.AUTHFAIL, null);
                  return false;
                }
              },

              /** PrivateFunction: _sasl_session_cb
               *  _Private_ handler to finish successful SASL connection.
               *
               *  This sets Connection.authenticated to true on success, which
               *  starts the processing of user handlers.
               *
               *  Parameters:
               *    (XMLElement) elem - The matching stanza.
               *
               *  Returns:
               *    false to remove the handler.
               */
              _sasl_session_cb: function _sasl_session_cb(elem) {
                if (elem.getAttribute("type") == "result") {
                  this.authenticated = true;
                  this._changeConnectStatus(Strophe.Status.CONNECTED, null);
                } else if (elem.getAttribute("type") == "error") {
                  Strophe.info("Session creation failed.");
                  this._changeConnectStatus(Strophe.Status.AUTHFAIL, null);
                  return false;
                }

                return false;
              },

              /** PrivateFunction: _sasl_failure_cb
               *  _Private_ handler for SASL authentication failure.
               *
               *  Parameters:
               *    (XMLElement) elem - The matching stanza.
               *
               *  Returns:
               *    false to remove the handler.
               */
              /* jshint unused:false */
              _sasl_failure_cb: function _sasl_failure_cb(elem) {
                // delete unneeded handlers
                if (this._sasl_success_handler) {
                  this.deleteHandler(this._sasl_success_handler);
                  this._sasl_success_handler = null;
                }
                if (this._sasl_challenge_handler) {
                  this.deleteHandler(this._sasl_challenge_handler);
                  this._sasl_challenge_handler = null;
                }

                if (this._sasl_mechanism) this._sasl_mechanism.onFailure();
                this._changeConnectStatus(Strophe.Status.AUTHFAIL, null);
                return false;
              },
              /* jshint unused:true */

              /** PrivateFunction: _auth2_cb
               *  _Private_ handler to finish legacy authentication.
               *
               *  This handler is called when the result from the jabber:iq:auth
               *  <iq/> stanza is returned.
               *
               *  Parameters:
               *    (XMLElement) elem - The stanza that triggered the callback.
               *
               *  Returns:
               *    false to remove the handler.
               */
              _auth2_cb: function _auth2_cb(elem) {
                if (elem.getAttribute("type") == "result") {
                  this.authenticated = true;
                  this._changeConnectStatus(Strophe.Status.CONNECTED, null);
                } else if (elem.getAttribute("type") == "error") {
                  this._changeConnectStatus(Strophe.Status.AUTHFAIL, null);
                  this.disconnect('authentication failed');
                }

                return false;
              },

              /** PrivateFunction: _addSysTimedHandler
               *  _Private_ function to add a system level timed handler.
               *
               *  This function is used to add a Strophe.TimedHandler for the
               *  library code.  System timed handlers are allowed to run before
               *  authentication is complete.
               *
               *  Parameters:
               *    (Integer) period - The period of the handler.
               *    (Function) handler - The callback function.
               */
              _addSysTimedHandler: function _addSysTimedHandler(period, handler) {
                var thand = new Strophe.TimedHandler(period, handler);
                thand.user = false;
                this.addTimeds.push(thand);
                return thand;
              },

              /** PrivateFunction: _addSysHandler
               *  _Private_ function to add a system level stanza handler.
               *
               *  This function is used to add a Strophe.Handler for the
               *  library code.  System stanza handlers are allowed to run before
               *  authentication is complete.
               *
               *  Parameters:
               *    (Function) handler - The callback function.
               *    (String) ns - The namespace to match.
               *    (String) name - The stanza name to match.
               *    (String) type - The stanza type attribute to match.
               *    (String) id - The stanza id attribute to match.
               */
              _addSysHandler: function _addSysHandler(handler, ns, name, type, id) {
                var hand = new Strophe.Handler(handler, ns, name, type, id);
                hand.user = false;
                this.addHandlers.push(hand);
                return hand;
              },

              /** PrivateFunction: _onDisconnectTimeout
               *  _Private_ timeout handler for handling non-graceful disconnection.
               *
               *  If the graceful disconnect process does not complete within the
               *  time allotted, this handler finishes the disconnect anyway.
               *
               *  Returns:
               *    false to remove the handler.
               */
              _onDisconnectTimeout: function _onDisconnectTimeout() {
                Strophe.info("_onDisconnectTimeout was called");

                this._proto._onDisconnectTimeout();

                // actually disconnect
                this._doDisconnect();

                return false;
              },

              /** PrivateFunction: _onIdle
               *  _Private_ handler to process events during idle cycle.
               *
               *  This handler is called every 100ms to fire timed handlers that
               *  are ready and keep poll requests going.
               */
              _onIdle: function _onIdle() {
                var i, thand, since, newList;

                // add timed handlers scheduled for addition
                // NOTE: we add before remove in the case a timed handler is
                // added and then deleted before the next _onIdle() call.
                while (this.addTimeds.length > 0) {
                  this.timedHandlers.push(this.addTimeds.pop());
                }

                // remove timed handlers that have been scheduled for deletion
                while (this.removeTimeds.length > 0) {
                  thand = this.removeTimeds.pop();
                  i = this.timedHandlers.indexOf(thand);
                  if (i >= 0) {
                    this.timedHandlers.splice(i, 1);
                  }
                }

                // call ready timed handlers
                var now = new Date().getTime();
                newList = [];
                for (i = 0; i < this.timedHandlers.length; i++) {
                  thand = this.timedHandlers[i];
                  if (this.authenticated || !thand.user) {
                    since = thand.lastCalled + thand.period;
                    if (since - now <= 0) {
                      if (thand.run()) {
                        newList.push(thand);
                      }
                    } else {
                      newList.push(thand);
                    }
                  }
                }
                this.timedHandlers = newList;

                clearTimeout(this._idleTimeout);

                this._proto._onIdle();

                // reactivate the timer only if connected
                if (this.connected) {
                  this._idleTimeout = setTimeout(this._onIdle.bind(this), 100);
                }
              }
            };

            if (callback) {
              callback(Strophe, $build, $msg, $iq, $pres);
            }

            /** Class: Strophe.SASLMechanism
             *
             *  encapsulates SASL authentication mechanisms.
             *
             *  User code may override the priority for each mechanism or disable it completely.
             *  See <priority> for information about changing priority and <test> for informatian on
             *  how to disable a mechanism.
             *
             *  By default, all mechanisms are enabled and the priorities are
             *
             *  SCRAM-SHA1 - 40
             *  DIGEST-MD5 - 30
             *  Plain - 20
             */

            /**
             * PrivateConstructor: Strophe.SASLMechanism
             * SASL auth mechanism abstraction.
             *
             *  Parameters:
             *    (String) name - SASL Mechanism name.
             *    (Boolean) isClientFirst - If client should send response first without challenge.
             *    (Number) priority - Priority.
             *
             *  Returns:
             *    A new Strophe.SASLMechanism object.
             */
            Strophe.SASLMechanism = function (name, isClientFirst, priority) {
              /** PrivateVariable: name
               *  Mechanism name.
               */
              this.name = name;
              /** PrivateVariable: isClientFirst
               *  If client sends response without initial server challenge.
               */
              this.isClientFirst = isClientFirst;
              /** Variable: priority
               *  Determines which <SASLMechanism> is chosen for authentication (Higher is better).
               *  Users may override this to prioritize mechanisms differently.
               *
               *  In the default configuration the priorities are
               *
               *  SCRAM-SHA1 - 40
               *  DIGEST-MD5 - 30
               *  Plain - 20
               *
               *  Example: (This will cause Strophe to choose the mechanism that the server sent first)
               *
               *  > Strophe.SASLMD5.priority = Strophe.SASLSHA1.priority;
               *
               *  See <SASL mechanisms> for a list of available mechanisms.
               *
               */
              this.priority = priority;
            };

            Strophe.SASLMechanism.prototype = {
              /**
               *  Function: test
               *  Checks if mechanism able to run.
               *  To disable a mechanism, make this return false;
               *
               *  To disable plain authentication run
               *  > Strophe.SASLPlain.test = function() {
               *  >   return false;
               *  > }
               *
               *  See <SASL mechanisms> for a list of available mechanisms.
               *
               *  Parameters:
               *    (Strophe.Connection) connection - Target Connection.
               *
               *  Returns:
               *    (Boolean) If mechanism was able to run.
               */
              /* jshint unused:false */
              test: function test(connection) {
                return true;
              },
              /* jshint unused:true */

              /** PrivateFunction: onStart
               *  Called before starting mechanism on some connection.
               *
               *  Parameters:
               *    (Strophe.Connection) connection - Target Connection.
               */
              onStart: function onStart(connection) {
                this._connection = connection;
              },

              /** PrivateFunction: onChallenge
               *  Called by protocol implementation on incoming challenge. If client is
               *  first (isClientFirst == true) challenge will be null on the first call.
               *
               *  Parameters:
               *    (Strophe.Connection) connection - Target Connection.
               *    (String) challenge - current challenge to handle.
               *
               *  Returns:
               *    (String) Mechanism response.
               */
              /* jshint unused:false */
              onChallenge: function onChallenge(connection, challenge) {
                throw new Error("You should implement challenge handling!");
              },
              /* jshint unused:true */

              /** PrivateFunction: onFailure
               *  Protocol informs mechanism implementation about SASL failure.
               */
              onFailure: function onFailure() {
                this._connection = null;
              },

              /** PrivateFunction: onSuccess
               *  Protocol informs mechanism implementation about SASL success.
               */
              onSuccess: function onSuccess() {
                this._connection = null;
              }
            };

            /** Constants: SASL mechanisms
             *  Available authentication mechanisms
             *
             *  Strophe.SASLAnonymous - SASL Anonymous authentication.
             *  Strophe.SASLPlain - SASL Plain authentication.
             *  Strophe.SASLMD5 - SASL Digest-MD5 authentication
             *  Strophe.SASLSHA1 - SASL SCRAM-SHA1 authentication
             */

            // Building SASL callbacks

            /** PrivateConstructor: SASLAnonymous
             *  SASL Anonymous authentication.
             */
            Strophe.SASLAnonymous = function () { };

            Strophe.SASLAnonymous.prototype = new Strophe.SASLMechanism("ANONYMOUS", false, 10);

            Strophe.SASLAnonymous.test = function (connection) {
              return connection.authcid === null;
            };

            Strophe.Connection.prototype.mechanisms[Strophe.SASLAnonymous.prototype.name] = Strophe.SASLAnonymous;

            /** PrivateConstructor: SASLPlain
             *  SASL Plain authentication.
             */
            Strophe.SASLPlain = function () { };

            Strophe.SASLPlain.prototype = new Strophe.SASLMechanism("PLAIN", true, 20);

            Strophe.SASLPlain.test = function (connection) {
              return connection.authcid !== null;
            };

            Strophe.SASLPlain.prototype.onChallenge = function (connection) {
              var auth_str = connection.authzid;
              auth_str = auth_str + '\0';
              auth_str = auth_str + connection.authcid;
              auth_str = auth_str + '\0';
              //Modified by evan zhanghui451@jk.cn 2015/9/16
              //Because BOSH protocol may be connect without password
              if (connection.pass) {
                auth_str = auth_str + connection.pass;
              }
              return auth_str;
            };

            Strophe.Connection.prototype.mechanisms[Strophe.SASLPlain.prototype.name] = Strophe.SASLPlain;

            /** PrivateConstructor: SASLSHA1
             *  SASL SCRAM SHA 1 authentication.
             */
            Strophe.SASLSHA1 = function () { };

            /* TEST:
             * This is a simple example of a SCRAM-SHA-1 authentication exchange
             * when the client doesn't support channel bindings (username 'user' and
             * password 'pencil' are used):
             *
             * C: n,,n=user,r=fyko+d2lbbFgONRv9qkxdawL
             * S: r=fyko+d2lbbFgONRv9qkxdawL3rfcNHYJY1ZVvWVs7j,s=QSXCR+Q6sek8bf92,
             * i=4096
             * C: c=biws,r=fyko+d2lbbFgONRv9qkxdawL3rfcNHYJY1ZVvWVs7j,
             * p=v0X8v3Bz2T0CJGbJQyF0X+HI4Ts=
             * S: v=rmF9pqV8S7suAoZWja4dJRkFsKQ=
             *
             */

            Strophe.SASLSHA1.prototype = new Strophe.SASLMechanism("SCRAM-SHA-1", true, 40);

            Strophe.SASLSHA1.test = function (connection) {
              return connection.authcid !== null;
            };

            Strophe.SASLSHA1.prototype.onChallenge = function (connection, challenge, test_cnonce) {
              var cnonce = test_cnonce || MD5.hexdigest(Math.random() * 1234567890);

              var auth_str = "n=" + connection.authcid;
              auth_str += ",r=";
              auth_str += cnonce;

              connection._sasl_data.cnonce = cnonce;
              connection._sasl_data["client-first-message-bare"] = auth_str;

              auth_str = "n,," + auth_str;

              this.onChallenge = function (connection, challenge) {
                var nonce, salt, iter, Hi, U, U_old, i, k;
                var clientKey, serverKey, clientSignature;
                var responseText = "c=biws,";
                var authMessage = connection._sasl_data["client-first-message-bare"] + "," + challenge + ",";
                var cnonce = connection._sasl_data.cnonce;
                var attribMatch = /([a-z]+)=([^,]+)(,|$)/;

                while (challenge.match(attribMatch)) {
                  var matches = challenge.match(attribMatch);
                  challenge = challenge.replace(matches[0], "");
                  switch (matches[1]) {
                    case "r":
                      nonce = matches[2];
                      break;
                    case "s":
                      salt = matches[2];
                      break;
                    case "i":
                      iter = matches[2];
                      break;
                  }
                }

                if (nonce.substr(0, cnonce.length) !== cnonce) {
                  connection._sasl_data = {};
                  return connection._sasl_failure_cb();
                }

                responseText += "r=" + nonce;
                authMessage += responseText;

                salt = Base64.decode(salt);
                salt += "\x00\x00\x00\x01";

                Hi = U_old = core_hmac_sha1(connection.pass, salt);
                for (i = 1; i < iter; i++) {
                  U = core_hmac_sha1(connection.pass, binb2str(U_old));
                  for (k = 0; k < 5; k++) {
                    Hi[k] ^= U[k];
                  }
                  U_old = U;
                }
                Hi = binb2str(Hi);

                clientKey = core_hmac_sha1(Hi, "Client Key");
                serverKey = str_hmac_sha1(Hi, "Server Key");
                clientSignature = core_hmac_sha1(str_sha1(binb2str(clientKey)), authMessage);
                connection._sasl_data["server-signature"] = b64_hmac_sha1(serverKey, authMessage);

                for (k = 0; k < 5; k++) {
                  clientKey[k] ^= clientSignature[k];
                }

                responseText += ",p=" + Base64.encode(binb2str(clientKey));

                return responseText;
              }.bind(this);

              return auth_str;
            };

            Strophe.Connection.prototype.mechanisms[Strophe.SASLSHA1.prototype.name] = Strophe.SASLSHA1;

            /** PrivateConstructor: SASLMD5
             *  SASL DIGEST MD5 authentication.
             */
            Strophe.SASLMD5 = function () { };

            Strophe.SASLMD5.prototype = new Strophe.SASLMechanism("DIGEST-MD5", false, 30);

            Strophe.SASLMD5.test = function (connection) {
              return connection.authcid !== null;
            };

            /** PrivateFunction: _quote
             *  _Private_ utility function to backslash escape and quote strings.
             *
             *  Parameters:
             *    (String) str - The string to be quoted.
             *
             *  Returns:
             *    quoted string
             */
            Strophe.SASLMD5.prototype._quote = function (str) {
              return '"' + str.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"';
              //" end string workaround for emacs
            };

            Strophe.SASLMD5.prototype.onChallenge = function (connection, challenge, test_cnonce) {
              var attribMatch = /([a-z]+)=("[^"]+"|[^,"]+)(?:,|$)/;
              var cnonce = test_cnonce || MD5.hexdigest("" + Math.random() * 1234567890);
              var realm = "";
              var host = null;
              var nonce = "";
              var qop = "";
              var matches;

              while (challenge.match(attribMatch)) {
                matches = challenge.match(attribMatch);
                challenge = challenge.replace(matches[0], "");
                matches[2] = matches[2].replace(/^"(.+)"$/, "$1");
                switch (matches[1]) {
                  case "realm":
                    realm = matches[2];
                    break;
                  case "nonce":
                    nonce = matches[2];
                    break;
                  case "qop":
                    qop = matches[2];
                    break;
                  case "host":
                    host = matches[2];
                    break;
                }
              }

              var digest_uri = connection.servtype + "/" + connection.domain;
              if (host !== null) {
                digest_uri = digest_uri + "/" + host;
              }

              var A1 = MD5.hash(connection.authcid + ":" + realm + ":" + this._connection.pass) + ":" + nonce + ":" + cnonce;
              var A2 = 'AUTHENTICATE:' + digest_uri;

              var responseText = "";
              responseText += 'charset=utf-8,';
              responseText += 'username=' + this._quote(connection.authcid) + ',';
              responseText += 'realm=' + this._quote(realm) + ',';
              responseText += 'nonce=' + this._quote(nonce) + ',';
              responseText += 'nc=00000001,';
              responseText += 'cnonce=' + this._quote(cnonce) + ',';
              responseText += 'digest-uri=' + this._quote(digest_uri) + ',';
              responseText += 'response=' + MD5.hexdigest(MD5.hexdigest(A1) + ":" + nonce + ":00000001:" + cnonce + ":auth:" + MD5.hexdigest(A2)) + ",";
              responseText += 'qop=auth';

              this.onChallenge = function () {
                return "";
              }.bind(this);

              return responseText;
            };

            Strophe.Connection.prototype.mechanisms[Strophe.SASLMD5.prototype.name] = Strophe.SASLMD5;
          })(function () {
            Strophe = arguments[0];
            $build = arguments[1];
            $msg = arguments[2];
            $iq = arguments[3];
            $pres = arguments[4];
          });

          /** Class: Strophe.WebSocket
           *  _Private_ helper class that handles WebSocket Connections
           *
           *  The Strophe.WebSocket class is used internally by Strophe.Connection
           *  to encapsulate WebSocket sessions. It is not meant to be used from user's code.
           */

          /** File: websocket.js
           *  A JavaScript library to enable XMPP over Websocket in Strophejs.
           *
           *  This file implements XMPP over WebSockets for Strophejs.
           *  If a Connection is established with a Websocket url (ws://...)
           *  Strophe will use WebSockets.
           *  For more information on XMPP-over WebSocket see this RFC draft:
           *  http://tools.ietf.org/html/draft-ietf-xmpp-websocket-00
           *
           *  WebSocket support implemented by Andreas Guth (andreas.guth@rwth-aachen.de)
           */

          /** PrivateConstructor: Strophe.Websocket
           *  Create and initialize a Strophe.WebSocket object.
           *  Currently only sets the connection Object.
           *
           *  Parameters:
           *    (Strophe.Connection) connection - The Strophe.Connection that will use WebSockets.
           *
           *  Returns:
           *    A new Strophe.WebSocket object.
           */
          Strophe.Websocket = function (connection) {
            this._conn = connection;
            this.strip = "stream:stream";

            var service = connection.service;
          };

          Strophe.Websocket.prototype = {
            /** PrivateFunction: _buildStream
             *  _Private_ helper function to generate the <stream> start tag for WebSockets
             *
             *  Returns:
             *    A Strophe.Builder with a <stream> element.
             */
            _buildStream: function _buildStream() {
              return $build("stream:stream", {
                "to": this._conn.domain,
                "xmlns": Strophe.NS.CLIENT,
                "xmlns:stream": Strophe.NS.STREAM,
                "version": '1.0'
              });
            },

            /** PrivateFunction: _check_streamerror
             * _Private_ checks a message for stream:error
             *
             *  Parameters:
             *    (Strophe.Request) bodyWrap - The received stanza.
             *    connectstatus - The ConnectStatus that will be set on error.
             *  Returns:
             *     true if there was a streamerror, false otherwise.
             */
            _check_streamerror: function _check_streamerror(bodyWrap, connectstatus) {
              var errors = bodyWrap.getElementsByTagNameNS(Strophe.NS.STREAM, "error");
              if (errors.length === 0) {
                return false;
              }
              var error = errors[0];

              var condition = "";
              var text = "";

              var ns = "urn:ietf:params:xml:ns:xmpp-streams";
              for (var i = 0; i < error.childNodes.length; i++) {
                var e = error.childNodes[i];
                if (e.getAttribute("xmlns") !== ns) {
                  break;
                }
                if (e.nodeName === "text") {
                  text = e.textContent;
                } else {
                  condition = e.nodeName;
                }
              }

              var errorString = "WebSocket stream error: ";

              if (condition) {
                errorString += condition;
              } else {
                errorString += "unknown";
              }

              if (text) {
                errorString += " - " + condition;
              }

              Strophe.error(errorString);

              // close the connection on stream_error
              this._conn._changeConnectStatus(connectstatus, condition);
              this._conn._doDisconnect();
              return true;
            },

            /** PrivateFunction: _reset
             *  Reset the connection.
             *
             *  This function is called by the reset function of the Strophe Connection.
             *  Is not needed by WebSockets.
             */
            _reset: function _reset() {
              return;
            },

            /** PrivateFunction: _connect
             *  _Private_ function called by Strophe.Connection.connect
             *
             *  Creates a WebSocket for a connection and assigns Callbacks to it.
             *  Does nothing if there already is a WebSocket.
             */
            _connect: function _connect() {
              // Ensure that there is no open WebSocket from a previous Connection.
              this._closeSocket();
              wx.connectSocket({
                url: this._conn.service,
                header: {
                  cookie: this._conn.options['ticketInfo'] || ''
                },
                protocols: ['xmpp']
              });
              wx.onSocketOpen(this._onOpen.bind(this));
              wx.onSocketError(this._onError.bind(this));
              wx.onSocketClose(this._onClose.bind(this));
              wx.onSocketMessage(this._connect_cb_wrapper.bind(this));
            },

            /** PrivateFunction: _connect_cb
             *  _Private_ function called by Strophe.Connection._connect_cb
             *
             * checks for stream:error
             *
             *  Parameters:
             *    (Strophe.Request) bodyWrap - The received stanza.
             */
            _connect_cb: function _connect_cb(bodyWrap) {
              var error = this._check_streamerror(bodyWrap, Strophe.Status.CONNFAIL);
              if (error) {
                return Strophe.Status.CONNFAIL;
              }
            },

            /** PrivateFunction: _handleStreamStart
             * _Private_ function that checks the opening stream:stream tag for errors.
             *
             * Disconnects if there is an error and returns false, true otherwise.
             *
             *  Parameters:
             *    (Node) message - Stanza containing the stream:stream.
             */
            _handleStreamStart: function _handleStreamStart(message) {
              var error = false;
              // Check for errors in the stream:stream tag
              var ns = message.getAttribute("xmlns");
              if (typeof ns !== "string") {
                error = "Missing xmlns in stream:stream";
              } else if (ns !== Strophe.NS.CLIENT) {
                error = "Wrong xmlns in stream:stream: " + ns;
              }

              var ns_stream = message.namespaceURI;
              if (typeof ns_stream !== "string") {
                error = "Missing xmlns:stream in stream:stream";
              } else if (ns_stream !== Strophe.NS.STREAM) {
                error = "Wrong xmlns:stream in stream:stream: " + ns_stream;
              }

              var ver = message.getAttribute("version");
              if (typeof ver !== "string") {
                error = "Missing version in stream:stream";
              } else if (ver !== "1.0") {
                error = "Wrong version in stream:stream: " + ver;
              }

              if (error) {
                this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, error);
                this._conn._doDisconnect();
                return false;
              }

              return true;
            },

            /** PrivateFunction: _connect_cb_wrapper
             * _Private_ function that handles the first connection messages.
             *
             * On receiving an opening stream tag this callback replaces itself with the real
             * message handler. On receiving a stream error the connection is terminated.
             */
            _connect_cb_wrapper: function _connect_cb_wrapper(message) {
              //@ get token
              if (message.data.indexOf("<body><handshake>") === 0) {
                //var hand = $(message.data)[0];
                var hand = new DOMParser().parseFromString(message.data, "text/xml").documentElement;
                if (hand.getElementsByTagName("handshake")[0].textContent == "success") {
                  var tk = hand.getElementsByTagName("tk")[0];
                  this._conn.pass = tk.textContent;
                  //this._onOpen();
                } else {
                  this._conn._doDisconnect();
                }
                return;
              }

              if (message.data.indexOf("<stream:stream ") === 0 || message.data.indexOf("<?xml") === 0) {
                // Strip the XML Declaration, if there is one
                var data = message.data.replace(/^(<\?.*?\?>\s*)*/, "");
                if (data === '') return;

                //Make the initial stream:stream selfclosing to parse it without a SAX parser.
                data = message.data.replace(/<stream:stream (.*[^\/])>/, "<stream:stream $1/>");

                var streamStart = new DOMParser().parseFromString(data, "text/xml").documentElement;
                this._conn.xmlInput(streamStart);
                this._conn.rawInput(message.data);

                //_handleStreamSteart will check for XML errors and disconnect on error
                if (this._handleStreamStart(streamStart)) {

                  //_connect_cb will check for stream:error and disconnect on error
                  this._connect_cb(streamStart);

                  // ensure received stream:stream is NOT selfclosing and save it for following messages
                  this.streamStart = message.data.replace(/^<stream:(.*)\/>$/, "<stream:$1>");
                }
              } else if (message.data === "</stream:stream>") {
                this._conn.rawInput(message.data);
                this._conn.xmlInput(Strophe.xmlGenerator().createElement("stream:stream"));
                this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, "Received closing stream");
                this._conn._doDisconnect();
                return;
              } else {
                var string = this._streamWrap(message.data);
                var elem = new DOMParser().parseFromString(string, "text/xml").documentElement;
                wx.onSocketMessage(this._onMessage.bind(this));
                this._conn._connect_cb(elem, null, message.data);
              }
            },

            /** PrivateFunction: _disconnect
             *  _Private_ function called by Strophe.Connection.disconnect
             *
             *  Disconnects and sends a last stanza if one is given
             *
             *  Parameters:
             *    (Request) pres - This stanza will be sent before disconnecting.
             */
            _disconnect: function _disconnect(pres) {
              if (pres) {
                this._conn.send(pres);
              }
              var close = '</stream:stream>';
              this._conn.xmlOutput(Strophe.xmlGenerator().createElement("stream:stream"));
              this._conn.rawOutput(close);
              try {
                if (this._conn.connected) {
                  wx.sendSocketMessage({
                    data: close,
                    success: function success() {
                      console.log('success');
                    },
                    fail: function fail() {
                      console.log('fail');
                    }
                  });
                }
              } catch (e) {
                Strophe.info("Couldn't send closing stream tag.");
              }
              this._conn._doDisconnect();
            },

            /** PrivateFunction: _doDisconnect
             *  _Private_ function to disconnect.
             *
             *  Just closes the Socket for WebSockets
             */
            _doDisconnect: function _doDisconnect() {
              Strophe.info("WebSockets _doDisconnect was called");
              this._closeSocket();
            },

            /** PrivateFunction _streamWrap
             *  _Private_ helper function to wrap a stanza in a <stream> tag.
             *  This is used so Strophe can process stanzas from WebSockets like BOSH
             */
            _streamWrap: function _streamWrap(stanza) {
              return this.streamStart + stanza + '</stream:stream>';
            },

            /** PrivateFunction: _closeSocket
             *  _Private_ function to close the WebSocket.
             *
             *  Closes the socket if it is still open and deletes it
             */
            _closeSocket: function _closeSocket() {
              wx.closeSocket({
                reason: 'need close',
                success: function success() {
                  console.log('关闭成功');
                },
                fail: function fail() {
                  console.log('关闭失败');
                }
              });
            },

            /** PrivateFunction: _emptyQueue
             * _Private_ function to check if the message queue is empty.
             *
             *  Returns:
             *    True, because WebSocket messages are send immediately after queueing.
             */
            _emptyQueue: function _emptyQueue() {
              return true;
            },

            /** PrivateFunction: _onClose
             * _Private_ function to handle websockets closing.
             *
             * Nothing to do here for WebSockets
             */
            _onClose: function _onClose() {
              if (this._conn.connected && !this._conn.disconnecting) {
                Strophe.error("Websocket closed unexcectedly");
                this._conn._doDisconnect();
              } else {
                Strophe.info("Websocket closed");
              }
            },

            /** PrivateFunction: _no_auth_received
             *
             * Called on stream start/restart when no stream:features
             * has been received.
             */
            _no_auth_received: function _no_auth_received(_callback) {
              Strophe.error("Server did not send any auth methods");
              this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, "Server did not send any auth methods");
              if (_callback) {
                _callback = _callback.bind(this._conn);
                _callback();
              }
              this._conn._doDisconnect();
            },

            /** PrivateFunction: _onDisconnectTimeout
             *  _Private_ timeout handler for handling non-graceful disconnection.
             *
             *  This does nothing for WebSockets
             */
            _onDisconnectTimeout: function _onDisconnectTimeout() { },

            /** PrivateFunction: _onError
             * _Private_ function to handle websockets errors.
             *
             * Parameters:
             * (Object) error - The websocket error.
             */
            _onError: function _onError(error) {
              Strophe.error("Websocket error " + error);
              this._conn._changeConnectStatus(Strophe.Status.CONNFAIL, "The WebSocket connection could not be established was disconnected.");
              this._disconnect();
            },

            /** PrivateFunction: _onIdle
             *  _Private_ function called by Strophe.Connection._onIdle
             *
             *  sends all queued stanzas
             */
            _onIdle: function _onIdle() {
              var data = this._conn._data;
              if (data.length > 0 && !this._conn.paused) {
                for (var i = 0; i < data.length; i++) {
                  if (data[i] !== null) {
                    var stanza, rawStanza;
                    if (data[i] === "restart") {
                      stanza = this._buildStream();
                      rawStanza = this._removeClosingTag(stanza);
                      stanza = stanza.tree();
                    } else {
                      stanza = data[i];
                      rawStanza = Strophe.serialize(stanza);
                    }
                    this._conn.xmlOutput(stanza);
                    this._conn.rawOutput(rawStanza);
                    if (this._conn.connected) {
                      wx.sendSocketMessage({
                        data: rawStanza,
                        success: function success() {
                          console.log('success');
                        },
                        fail: function fail() {
                          console.log('fail');
                        }
                      });
                    }
                  }
                }
                this._conn._data = [];
              }
            },

            /** PrivateFunction: _onMessage
             * _Private_ function to handle websockets messages.
             *
             * This function parses each of the messages as if they are full documents. [TODO : We may actually want to use a SAX Push parser].
             *
             * Since all XMPP traffic starts with "<stream:stream version='1.0' xml:lang='en' xmlns='jabber:client' xmlns:stream='http://etherx.jabber.org/streams' id='3697395463' from='SERVER'>"
             * The first stanza will always fail to be parsed...
             * Addtionnaly, the seconds stanza will always be a <stream:features> with the stream NS defined in the previous stanza... so we need to 'force' the inclusion of the NS in this stanza!
             *
             * Parameters:
             * (string) message - The websocket message.
             */
            _onMessage: function _onMessage(message) {
              var elem, data;
              // check for closing stream
              if (message.data === "</stream:stream>") {
                var close = "</stream:stream>";
                this._conn.rawInput(close);
                this._conn.xmlInput(Strophe.xmlGenerator().createElement("stream:stream"));
                if (!this._conn.disconnecting) {
                  this._conn._doDisconnect();
                }
                return;
              } else if (message.data.search("<stream:stream ") === 0) {
                //Make the initial stream:stream selfclosing to parse it without a SAX parser.
                data = message.data.replace(/<stream:stream (.*[^\/])>/, "<stream:stream $1/>");
                elem = new DOMParser().parseFromString(data, "text/xml").documentElement;

                if (!this._handleStreamStart(elem)) {
                  return;
                }
              } else {
                data = this._streamWrap(message.data);
                elem = new DOMParser().parseFromString(data, "text/xml").documentElement;
              }

              if (this._check_streamerror(elem, Strophe.Status.ERROR)) {
                return;
              }

              //handle unavailable presence stanza before disconnecting
              if (this._conn.disconnecting && elem.firstChild.nodeName === "presence" && elem.firstChild.getAttribute("type") === "unavailable") {
                this._conn.xmlInput(elem);
                this._conn.rawInput(Strophe.serialize(elem));
                // if we are already disconnecting we will ignore the unavailable stanza and
                // wait for the </stream:stream> tag before we close the connection
                return;
              }
              this._conn._dataRecv(elem, message.data);
            },

            /** PrivateFunction: _onOpen
             * _Private_ function to handle websockets connection setup.
             *
             * The opening stream tag is sent here.
             */
            _onOpen: function _onOpen() {
              Strophe.info("Websocket open");
              var start = this._buildStream();
              this._conn.xmlOutput(start.tree());

              var startString = this._removeClosingTag(start);
              this._conn.rawOutput(startString);
              wx.sendSocketMessage({
                data: startString,
                success: function success() {
                  console.log('success');
                },
                fail: function fail() {
                  console.log('fail');
                }
              });
            },

            /** PrivateFunction: _removeClosingTag
             *  _Private_ function to Make the first <stream:stream> non-selfclosing
             *
             *  Parameters:
             *      (Object) elem - The <stream:stream> tag.
             *
             *  Returns:
             *      The stream:stream tag as String
             */
            _removeClosingTag: function _removeClosingTag(elem) {
              var string = Strophe.serialize(elem);
              string = string.replace(/<(stream:stream .*[^\/])\/>$/, "<$1>");
              return string;
            },

            /** PrivateFunction: _reqToData
             * _Private_ function to get a stanza out of a request.
             *
             * WebSockets don't use requests, so the passed argument is just returned.
             *
             *  Parameters:
             *    (Object) stanza - The stanza.
             *
             *  Returns:
             *    The stanza that was passed.
             */
            _reqToData: function _reqToData(stanza) {
              return stanza;
            },

            /** PrivateFunction: _send
             *  _Private_ part of the Connection.send function for WebSocket
             *
             * Just flushes the messages that are in the queue
             */
            _send: function _send() {
              this._conn.flush();
            },

            /** PrivateFunction: _sendRestart
             *
             *  Send an xmpp:restart stanza.
             */
            _sendRestart: function _sendRestart() {
              clearTimeout(this._conn._idleTimeout);
              this._conn._onIdle.bind(this._conn)();
            }
          };

          /**
           * A Strophe plugin for XMPP Ping
           */
          Strophe.addConnectionPlugin('ping', {
            _c: null,

            // called by the Strophe.Connection constructor
            init: function init(conn) {
              this._c = conn;
              Strophe.addNamespace('PING', "urn:xmpp:ping");
            },

            /**
             * Function: ping
             *
             * Parameters:
             * (String) to - The JIDHOST you want to ping
             * (Function) success - Callback function on success
             * (Function) error - Callback function on error
             * (Integer) timeout - Timeout in milliseconds
             */
            ping: function ping(jid, success, error, timeout) {
              var id = this._c.getUniqueId('ping');
              var iq = $iq({
                type: 'get',
                to: jid,
                id: id
              }).c('ping', {
                xmlns: Strophe.NS.PING
              });
              this._c.sendIQ(iq, success, error, timeout);
            },

            /**
             * Function: pong
             *
             * Parameters:
             * (Object) ping - The ping stanza from the server
             */
            pong: function pong(ping) {
              var from = ping.getAttribute('from');
              var id = ping.getAttribute('id');
              var iq = $iq({
                type: 'result',
                to: from,
                id: id
              });
              this._c.sendIQ(iq);
            },

            /**
             * Function: addPingHandler
             *
             * Parameters:
             * (Function) handler - Ping handler
             *
             * Returns:
             * A reference to the handler that can be used to remove it.
             */
            addPingHandler: function addPingHandler(handler) {
              return this._c.addHandler(handler, Strophe.NS.PING, "iq", "get");
            }
          });

          /* harmony default export */
          __webpack_exports__["default"] = (Strophe);

          /***/
        }),

      /***/
      499:
        /***/
        (function (module, exports, __webpack_require__) {

          function DOMParser(options) {
            this.options = options || {
              locator: {}
            };

          }
          DOMParser.prototype.parseFromString = function (source, mimeType) {
            var options = this.options;
            var sax = new XMLReader();
            var domBuilder = options.domBuilder || new DOMHandler(); //contentHandler and LexicalHandler
            var errorHandler = options.errorHandler;
            var locator = options.locator;
            var defaultNSMap = options.xmlns || {};
            var entityMap = {
              'lt': '<',
              'gt': '>',
              'amp': '&',
              'quot': '"',
              'apos': "'"
            }
            if (locator) {
              domBuilder.setDocumentLocator(locator)
            }

            sax.errorHandler = buildErrorHandler(errorHandler, domBuilder, locator);
            sax.domBuilder = options.domBuilder || domBuilder;
            if (/\/x?html?$/.test(mimeType)) {
              entityMap.nbsp = '\xa0';
              entityMap.copy = '\xa9';
              defaultNSMap[''] = 'http://www.w3.org/1999/xhtml';
            }
            defaultNSMap.xml = defaultNSMap.xml || 'http://www.w3.org/XML/1998/namespace';
            if (source) {
              sax.parse(source, defaultNSMap, entityMap);
            } else {
              sax.errorHandler.error("invalid doc source");
            }
            return domBuilder.doc;
          }

          function buildErrorHandler(errorImpl, domBuilder, locator) {
            if (!errorImpl) {
              if (domBuilder instanceof DOMHandler) {
                return domBuilder;
              }
              errorImpl = domBuilder;
            }
            var errorHandler = {}
            var isCallback = errorImpl instanceof Function;
            locator = locator || {}

            function build(key) {
              var fn = errorImpl[key];
              if (!fn && isCallback) {
                fn = errorImpl.length == 2 ? function (msg) {
                  errorImpl(key, msg)
                } : errorImpl;
              }
              errorHandler[key] = fn && function (msg) {
                fn('[xmldom ' + key + ']\t' + msg + _locator(locator));
              } || function () { };
            }
            build('warning');
            build('error');
            build('fatalError');
            return errorHandler;
          }

          //console.log('#\n\n\n\n\n\n\n####')
          /**
           * +ContentHandler+ErrorHandler
           * +LexicalHandler+EntityResolver2
           * -DeclHandler-DTDHandler
           *
           * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
           * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
           * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
           */
          function DOMHandler() {
            this.cdata = false;
          }

          function position(locator, node) {
            node.lineNumber = locator.lineNumber;
            node.columnNumber = locator.columnNumber;
          }
          /**
           * @see org.xml.sax.ContentHandler#startDocument
           * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
           */
          DOMHandler.prototype = {
            startDocument: function () {
              this.doc = new DOMImplementation().createDocument(null, null, null);
              if (this.locator) {
                this.doc.documentURI = this.locator.systemId;
              }
            },
            startElement: function (namespaceURI, localName, qName, attrs) {
              var doc = this.doc;
              var el = doc.createElementNS(namespaceURI, qName || localName);
              var len = attrs.length;
              appendElement(this, el);
              this.currentElement = el;

              this.locator && position(this.locator, el)
              for (var i = 0; i < len; i++) {
                var namespaceURI = attrs.getURI(i);
                var value = attrs.getValue(i);
                var qName = attrs.getQName(i);
                var attr = doc.createAttributeNS(namespaceURI, qName);
                this.locator && position(attrs.getLocator(i), attr);
                attr.value = attr.nodeValue = value;
                el.setAttributeNode(attr)
              }
            },
            endElement: function (namespaceURI, localName, qName) {
              var current = this.currentElement
              var tagName = current.tagName;
              this.currentElement = current.parentNode;
            },
            startPrefixMapping: function (prefix, uri) { },
            endPrefixMapping: function (prefix) { },
            processingInstruction: function (target, data) {
              var ins = this.doc.createProcessingInstruction(target, data);
              this.locator && position(this.locator, ins)
              appendElement(this, ins);
            },
            ignorableWhitespace: function (ch, start, length) { },
            characters: function (chars, start, length) {
              chars = _toString.apply(this, arguments)
              //console.log(chars)
              if (chars) {
                if (this.cdata) {
                  var charNode = this.doc.createCDATASection(chars);
                } else {
                  var charNode = this.doc.createTextNode(chars);
                }
                if (this.currentElement) {
                  this.currentElement.appendChild(charNode);
                } else if (/^\s*$/.test(chars)) {
                  this.doc.appendChild(charNode);
                  //process xml
                }
                this.locator && position(this.locator, charNode)
              }
            },
            skippedEntity: function (name) { },
            endDocument: function () {
              this.doc.normalize();
            },
            setDocumentLocator: function (locator) {
              if (this.locator = locator) { // && !('lineNumber' in locator)){
                locator.lineNumber = 0;
              }
            },
            //LexicalHandler
            comment: function (chars, start, length) {
              chars = _toString.apply(this, arguments)
              var comm = this.doc.createComment(chars);
              this.locator && position(this.locator, comm)
              appendElement(this, comm);
            },

            startCDATA: function () {
              //used in characters() methods
              this.cdata = true;
            },
            endCDATA: function () {
              this.cdata = false;
            },

            startDTD: function (name, publicId, systemId) {
              var impl = this.doc.implementation;
              if (impl && impl.createDocumentType) {
                var dt = impl.createDocumentType(name, publicId, systemId);
                this.locator && position(this.locator, dt)
                appendElement(this, dt);
              }
            },
            /**
             * @see org.xml.sax.ErrorHandler
             * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
             */
            warning: function (error) {
              console.warn('[xmldom warning]\t' + error, _locator(this.locator));
            },
            error: function (error) {
              console.error('[xmldom error]\t' + error, _locator(this.locator));
            },
            fatalError: function (error) {
              console.error('[xmldom fatalError]\t' + error, _locator(this.locator));
              throw error;
            }
          }

          function _locator(l) {
            if (l) {
              return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']'
            }
          }

          function _toString(chars, start, length) {
            if (typeof chars == 'string') {
              return chars.substr(start, length)
            } else { //java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
              if (chars.length >= start + length || start) {
                return new java.lang.String(chars, start, length) + '';
              }
              return chars;
            }
          }

          /*
           * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
           * used method of org.xml.sax.ext.LexicalHandler:
           *  #comment(chars, start, length)
           *  #startCDATA()
           *  #endCDATA()
           *  #startDTD(name, publicId, systemId)
           *
           *
           * IGNORED method of org.xml.sax.ext.LexicalHandler:
           *  #endDTD()
           *  #startEntity(name)
           *  #endEntity(name)
           *
           *
           * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
           * IGNORED method of org.xml.sax.ext.DeclHandler
           * 	#attributeDecl(eName, aName, type, mode, value)
           *  #elementDecl(name, model)
           *  #externalEntityDecl(name, publicId, systemId)
           *  #internalEntityDecl(name, value)
           * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
           * IGNORED method of org.xml.sax.EntityResolver2
           *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
           *  #resolveEntity(publicId, systemId)
           *  #getExternalSubset(name, baseURI)
           * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
           * IGNORED method of org.xml.sax.DTDHandler
           *  #notationDecl(name, publicId, systemId) {};
           *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
           */
          "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function (key) {
            DOMHandler.prototype[key] = function () {
              return null
            }
          })

          /* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
          function appendElement(hander, node) {
            if (!hander.currentElement) {
              hander.doc.appendChild(node);
            } else {
              hander.currentElement.appendChild(node);
            }
          } //appendChild and setAttributeNS are preformance key

          //if(typeof require == 'function'){
          var XMLReader = __webpack_require__(500).XMLReader;
          var DOMImplementation = exports.DOMImplementation = __webpack_require__(189).DOMImplementation;
          exports.XMLSerializer = __webpack_require__(189).XMLSerializer;
          exports.DOMParser = DOMParser;
          //}


          /***/
        }),

      /***/
      50:
        /***/
        (function (module, exports, __webpack_require__) {

          var root = __webpack_require__(31);

          /** Built-in value references. */
          var Symbol = root.Symbol;

          module.exports = Symbol;


          /***/
        }),

      /***/
      500:
        /***/
        (function (module, exports) {

          //[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
          //[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
          //[5]   	Name	   ::=   	NameStartChar (NameChar)*
          var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/ //\u10000-\uEFFFF
          var nameChar = new RegExp("[\\-\\.0-9" + nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
          var tagNamePattern = new RegExp('^' + nameStartChar.source + nameChar.source + '*(?:\:' + nameStartChar.source + nameChar.source + '*)?$');
          //var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
          //var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')

          //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
          //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
          var S_TAG = 0; //tag name offerring
          var S_ATTR = 1; //attr name offerring
          var S_ATTR_SPACE = 2; //attr name end and space offer
          var S_EQ = 3; //=space?
          var S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
          var S_ATTR_END = 5; //attr value end and no space(quot end)
          var S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
          var S_TAG_CLOSE = 7; //closed el<el />

          function XMLReader() {

          }

          XMLReader.prototype = {
            parse: function (source, defaultNSMap, entityMap) {
              var domBuilder = this.domBuilder;
              domBuilder.startDocument();
              _copy(defaultNSMap, defaultNSMap = {})
              parse(source, defaultNSMap, entityMap,
                domBuilder, this.errorHandler);
              domBuilder.endDocument();
            }
          }

          function parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
            function fixedFromCharCode(code) {
              // String.prototype.fromCharCode does not supports
              // > 2 bytes unicode chars directly
              if (code > 0xffff) {
                code -= 0x10000;
                var surrogate1 = 0xd800 + (code >> 10),
                  surrogate2 = 0xdc00 + (code & 0x3ff);

                return String.fromCharCode(surrogate1, surrogate2);
              } else {
                return String.fromCharCode(code);
              }
            }

            function entityReplacer(a) {
              var k = a.slice(1, -1);
              if (k in entityMap) {
                return entityMap[k];
              } else if (k.charAt(0) === '#') {
                return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')))
              } else {
                errorHandler.error('entity not found:' + a);
                return a;
              }
            }

            function appendText(end) { //has some bugs
              if (end > start) {
                var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
                locator && position(start);
                domBuilder.characters(xt, 0, end - start);
                start = end
              }
            }

            function position(p, m) {
              while (p >= lineEnd && (m = linePattern.exec(source))) {
                lineStart = m.index;
                lineEnd = lineStart + m[0].length;
                locator.lineNumber++;
                //console.log('line++:',locator,startPos,endPos)
              }
              locator.columnNumber = p - lineStart + 1;
            }
            var lineStart = 0;
            var lineEnd = 0;
            var linePattern = /.*(?:\r\n?|\n)|.*$/g
            var locator = domBuilder.locator;

            var parseStack = [{
              currentNSMap: defaultNSMapCopy
            }]
            var closeMap = {};
            var start = 0;
            while (true) {
              try {
                var tagStart = source.indexOf('<', start);
                if (tagStart < 0) {
                  if (!source.substr(start).match(/^\s*$/)) {
                    var doc = domBuilder.doc;
                    var text = doc.createTextNode(source.substr(start));
                    doc.appendChild(text);
                    domBuilder.currentElement = text;
                  }
                  return;
                }
                if (tagStart > start) {
                  appendText(tagStart);
                }
                switch (source.charAt(tagStart + 1)) {
                  case '/':
                    var end = source.indexOf('>', tagStart + 3);
                    var tagName = source.substring(tagStart + 2, end);
                    var config = parseStack.pop();
                    if (end < 0) {

                      tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
                      //console.error('#@@@@@@'+tagName)
                      errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
                      end = tagStart + 1 + tagName.length;
                    } else if (tagName.match(/\s</)) {
                      tagName = tagName.replace(/[\s<].*/, '');
                      errorHandler.error("end tag name: " + tagName + ' maybe not complete');
                      end = tagStart + 1 + tagName.length;
                    }
                    //console.error(parseStack.length,parseStack)
                    //console.error(config);
                    var localNSMap = config.localNSMap;
                    var endMatch = config.tagName == tagName;
                    var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase()
                    if (endIgnoreCaseMach) {
                      domBuilder.endElement(config.uri, config.localName, tagName);
                      if (localNSMap) {
                        for (var prefix in localNSMap) {
                          domBuilder.endPrefixMapping(prefix);
                        }
                      }
                      if (!endMatch) {
                        errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName);
                      }
                    } else {
                      parseStack.push(config)
                    }

                    end++;
                    break;
                  // end elment
                  case '?': // <?...?>
                    locator && position(tagStart);
                    end = parseInstruction(source, tagStart, domBuilder);
                    break;
                  case '!': // <!doctype,<![CDATA,<!--
                    locator && position(tagStart);
                    end = parseDCC(source, tagStart, domBuilder, errorHandler);
                    break;
                  default:
                    locator && position(tagStart);
                    var el = new ElementAttributes();
                    var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
                    //elStartEnd
                    var end = parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
                    var len = el.length;


                    if (!el.closed && fixSelfClosed(source, end, el.tagName, closeMap)) {
                      el.closed = true;
                      if (!entityMap.nbsp) {
                        errorHandler.warning('unclosed xml attribute');
                      }
                    }
                    if (locator && len) {
                      var locator2 = copyLocator(locator, {});
                      //try{//attribute position fixed
                      for (var i = 0; i < len; i++) {
                        var a = el[i];
                        position(a.offset);
                        a.locator = copyLocator(locator, {});
                      }
                      //}catch(e){console.error('@@@@@'+e)}
                      domBuilder.locator = locator2
                      if (appendElement(el, domBuilder, currentNSMap)) {
                        parseStack.push(el)
                      }
                      domBuilder.locator = locator;
                    } else {
                      if (appendElement(el, domBuilder, currentNSMap)) {
                        parseStack.push(el)
                      }
                    }



                    if (el.uri === 'http://www.w3.org/1999/xhtml' && !el.closed) {
                      end = parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder)
                    } else {
                      end++;
                    }
                }
              } catch (e) {
                errorHandler.error('element parse error: ' + e)
                //errorHandler.error('element parse error: '+e);
                end = -1;
                //throw e;
              }
              if (end > start) {
                start = end;
              } else {
                //TODO: 这里有可能sax回退，有位置错误风险
                appendText(Math.max(tagStart, start) + 1);
              }
            }
          }

          function copyLocator(f, t) {
            t.lineNumber = f.lineNumber;
            t.columnNumber = f.columnNumber;
            return t;
          }

          /**
           * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
           * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
           */
          function parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
            var attrName;
            var value;
            var p = ++start;
            var s = S_TAG; //status
            while (true) {
              var c = source.charAt(p);
              switch (c) {
                case '=':
                  if (s === S_ATTR) { //attrName
                    attrName = source.slice(start, p);
                    s = S_EQ;
                  } else if (s === S_ATTR_SPACE) {
                    s = S_EQ;
                  } else {
                    //fatalError: equal must after attrName or space after attrName
                    throw new Error('attribute equal must after attrName');
                  }
                  break;
                case '\'':
                case '"':
                  if (s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
                  ) { //equal
                    if (s === S_ATTR) {
                      errorHandler.warning('attribute value must after "="')
                      attrName = source.slice(start, p)
                    }
                    start = p + 1;
                    p = source.indexOf(c, start)
                    if (p > 0) {
                      value = source.slice(start, p).replace(/&#?\w+;/g, entityReplacer);
                      el.add(attrName, value, start - 1);
                      s = S_ATTR_END;
                    } else {
                      //fatalError: no end quot match
                      throw new Error('attribute value no end \'' + c + '\' match');
                    }
                  } else if (s == S_ATTR_NOQUOT_VALUE) {
                    value = source.slice(start, p).replace(/&#?\w+;/g, entityReplacer);
                    //console.log(attrName,value,start,p)
                    el.add(attrName, value, start);
                    //console.dir(el)
                    errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
                    start = p + 1;
                    s = S_ATTR_END
                  } else {
                    //fatalError: no equal before
                    throw new Error('attribute value must after "="');
                  }
                  break;
                case '/':
                  switch (s) {
                    case S_TAG:
                      el.setTagName(source.slice(start, p));
                    case S_ATTR_END:
                    case S_TAG_SPACE:
                    case S_TAG_CLOSE:
                      s = S_TAG_CLOSE;
                      el.closed = true;
                    case S_ATTR_NOQUOT_VALUE:
                    case S_ATTR:
                    case S_ATTR_SPACE:
                      break;
                    //case S_EQ:
                    default:
                      throw new Error("attribute invalid close char('/')")
                  }
                  break;
                case '': //end document
                  //throw new Error('unexpected end of input')
                  errorHandler.error('unexpected end of input');
                  if (s == S_TAG) {
                    el.setTagName(source.slice(start, p));
                  }
                  return p;
                case '>':
                  switch (s) {
                    case S_TAG:
                      el.setTagName(source.slice(start, p));
                    case S_ATTR_END:
                    case S_TAG_SPACE:
                    case S_TAG_CLOSE:
                      break; //normal
                    case S_ATTR_NOQUOT_VALUE: //Compatible state
                    case S_ATTR:
                      value = source.slice(start, p);
                      if (value.slice(-1) === '/') {
                        el.closed = true;
                        value = value.slice(0, -1)
                      }
                    case S_ATTR_SPACE:
                      if (s === S_ATTR_SPACE) {
                        value = attrName;
                      }
                      if (s == S_ATTR_NOQUOT_VALUE) {
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        el.add(attrName, value.replace(/&#?\w+;/g, entityReplacer), start)
                      } else {
                        if (currentNSMap[''] !== 'http://www.w3.org/1999/xhtml' || !value.match(/^(?:disabled|checked|selected)$/i)) {
                          errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!')
                        }
                        el.add(value, value, start)
                      }
                      break;
                    case S_EQ:
                      throw new Error('attribute value missed!!');
                  }
                  //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
                  return p;
                /*xml space '\x20' | #x9 | #xD | #xA; */
                case '\u0080':
                  c = ' ';
                default:
                  if (c <= ' ') { //space
                    switch (s) {
                      case S_TAG:
                        el.setTagName(source.slice(start, p)); //tagName
                        s = S_TAG_SPACE;
                        break;
                      case S_ATTR:
                        attrName = source.slice(start, p)
                        s = S_ATTR_SPACE;
                        break;
                      case S_ATTR_NOQUOT_VALUE:
                        var value = source.slice(start, p).replace(/&#?\w+;/g, entityReplacer);
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        el.add(attrName, value, start)
                      case S_ATTR_END:
                        s = S_TAG_SPACE;
                        break;
                      //case S_TAG_SPACE:
                      //case S_EQ:
                      //case S_ATTR_SPACE:
                      //	void();break;
                      //case S_TAG_CLOSE:
                      //ignore warning
                    }
                  } else { //not space
                    //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
                    //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
                    switch (s) {
                      //case S_TAG:void();break;
                      //case S_ATTR:void();break;
                      //case S_ATTR_NOQUOT_VALUE:void();break;
                      case S_ATTR_SPACE:
                        var tagName = el.tagName;
                        if (currentNSMap[''] !== 'http://www.w3.org/1999/xhtml' || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
                          errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!')
                        }
                        el.add(attrName, attrName, start);
                        start = p;
                        s = S_ATTR;
                        break;
                      case S_ATTR_END:
                        errorHandler.warning('attribute space is required"' + attrName + '"!!')
                      case S_TAG_SPACE:
                        s = S_ATTR;
                        start = p;
                        break;
                      case S_EQ:
                        s = S_ATTR_NOQUOT_VALUE;
                        start = p;
                        break;
                      case S_TAG_CLOSE:
                        throw new Error("elements closed character '/' and '>' must be connected to");
                    }
                  }
              } //end outer switch
              //console.log('p++',p)
              p++;
            }
          }
          /**
           * @return true if has new namespace define
           */
          function appendElement(el, domBuilder, currentNSMap) {
            var tagName = el.tagName;
            var localNSMap = null;
            //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
            var i = el.length;
            while (i--) {
              var a = el[i];
              var qName = a.qName;
              var value = a.value;
              var nsp = qName.indexOf(':');
              if (nsp > 0) {
                var prefix = a.prefix = qName.slice(0, nsp);
                var localName = qName.slice(nsp + 1);
                var nsPrefix = prefix === 'xmlns' && localName
              } else {
                localName = qName;
                prefix = null
                nsPrefix = qName === 'xmlns' && ''
              }
              //can not set prefix,because prefix !== ''
              a.localName = localName;
              //prefix == null for no ns prefix attribute
              if (nsPrefix !== false) { //hack!!
                if (localNSMap == null) {
                  localNSMap = {}
                  //console.log(currentNSMap,0)
                  _copy(currentNSMap, currentNSMap = {})
                  //console.log(currentNSMap,1)
                }
                currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
                a.uri = 'http://www.w3.org/2000/xmlns/'
                domBuilder.startPrefixMapping(nsPrefix, value)
              }
            }
            var i = el.length;
            while (i--) {
              a = el[i];
              var prefix = a.prefix;
              if (prefix) { //no prefix attribute has no namespace
                if (prefix === 'xml') {
                  a.uri = 'http://www.w3.org/XML/1998/namespace';
                }
                if (prefix !== 'xmlns') {
                  a.uri = currentNSMap[prefix || '']

                  //{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
                }
              }
            }
            var nsp = tagName.indexOf(':');
            if (nsp > 0) {
              prefix = el.prefix = tagName.slice(0, nsp);
              localName = el.localName = tagName.slice(nsp + 1);
            } else {
              prefix = null; //important!!
              localName = el.localName = tagName;
            }
            //no prefix element has default namespace
            var ns = el.uri = currentNSMap[prefix || ''];
            domBuilder.startElement(ns, localName, tagName, el);
            //endPrefixMapping and startPrefixMapping have not any help for dom builder
            //localNSMap = null
            if (el.closed) {
              domBuilder.endElement(ns, localName, tagName);
              if (localNSMap) {
                for (prefix in localNSMap) {
                  domBuilder.endPrefixMapping(prefix)
                }
              }
            } else {
              el.currentNSMap = currentNSMap;
              el.localNSMap = localNSMap;
              //parseStack.push(el);
              return true;
            }
          }

          function parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
            if (/^(?:script|textarea)$/i.test(tagName)) {
              var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
              var text = source.substring(elStartEnd + 1, elEndStart);
              if (/[&<]/.test(text)) {
                if (/^script$/i.test(tagName)) {
                  //if(!/\]\]>/.test(text)){
                  //lexHandler.startCDATA();
                  domBuilder.characters(text, 0, text.length);
                  //lexHandler.endCDATA();
                  return elEndStart;
                  //}
                } //}else{//text area
                text = text.replace(/&#?\w+;/g, entityReplacer);
                domBuilder.characters(text, 0, text.length);
                return elEndStart;
                //}

              }
            }
            return elStartEnd + 1;
          }

          function fixSelfClosed(source, elStartEnd, tagName, closeMap) {
            //if(tagName in closeMap){
            var pos = closeMap[tagName];
            if (pos == null) {
              //console.log(tagName)
              pos = source.lastIndexOf('</' + tagName + '>')
              if (pos < elStartEnd) { //忘记闭合
                pos = source.lastIndexOf('</' + tagName)
              }
              closeMap[tagName] = pos
            }
            return pos < elStartEnd;
            //}
          }

          function _copy(source, target) {
            for (var n in source) {
              target[n] = source[n]
            }
          }

          function parseDCC(source, start, domBuilder, errorHandler) { //sure start with '<!'
            var next = source.charAt(start + 2)
            switch (next) {
              case '-':
                if (source.charAt(start + 3) === '-') {
                  var end = source.indexOf('-->', start + 4);
                  //append comment source.substring(4,end)//<!--
                  if (end > start) {
                    domBuilder.comment(source, start + 4, end - start - 4);
                    return end + 3;
                  } else {
                    errorHandler.error("Unclosed comment");
                    return -1;
                  }
                } else {
                  //error
                  return -1;
                }
              default:
                if (source.substr(start + 3, 6) == 'CDATA[') {
                  var end = source.indexOf(']]>', start + 9);
                  domBuilder.startCDATA();
                  domBuilder.characters(source, start + 9, end - start - 9);
                  domBuilder.endCDATA()
                  return end + 3;
                }
                //<!DOCTYPE
                //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
                var matchs = split(source, start);
                var len = matchs.length;
                if (len > 1 && /!doctype/i.test(matchs[0][0])) {
                  var name = matchs[1][0];
                  var pubid = len > 3 && /^public$/i.test(matchs[2][0]) && matchs[3][0]
                  var sysid = len > 4 && matchs[4][0];
                  var lastMatch = matchs[len - 1]
                  domBuilder.startDTD(name, pubid && pubid.replace(/^(['"])(.*?)\1$/, '$2'),
                    sysid && sysid.replace(/^(['"])(.*?)\1$/, '$2'));
                  domBuilder.endDTD();

                  return lastMatch.index + lastMatch[0].length
                }
            }
            return -1;
          }



          function parseInstruction(source, start, domBuilder) {
            var end = source.indexOf('?>', start);
            if (end) {
              var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
              if (match) {
                var len = match[0].length;
                domBuilder.processingInstruction(match[1], match[2]);
                return end + 2;
              } else { //error
                return -1;
              }
            }
            return -1;
          }

          /**
           * @param source
           */
          function ElementAttributes(source) {

          }
          ElementAttributes.prototype = {
            setTagName: function (tagName) {
              if (!tagNamePattern.test(tagName)) {
                throw new Error('invalid tagName:' + tagName)
              }
              this.tagName = tagName
            },
            add: function (qName, value, offset) {
              if (!tagNamePattern.test(qName)) {
                throw new Error('invalid attribute:' + qName)
              }
              this[this.length++] = {
                qName: qName,
                value: value,
                offset: offset
              }
            },
            length: 0,
            getLocalName: function (i) {
              return this[i].localName
            },
            getLocator: function (i) {
              return this[i].locator
            },
            getQName: function (i) {
              return this[i].qName
            },
            getURI: function (i) {
              return this[i].uri
            },
            getValue: function (i) {
              return this[i].value
            }
            //	,getIndex:function(uri, localName)){
            //		if(localName){
            //
            //		}else{
            //			var qName = uri
            //		}
            //	},
            //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
            //	getType:function(uri,localName){}
            //	getType:function(i){},
          }




          function _set_proto_(thiz, parent) {
            thiz.__proto__ = parent;
            return thiz;
          }
          if (!(_set_proto_({}, _set_proto_.prototype) instanceof _set_proto_)) {
            _set_proto_ = function (thiz, parent) {
              function p() { };
              p.prototype = parent;
              p = new p();
              for (parent in thiz) {
                p[parent] = thiz[parent];
              }
              return p;
            }
          }

          function split(source, start) {
            var match;
            var buf = [];
            var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
            reg.lastIndex = start;
            reg.exec(source); //skip <
            while (match = reg.exec(source)) {
              buf.push(match);
              if (match[1]) return buf;
            }
          }

          exports.XMLReader = XMLReader;



          /***/
        }),

      /***/
      501:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          var IMEventBus_1 = __webpack_require__(1);
          var IRobotMessage_1 = __webpack_require__(7);
          var IMEventMap_1 = __webpack_require__(2);
          // 消息分类处理
          var WXMessageClassfy = /** @class */ (function () {
            function WXMessageClassfy() { }
            // 设置主医生id 只处理主医生相关信息
            WXMessageClassfy.prototype.setDid = function (did) {
              this.did = did;
            };
            WXMessageClassfy.prototype.getDid = function () {
              return this.did;
            };
            // 设置档案人id 私人医生只处理主医生和档案人一致的相关信息
            WXMessageClassfy.prototype.setPid = function (pid) {
              this.pid = pid;
            };
            WXMessageClassfy.prototype.getPid = function () {
              return this.pid;
            };
            WXMessageClassfy.prototype.processMessage = function (msg) {

              if (msg.msgBody === 'messageack') {
                // 更新消息发送状态为已成功
                IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.SEND_MESSGE_ACK, msg.sid);
                return;
              }
              var subType = msg.data.subType;
              // 人机切换医生消息 前端不感知
              if (subType === 19001) {
                return;
              }
              // 人机协议
              if (subType === 2000) {
                // this.processRobotDoctorProto(msg);
                this.triggerRefreshContext(false);
                return;
                // 机器人协议
              } else if (subType === 71000 || subType === 72002 || subType === 73000) {
                this.processRobotProto(msg);
                return;
              }
              // 医生引导结束
              if (subType === 10002) {
                this.triggerRefreshContext(false);
              } else if (IMEventMap_1.EVENTS_MAP[subType]) {
                // 交互控制消息(除去人机消息 机器人消息 渲染型控制消息)
                IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.OPTION_CONTROL_MSG, IMEventMap_1.EVENTS_MAP[subType], msg.data);
              } else if(subType === 10000){
                IMEventBus_1.default.trigger("input_emitter", false);
                IMEventBus_1.default.trigger("robot_emitter", true, msg.data);
                this.triggerMsgRender(msg);
              } else {
                this.triggerMsgRender(msg);
              }
            };
            /**
             * 机器人协议处理
             */
            WXMessageClassfy.prototype.processRobotProto = function (msg) {
              var robotMsg = IRobotMessage_1.default.format(JSON.parse(msg.data.content));
              var robotData = robotMsg.content;
              // 刷新上下文
              if (robotMsg.protocolType === IRobotMessage_1.RobotProtocalTypes.CONTROL_NODE) {
                this.triggerRefreshContext(false);
              } else {
                // 渲染消息
                this.triggerMsgRender(msg);
              }
            };
            /**
             * 人机消息处理
             */
            WXMessageClassfy.prototype.processRobotDoctorProto = function (msg) {
              var data = msg.data,
                messagecontent = JSON.parse(data.content),
                controlContent = JSON.parse(messagecontent.content);
              var bizData;
              switch (controlContent.controlCode) {
                case IRobotMessage_1.RobotDoctorConstants.RobotDoctorSwitchRobot:
                  // 切换到机
                  this.triggerRefreshContext(false);
                  break;
                // 切换到人 或者 指定刷新
                case IRobotMessage_1.RobotDoctorConstants.RobotDoctorSwitchDoctor:
                case IRobotMessage_1.RobotDoctorConstants.RobotDoctorRefreshContext:
                  // RobotDoctorConstants.RobotDoctorConsultFinish:
                  this.triggerRefreshContext();
                  break;
                case IRobotMessage_1.RobotDoctorConstants.RobotDoctorOffline:
                  // 医生已下班
                  break;
                case IRobotMessage_1.RobotDoctorConstants.RobotDoctorQueueRefresh:
                  // 队列人数变化
                  bizData = JSON.parse(controlContent.bizData);
                  IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.REFRESH_QUEUE, bizData);
                  break;
                case IRobotMessage_1.RobotDoctorConstants.RobotDoctorConsultCancel:
                  // 咨询单取消  和10025消息重复
                  // refreshImContext(3);
                  break;
                case IRobotMessage_1.RobotDoctorConstants.RobotDoctorConsultExist:
                  this.triggerMsgRender(msg);
                  break;

                case IRobotMessage_1.RobotDoctorConstants.RobotDoctorDialogEvent:
                  bizData = JSON.parse(controlContent.bizData);
                  if (bizData && bizData.eventType == 36) {
                    this.triggerRefreshContext(false);
                  } else {
                    // 私人医生会话场景
                    this.triggerRefreshContext();
                  }
                  break;
                case IRobotMessage_1.RobotDoctorConstants.RobotDoctorInboxMsg:
                  this.triggerUnreadInboxMsg();
                  break;
                case IRobotMessage_1.RobotDoctorConstants.RobotDoctorConsultFinish:
                  // 咨询单完成
                  this.triggerRefreshContext();
                  break;
                default:
                  break;
              }
            };
            /**
             * 触发刷新上下文
             * @param needIgnoreCurrentNode
             */
            WXMessageClassfy.prototype.triggerRefreshContext = function (needIgnoreCurrentNode) {
              if (needIgnoreCurrentNode === void 0) {
                needIgnoreCurrentNode = true;
              }
              IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.REFRESH_CONTEXT, needIgnoreCurrentNode);
            };
            /**
             * 触发消息渲染
             * @param msg
             */
            WXMessageClassfy.prototype.triggerMsgRender = function (msg) {
              IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.RENDER_MSG, msg);
            };

            /**
             * 触发获取消息箱未读消息
             */
            WXMessageClassfy.prototype.triggerUnreadInboxMsg = function () {
              IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.LOAD_UNREAD_INBOX_MSG);
            }
            return WXMessageClassfy;
          }());
          exports.default = WXMessageClassfy;


          /***/
        }),

      /***/
      51:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";


          exports.__esModule = true;

          var _iterator = __webpack_require__(109);

          var _iterator2 = _interopRequireDefault(_iterator);

          var _symbol = __webpack_require__(120);

          var _symbol2 = _interopRequireDefault(_symbol);

          var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
            return typeof obj;
          } : function (obj) {
            return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
          };

          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }

          exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
            return typeof obj === "undefined" ? "undefined" : _typeof(obj);
          } : function (obj) {
            return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
          };

          /***/
        }),

      /***/
      52:
        /***/
        (function (module, exports) {

          module.exports = true;


          /***/
        }),

      /***/
      53:
        /***/
        (function (module, exports, __webpack_require__) {

          var def = __webpack_require__(12).f;
          var has = __webpack_require__(13);
          var TAG = __webpack_require__(10)('toStringTag');

          module.exports = function (it, tag, stat) {
            if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
              configurable: true,
              value: tag
            });
          };


          /***/
        }),

      /***/
      54:
        /***/
        (function (module, exports, __webpack_require__) {

          exports.f = __webpack_require__(10);


          /***/
        }),

      /***/
      55:
        /***/
        (function (module, exports, __webpack_require__) {

          var global = __webpack_require__(9);
          var core = __webpack_require__(17);
          var LIBRARY = __webpack_require__(52);
          var wksExt = __webpack_require__(54);
          var defineProperty = __webpack_require__(12).f;
          module.exports = function (name) {
            var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
            if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
              value: wksExt.f(name)
            });
          };


          /***/
        }),

      /***/
      56:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          var IMEventBus_1 = __webpack_require__(1);
          var IMEventMap_1 = __webpack_require__(2);
          var RUNNERSTATUS;
          (function (RUNNERSTATUS) {
            RUNNERSTATUS[RUNNERSTATUS["STOP"] = 0] = "STOP";
            RUNNERSTATUS[RUNNERSTATUS["RUN"] = 1] = "RUN";
          })(RUNNERSTATUS || (RUNNERSTATUS = {}));
          exports.START_TASK_RUNNER = 'START_TASK_RUNNER';
          var Task = /** @class */ (function () {
            function Task(taskId, data) {
              this._taskId = taskId;
              this._data = data;
            }
            Object.defineProperty(Task.prototype, "taskId", {
              get: function () {
                return this._taskId;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(Task.prototype, "data", {
              get: function () {
                return this._data;
              },
              enumerable: true,
              configurable: true
            });
            return Task;
          }());
          exports.Task = Task;
          /**
           * 动画任务序列
           */
          var AnimationRunner = /** @class */ (function () {
            function AnimationRunner() {
              this._taskList = [];
              this._renderMap = {};
              this._statu = RUNNERSTATUS.STOP;
            }
            AnimationRunner.getInstance = function () {
              if (!AnimationRunner.instance) {
                AnimationRunner.instance = new AnimationRunner();
                // 启动任务
                AnimationRunner.instance.StartTaskRunnerListener();
              }
              return AnimationRunner.instance;
            };
            /**
             * 执行任务
             */
            AnimationRunner.prototype.excuteTaskList = function () {
              var _this = this;
              var taskList = this._taskList;
              if (taskList.length > 0) {
                var task = taskList.shift(),
                  data = task.data;
                this._lastTask = task;
                if (this._lastTask && this._lastTask.data.content.answerBody) {
                  //  缓存答案节点(消息乱序到达的时候需要考虑到)
                  this._taskWithAnswer = task;
                }
                IMEventBus_1.default.trigger(task.taskId, task);
                setTimeout(function () {
                  _this.excuteTaskList();
                }, data.header.delayTime || 0);
              } else {
                // 停止状态机
                this._statu = RUNNERSTATUS.STOP;
                // 如果最后是个答案节点或乱序情况下中间节点包含答案节点 则触发展示
                var robotDataWithAnswer_1 = null;
                if (this._lastTask && this._lastTask.data.content.answerBody) {
                  robotDataWithAnswer_1 = this._lastTask.data;
                } else if (this._taskWithAnswer) {
                  robotDataWithAnswer_1 = this._taskWithAnswer.data;
                }
                if (robotDataWithAnswer_1) {
                  var element = document && document.activeElement;
                  var hasActiveElement_1 = element ? true : false;
                  if (hasActiveElement_1) {
                    document.documentElement.style.height = '100%';
                  }
                  element && element.blur();
                  setTimeout(function () {
                    if (hasActiveElement_1) {
                      IMEventBus_1.default.trigger(IMEventMap_1.APP_EVENTS.REFRESH_SCROLLER);
                    }
                    _this._taskWithAnswer = null;
                    IMEventBus_1.default.trigger('emit_panel_msg', 'robot_emitter', true, robotDataWithAnswer_1);
                  }, 300);
                }
              }
            };
            /**
             * 添加任务
             * @param task
             */
            AnimationRunner.prototype.addTask = function (task) {
              if (!this._renderMap.hasOwnProperty(task.taskId)) {
                this._renderMap[task.taskId] = 1;
                this._taskList.push(task);
              }
            };
            /**
             * 销毁实例对象
             */
            AnimationRunner.prototype.destoryInstance = function () {
              AnimationRunner.instance = null;
            };
            /**
             * 移除任务
             * @param task
             */
            AnimationRunner.prototype.removeTask = function (task) { };
            /**
             * 启动runner
             */
            AnimationRunner.prototype.StartTaskRunnerListener = function () {
              var _this = this;
              IMEventBus_1.default.addListener(exports.START_TASK_RUNNER, function () {
                if (_this._statu !== RUNNERSTATUS.RUN) {
                  _this._statu = RUNNERSTATUS.RUN;
                  _this.excuteTaskList();
                }
              });
            };
            AnimationRunner.Task = Task;
            return AnimationRunner;
          }());
          exports.default = AnimationRunner;


          /***/
        }),

      /***/
      60:
        /***/
        (function (module, exports) {

          var toString = {}.toString;

          module.exports = function (it) {
            return toString.call(it).slice(8, -1);
          };


          /***/
        }),

      /***/
      61:
        /***/
        (function (module, exports) {

          exports.f = Object.getOwnPropertySymbols;


          /***/
        }),

      /***/
      62:
        /***/
        (function (module, exports) {

          /**
           * Checks if `value` is object-like. A value is object-like if it's not `null`
           * and has a `typeof` result of "object".
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
           * @example
           *
           * _.isObjectLike({});
           * // => true
           *
           * _.isObjectLike([1, 2, 3]);
           * // => true
           *
           * _.isObjectLike(_.noop);
           * // => false
           *
           * _.isObjectLike(null);
           * // => false
           */
          function isObjectLike(value) {
            return value != null && typeof value == 'object';
          }

          module.exports = isObjectLike;


          /***/
        }),

      /***/
      63:
        /***/
        (function (module, exports, __webpack_require__) {

          // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
          var anObject = __webpack_require__(27);
          var dPs = __webpack_require__(113);
          var enumBugKeys = __webpack_require__(48);
          var IE_PROTO = __webpack_require__(46)('IE_PROTO');
          var Empty = function () {
            /* empty */
          };
          var PROTOTYPE = 'prototype';

          // Create object with fake `null` prototype: use iframe Object with cleared prototype
          var createDict = function () {
            // Thrash, waste and sodomy: IE GC bug
            var iframe = __webpack_require__(71)('iframe');
            var i = enumBugKeys.length;
            var lt = '<';
            var gt = '>';
            var iframeDocument;
            iframe.style.display = 'none';
            __webpack_require__(114).appendChild(iframe);
            iframe.src = 'javascript:'; // eslint-disable-line no-script-url
            // createDict = iframe.contentWindow.Object;
            // html.removeChild(iframe);
            iframeDocument = iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
            iframeDocument.close();
            createDict = iframeDocument.F;
            while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
            return createDict();
          };

          module.exports = Object.create || function create(O, Properties) {
            var result;
            if (O !== null) {
              Empty[PROTOTYPE] = anObject(O);
              result = new Empty();
              Empty[PROTOTYPE] = null;
              // add "__proto__" for Object.getPrototypeOf polyfill
              result[IE_PROTO] = O;
            } else result = createDict();
            return Properties === undefined ? result : dPs(result, Properties);
          };


          /***/
        }),

      /***/
      69:
        /***/
        (function (module, exports, __webpack_require__) {

          // optional / simple context binding
          var aFunction = __webpack_require__(102);
          module.exports = function (fn, that, length) {
            aFunction(fn);
            if (that === undefined) return fn;
            switch (length) {
              case 1:
                return function (a) {
                  return fn.call(that, a);
                };
              case 2:
                return function (a, b) {
                  return fn.call(that, a, b);
                };
              case 3:
                return function (a, b, c) {
                  return fn.call(that, a, b, c);
                };
            }
            return function ( /* ...args */) {
              return fn.apply(that, arguments);
            };
          };


          /***/
        }),

      /***/
      7:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          /*
           * @Author: lisanjie212@jk.cn
           * @Date: 2017-07-12 09:36:58
           * @Last Modified by: lisanjie
           * @Last Modified time: 2019-04-24 12:49:21
           */
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          /*人机控制常量信息 */
          exports.RobotDoctorConstants = {
            /** 人机互切 **/
            RobotDoctorProtocolControl: 10,
            RobotDoctorProtocolTip: 11,
            RobotDoctorProtocolCard: 12,
            /** 人机互切子控制类型 **/
            RobotDoctorSwitchRobot: 'TO_ROBOT',
            RobotDoctorSwitchDoctor: 'TO_DOCTOR',
            RobotDoctorRefreshContext: 'REFRESH',
            RobotDoctorOffline: 'DOCTOR_OFFLINE',
            RobotDoctorQueueRefresh: 'QUEUE_CHANGED',
            RobotDoctorConsultFinish: 'FINISH',
            RobotDoctorConsultExist: 'CONSULT_EXIST',
            RobotDoctorTimeChanged: 'DELAYTIME',
            RobotDoctorConsultCancel: 'CANCEL',
            RobotDoctorDialogEvent: 'DIALOG_EVENT', // 私人医生会话消息
            RobotDoctorInboxMsg: 'INBOX_MSG_UPDATED' // 消息盒子未读消息
          };
          /**
           * 机器人协议类型
           */
          var RobotProtocalTypes;
          (function (RobotProtocalTypes) {
            // 错误节点
            RobotProtocalTypes[RobotProtocalTypes["ERROR_NODE"] = -1] = "ERROR_NODE";
            // 问题节点
            RobotProtocalTypes[RobotProtocalTypes["QUESTION_NODE"] = 0] = "QUESTION_NODE";
            // 动画节点
            RobotProtocalTypes[RobotProtocalTypes["ANIMATE_NODE"] = 2] = "ANIMATE_NODE";
            // 卡片类型
            RobotProtocalTypes[RobotProtocalTypes["CARD_NODE"] = 5] = "CARD_NODE";
            // 控制节点
            RobotProtocalTypes[RobotProtocalTypes["CONTROL_NODE"] = 6] = "CONTROL_NODE";
            // 客户端回复节点
            RobotProtocalTypes[RobotProtocalTypes["RESPONSE_NODE"] = 7] = "RESPONSE_NODE";
            // 通用信息素
            RobotProtocalTypes[RobotProtocalTypes["INFO_NODE"] = 8] = "INFO_NODE";
            // 特殊视图节点(如 压顶，夺宝) h5端暂不处理
            RobotProtocalTypes[RobotProtocalTypes["SPECIFIC_VIEW_NODE"] = 9] = "SPECIFIC_VIEW_NODE";
            // 功能节点
            RobotProtocalTypes[RobotProtocalTypes["FUNCTION_NODE"] = 20] = "FUNCTION_NODE";
            // 可操作信息素节点
            RobotProtocalTypes[RobotProtocalTypes["OPTION_INFO_NODE"] = 21] = "OPTION_INFO_NODE";
          })(RobotProtocalTypes = exports.RobotProtocalTypes || (exports.RobotProtocalTypes = {}));
          /**
           * 答案展示类型
           */
          var SHOWTYPES;
          (function (SHOWTYPES) {
            SHOWTYPES[SHOWTYPES["OPTION"] = 0] = "OPTION";
            SHOWTYPES[SHOWTYPES["INPUT"] = 1] = "INPUT";
            SHOWTYPES[SHOWTYPES["WHEEL"] = 2] = "WHEEL"; // 滚轮
          })(SHOWTYPES = exports.SHOWTYPES || (exports.SHOWTYPES = {}));
          /**
           * 答案数值类型
           */
          var DATATYPES;
          (function (DATATYPES) {
            DATATYPES[DATATYPES["TEXT"] = 1] = "TEXT";
            DATATYPES[DATATYPES["NUMBER"] = 2] = "NUMBER";
            DATATYPES[DATATYPES["DATE"] = 3] = "DATE"; // 日期
          })(DATATYPES = exports.DATATYPES || (exports.DATATYPES = {}));
          var TAGTYPES;
          (function (TAGTYPES) {
            // 不清楚
            TAGTYPES["Unknown"] = "Unknown";
            // 以上都无
            TAGTYPES["None"] = "None";
            // 其它
            TAGTYPES["Others"] = "Others";
          })(TAGTYPES = exports.TAGTYPES || (exports.TAGTYPES = {}));
          // 选项类型
          var OPTIONTYPE;
          (function (OPTIONTYPE) {
            OPTIONTYPE[OPTIONTYPE["TEXT"] = 0] = "TEXT";
            OPTIONTYPE[OPTIONTYPE["IMAGE"] = 1] = "IMAGE";
          })(OPTIONTYPE = exports.OPTIONTYPE || (exports.OPTIONTYPE = {}));
          // 问题布局类型
          var LAYOUTTYPE;
          (function (LAYOUTTYPE) {
            LAYOUTTYPE[LAYOUTTYPE["TEXT"] = 0] = "TEXT";
            LAYOUTTYPE[LAYOUTTYPE["IMAGE"] = 1] = "IMAGE";
            LAYOUTTYPE[LAYOUTTYPE["VIDEO"] = 2] = "VIDEO";
            LAYOUTTYPE[LAYOUTTYPE["AUDIO"] = 3] = "AUDIO";
            LAYOUTTYPE[LAYOUTTYPE["VALUATION"] = 4] = "VALUATION"; // 评价
          })(LAYOUTTYPE = exports.LAYOUTTYPE || (exports.LAYOUTTYPE = {}));
          /**
           * 机器人消息
           */
          var IRobotMessage = /** @class */ (function () {
            function IRobotMessage() {
              // 子元素未解包的原始数据
              this.orignData = {};
            }
            IRobotMessage.format = function (outside) {
              var inside = new IRobotMessage();
              IRobotMessage.PropertyNames.forEach(function (propName) {
                if (!outside.hasOwnProperty(propName)) {
                  return;
                }
                inside.orignData[propName] = outside[propName];
                (propName === 'content' || propName === 'header') && typeof outside[propName] === 'string' ?
                  inside[propName] = JSON.parse(outside[propName]) :
                  inside[propName] = outside[propName];
              });
              return inside;
            };
            IRobotMessage.formatAsObject = function (outside) {
              var inside = {
                orignData: {}
              };
              IRobotMessage.PropertyNames.forEach(function (propName) {
                if (!outside.hasOwnProperty(propName)) {
                  return;
                }
                inside.orignData[propName] = outside[propName];
                (propName === 'content' || propName === 'header') && typeof outside[propName] === 'string' ?
                  inside[propName] = JSON.parse(outside[propName]) :
                  inside[propName] = outside[propName];
              });
              return inside;
            };
            Object.defineProperty(IRobotMessage.prototype, "consultantId", {
              get: function () {
                return this._consultantId;
              },
              set: function (value) {
                this._consultantId = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IRobotMessage.prototype, "content", {
              get: function () {
                return this._content;
              },
              set: function (value) {
                this._content = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IRobotMessage.prototype, "header", {
              get: function () {
                return this._header;
              },
              set: function (value) {
                this._header = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IRobotMessage.prototype, "protocolType", {
              get: function () {
                return this._protocolType;
              },
              set: function (value) {
                this._protocolType = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IRobotMessage.prototype, "userId", {
              get: function () {
                return this._userId;
              },
              set: function (value) {
                this._userId = value;
              },
              enumerable: true,
              configurable: true
            });
            IRobotMessage.PropertyNames = [
              'consultantId',
              'content',
              'header',
              'protocolType',
              'userId',
              'aiContent'
            ];
            return IRobotMessage;
          }());
          exports.default = IRobotMessage;


          /***/
        }),

      /***/
      70:
        /***/
        (function (module, exports, __webpack_require__) {

          module.exports = !__webpack_require__(15) && !__webpack_require__(29)(function () {
            return Object.defineProperty(__webpack_require__(71)('div'), 'a', {
              get: function () {
                return 7;
              }
            }).a != 7;
          });


          /***/
        }),

      /***/
      71:
        /***/
        (function (module, exports, __webpack_require__) {

          var isObject = __webpack_require__(21);
          var document = __webpack_require__(9).document;
          // typeof document.createElement is 'object' in old IE
          var is = isObject(document) && isObject(document.createElement);
          module.exports = function (it) {
            return is ? document.createElement(it) : {};
          };


          /***/
        }),

      /***/
      72:
        /***/
        (function (module, exports, __webpack_require__) {

          var has = __webpack_require__(13);
          var toIObject = __webpack_require__(19);
          var arrayIndexOf = __webpack_require__(104)(false);
          var IE_PROTO = __webpack_require__(46)('IE_PROTO');

          module.exports = function (object, names) {
            var O = toIObject(object);
            var i = 0;
            var result = [];
            var key;
            for (key in O)
              if (key != IE_PROTO) has(O, key) && result.push(key);
            // Don't enum bug & hidden keys
            while (names.length > i)
              if (has(O, key = names[i++])) {
                ~arrayIndexOf(result, key) || result.push(key);
              }
            return result;
          };


          /***/
        }),

      /***/
      73:
        /***/
        (function (module, exports, __webpack_require__) {

          // 7.1.13 ToObject(argument)
          var defined = __webpack_require__(44);
          module.exports = function (it) {
            return Object(defined(it));
          };


          /***/
        }),

      /***/
      76:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          var LIBRARY = __webpack_require__(52);
          var $export = __webpack_require__(28);
          var redefine = __webpack_require__(77);
          var hide = __webpack_require__(18);
          var has = __webpack_require__(13);
          var Iterators = __webpack_require__(38);
          var $iterCreate = __webpack_require__(112);
          var setToStringTag = __webpack_require__(53);
          var getPrototypeOf = __webpack_require__(115);
          var ITERATOR = __webpack_require__(10)('iterator');
          var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
          var FF_ITERATOR = '@@iterator';
          var KEYS = 'keys';
          var VALUES = 'values';

          var returnThis = function () {
            return this;
          };

          module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
            $iterCreate(Constructor, NAME, next);
            var getMethod = function (kind) {
              if (!BUGGY && kind in proto) return proto[kind];
              switch (kind) {
                case KEYS:
                  return function keys() {
                    return new Constructor(this, kind);
                  };
                case VALUES:
                  return function values() {
                    return new Constructor(this, kind);
                  };
              }
              return function entries() {
                return new Constructor(this, kind);
              };
            };
            var TAG = NAME + ' Iterator';
            var DEF_VALUES = DEFAULT == VALUES;
            var VALUES_BUG = false;
            var proto = Base.prototype;
            var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
            var $default = (!BUGGY && $native) || getMethod(DEFAULT);
            var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
            var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
            var methods, key, IteratorPrototype;
            // Fix native
            if ($anyNative) {
              IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
              if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
                // Set @@toStringTag to native iterators
                setToStringTag(IteratorPrototype, TAG, true);
                // fix for some old engines
                if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
              }
            }
            // fix Array#{values, @@iterator}.name in V8 / FF
            if (DEF_VALUES && $native && $native.name !== VALUES) {
              VALUES_BUG = true;
              $default = function values() {
                return $native.call(this);
              };
            }
            // Define iterator
            if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
              hide(proto, ITERATOR, $default);
            }
            // Plug for library
            Iterators[NAME] = $default;
            Iterators[TAG] = returnThis;
            if (DEFAULT) {
              methods = {
                values: DEF_VALUES ? $default : getMethod(VALUES),
                keys: IS_SET ? $default : getMethod(KEYS),
                entries: $entries
              };
              if (FORCED)
                for (key in methods) {
                  if (!(key in proto)) redefine(proto, key, methods[key]);
                } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
            }
            return methods;
          };


          /***/
        }),

      /***/
      77:
        /***/
        (function (module, exports, __webpack_require__) {

          module.exports = __webpack_require__(18);


          /***/
        }),

      /***/
      78:
        /***/
        (function (module, exports, __webpack_require__) {

          // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
          var $keys = __webpack_require__(72);
          var hiddenKeys = __webpack_require__(48).concat('length', 'prototype');

          exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
            return $keys(O, hiddenKeys);
          };


          /***/
        }),

      /***/
      83:
        /***/
        (function (module, exports, __webpack_require__) {

          // fallback for non-array-like ES3 and non-enumerable old V8 strings
          var cof = __webpack_require__(60);
          // eslint-disable-next-line no-prototype-builtins
          module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
            return cof(it) == 'String' ? it.split('') : Object(it);
          };


          /***/
        }),

      /***/
      84:
        /***/
        (function (module, exports, __webpack_require__) {

          // 7.1.15 ToLength
          var toInteger = __webpack_require__(45);
          var min = Math.min;
          module.exports = function (it) {
            return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
          };


          /***/
        }),

      /***/
      85:
        /***/
        (function (module, exports, __webpack_require__) {

          /* WEBPACK VAR INJECTION */
          (function (global) {
            /** Detect free variable `global` from Node.js. */
            var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

            module.exports = freeGlobal;

            /* WEBPACK VAR INJECTION */
          }.call(exports, __webpack_require__(41)))

          /***/
        }),

      /***/
      86:
        /***/
        (function (module, exports) {

          /**
           * Checks if `value` is classified as an `Array` object.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an array, else `false`.
           * @example
           *
           * _.isArray([1, 2, 3]);
           * // => true
           *
           * _.isArray(document.body.children);
           * // => false
           *
           * _.isArray('abc');
           * // => false
           *
           * _.isArray(_.noop);
           * // => false
           */
          var isArray = Array.isArray;

          module.exports = isArray;


          /***/
        }),

      /***/
      87:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          var $at = __webpack_require__(111)(true);

          // 21.1.3.27 String.prototype[@@iterator]()
          __webpack_require__(76)(String, 'String', function (iterated) {
            this._t = String(iterated); // target
            this._i = 0; // next index
            // 21.1.5.2.1 %StringIteratorPrototype%.next()
          }, function () {
            var O = this._t;
            var index = this._i;
            var point;
            if (index >= O.length) return {
              value: undefined,
              done: true
            };
            point = $at(O, index);
            this._i += point.length;
            return {
              value: point,
              done: false
            };
          });


          /***/
        }),

      /***/
      88:
        /***/
        (function (module, exports, __webpack_require__) {

          var pIE = __webpack_require__(40);
          var createDesc = __webpack_require__(30);
          var toIObject = __webpack_require__(19);
          var toPrimitive = __webpack_require__(43);
          var has = __webpack_require__(13);
          var IE8_DOM_DEFINE = __webpack_require__(70);
          var gOPD = Object.getOwnPropertyDescriptor;

          exports.f = __webpack_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P) {
            O = toIObject(O);
            P = toPrimitive(P, true);
            if (IE8_DOM_DEFINE) try {
              return gOPD(O, P);
            } catch (e) {
              /* empty */
            }
            if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
          };


          /***/
        }),

      /***/
      9:
        /***/
        (function (module, exports) {

          // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
          var global = module.exports = typeof window != 'undefined' && window.Math == Math ?
            window : typeof self != 'undefined' && self.Math == Math ? self
              // eslint-disable-next-line no-new-func
              :
              Function('return this')();
          if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


          /***/
        }),

      /***/
      95:
        /***/
        (function (module, exports, __webpack_require__) {

          "use strict";

          /**
           * Created by evan on 2017/5/2.
           */
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          /**
           * 消息主体
           */
          var IMData = /** @class */ (function () {
            function IMData() { }
            IMData.format = function (outside) {
              var inside = new IMData();
              IMData.PropertyNames.forEach(function (propName) {
                if (propName === 'feature' && outside[propName]) {
                  outside[propName] = SystemUtil.json_parse(outside[propName]);
                }
                outside[propName] && (inside[propName] = outside[propName]);
              });
              return inside;
            };
            Object.defineProperty(IMData.prototype, "type", {
              get: function () {
                return this._type;
              },
              set: function (value) {
                this._type = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "subType", {
              get: function () {
                return this._subType;
              },
              set: function (value) {
                this._subType = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "fromId", {
              get: function () {
                return this._fromId;
              },
              set: function (value) {
                this._fromId = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "toId", {
              get: function () {
                return this._toId;
              },
              set: function (value) {
                this._toId = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "did", {
              get: function () {
                return this._did;
              },
              set: function (value) {
                this._did = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "content", {
              get: function () {
                return this._content;
              },
              set: function (value) {
                this._content = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "ac", {
              get: function () {
                return this._ac;
              },
              set: function (value) {
                this._ac = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "feature", {
              get: function () {
                return this._feature;
              },
              set: function (value) {
                this._feature = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "created", {
              get: function () {
                return this._created;
              },
              set: function (value) {
                this._created = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "flag", {
              get: function () {
                return this._flag;
              },
              set: function (value) {
                this._flag = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "id", {
              get: function () {
                return this._id;
              },
              set: function (value) {
                this._id = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMData.prototype, "sid", {
              get: function () {
                return this._sid;
              },
              set: function (value) {
                this._sid = value;
              },
              enumerable: true,
              configurable: true
            });
            // 序列号imdata对象
            IMData.prototype.serialize = function () {
              return {
                'type': this.type,
                'subType': this.subType,
                'fromId': this.fromId,
                'toId': this.toId,
                'did': this.did,
                'content': this.content,
                'ac': this.ac,
                'feature': this.feature,
                'created': this.created,
                'id': this.id,
                'flag': this.flag,
                'sid': this.sid
              };
            };
            IMData.PropertyNames = [
              'type',
              'subType',
              'fromId',
              'toId',
              'did',
              'content',
              'ac',
              'feature',
              'created',
              'id',
              'flag',
              'sid'
            ];
            return IMData;
          }());
          exports.IMData = IMData;
          /**
           * 消息结构
           */
          var IMessage = /** @class */ (function () {
            function IMessage() {
              this._sent = false;
              this._index = 0;
            }
            IMessage.format = function (props, data) {
              if (!props || !data) {
                throw new Error('Can\'t find \'props\' and \'data\'');
              }
              var inside = new IMessage();
              IMessage.PropertyInNames.forEach(function (propName) {
                props[propName] && (inside[propName] = props[propName]);
              });
              var imData = IMData.format(data);
              imData.id = props.mid; 
              inside.data = imData;
              return inside;
            };
            Object.defineProperty(IMessage.prototype, "sid", {
              get: function () {
                return this._sid;
              },
              set: function (value) {
                this._sid = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMessage.prototype, "msgBody", {
              get: function () {
                return this._msgBody;
              },
              set: function (value) {
                this._msgBody = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMessage.prototype, "mid", {
              get: function () {
                return this._mid;
              },
              set: function (value) {
                this._mid = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMessage.prototype, "data", {
              get: function () {
                return this._data;
              },
              set: function (value) {
                this._data = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMessage.prototype, "created", {
              get: function () {
                return this._created;
              },
              set: function (value) {
                this._created = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMessage.prototype, "sent", {
              get: function () {
                return this._sent;
              },
              set: function (value) {
                this._sent = value;
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(IMessage.prototype, "index", {
              get: function () {
                return this._index;
              },
              set: function (value) {
                this._index = value;
              },
              enumerable: true,
              configurable: true
            });
            IMessage.PropertyInNames = [
              'sid',
              'mid',
              'created',
              'msgBody'
            ];
            IMessage.PropertyOutNames = [
              'sid',
              'msgType'
            ];
            return IMessage;
          }());
          exports.default = IMessage;


          /***/
        })

      /******/
    });
//# sourceMappingURL=weapp.service.js.map